import { jsx as c, Fragment as Fe, jsxs as Y } from "react/jsx-runtime";
import * as l from "react";
import X, { useState as hd, useLayoutEffect as vd, useMemo as bd, useContext as wd, createContext as xd, forwardRef as ya, createElement as gn } from "react";
import * as bo from "react-dom";
import yd from "react-dom";
function Ca(e) {
  var t, o, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (o = Ca(e[t])) && (n && (n += " "), n += o);
  } else for (o in e) e[o] && (n && (n += " "), n += o);
  return n;
}
function Sa() {
  for (var e, t, o = 0, n = "", r = arguments.length; o < r; o++) (e = arguments[o]) && (t = Ca(e)) && (n && (n += " "), n += t);
  return n;
}
const Cd = (e, t) => {
  const o = new Array(e.length + t.length);
  for (let n = 0; n < e.length; n++)
    o[n] = e[n];
  for (let n = 0; n < t.length; n++)
    o[e.length + n] = t[n];
  return o;
}, Sd = (e, t) => ({
  classGroupId: e,
  validator: t
}), Ea = (e = /* @__PURE__ */ new Map(), t = null, o) => ({
  nextPart: e,
  validators: t,
  classGroupId: o
}), no = "-", Ir = [], Ed = "arbitrary..", Rd = (e) => {
  const t = Ad(e), {
    conflictingClassGroups: o,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (i) => {
      if (i.startsWith("[") && i.endsWith("]"))
        return Pd(i);
      const s = i.split(no), d = s[0] === "" && s.length > 1 ? 1 : 0;
      return Ra(s, d, t);
    },
    getConflictingClassGroupIds: (i, s) => {
      if (s) {
        const d = n[i], u = o[i];
        return d ? u ? Cd(u, d) : d : u || Ir;
      }
      return o[i] || Ir;
    }
  };
}, Ra = (e, t, o) => {
  if (e.length - t === 0)
    return o.classGroupId;
  const r = e[t], a = o.nextPart.get(r);
  if (a) {
    const u = Ra(e, t + 1, a);
    if (u) return u;
  }
  const i = o.validators;
  if (i === null)
    return;
  const s = t === 0 ? e.join(no) : e.slice(t).join(no), d = i.length;
  for (let u = 0; u < d; u++) {
    const f = i[u];
    if (f.validator(s))
      return f.classGroupId;
  }
}, Pd = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const t = e.slice(1, -1), o = t.indexOf(":"), n = t.slice(0, o);
  return n ? Ed + n : void 0;
})(), Ad = (e) => {
  const {
    theme: t,
    classGroups: o
  } = e;
  return _d(o, t);
}, _d = (e, t) => {
  const o = Ea();
  for (const n in e) {
    const r = e[n];
    On(r, o, n, t);
  }
  return o;
}, On = (e, t, o, n) => {
  const r = e.length;
  for (let a = 0; a < r; a++) {
    const i = e[a];
    Td(i, t, o, n);
  }
}, Td = (e, t, o, n) => {
  if (typeof e == "string") {
    Nd(e, t, o);
    return;
  }
  if (typeof e == "function") {
    kd(e, t, o, n);
    return;
  }
  Id(e, t, o, n);
}, Nd = (e, t, o) => {
  const n = e === "" ? t : Pa(t, e);
  n.classGroupId = o;
}, kd = (e, t, o, n) => {
  if (Md(e)) {
    On(e(n), t, o, n);
    return;
  }
  t.validators === null && (t.validators = []), t.validators.push(Sd(o, e));
}, Id = (e, t, o, n) => {
  const r = Object.entries(e), a = r.length;
  for (let i = 0; i < a; i++) {
    const [s, d] = r[i];
    On(d, Pa(t, s), o, n);
  }
}, Pa = (e, t) => {
  let o = e;
  const n = t.split(no), r = n.length;
  for (let a = 0; a < r; a++) {
    const i = n[a];
    let s = o.nextPart.get(i);
    s || (s = Ea(), o.nextPart.set(i, s)), o = s;
  }
  return o;
}, Md = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, Dd = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, o = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null);
  const r = (a, i) => {
    o[a] = i, t++, t > e && (t = 0, n = o, o = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(a) {
      let i = o[a];
      if (i !== void 0)
        return i;
      if ((i = n[a]) !== void 0)
        return r(a, i), i;
    },
    set(a, i) {
      a in o ? o[a] = i : r(a, i);
    }
  };
}, hn = "!", Mr = ":", Od = [], Dr = (e, t, o, n, r) => ({
  modifiers: e,
  hasImportantModifier: t,
  baseClassName: o,
  maybePostfixModifierPosition: n,
  isExternal: r
}), Ld = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: o
  } = e;
  let n = (r) => {
    const a = [];
    let i = 0, s = 0, d = 0, u;
    const f = r.length;
    for (let g = 0; g < f; g++) {
      const v = r[g];
      if (i === 0 && s === 0) {
        if (v === Mr) {
          a.push(r.slice(d, g)), d = g + 1;
          continue;
        }
        if (v === "/") {
          u = g;
          continue;
        }
      }
      v === "[" ? i++ : v === "]" ? i-- : v === "(" ? s++ : v === ")" && s--;
    }
    const p = a.length === 0 ? r : r.slice(d);
    let m = p, h = !1;
    p.endsWith(hn) ? (m = p.slice(0, -1), h = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      p.startsWith(hn) && (m = p.slice(1), h = !0)
    );
    const b = u && u > d ? u - d : void 0;
    return Dr(a, h, m, b);
  };
  if (t) {
    const r = t + Mr, a = n;
    n = (i) => i.startsWith(r) ? a(i.slice(r.length)) : Dr(Od, !1, i, void 0, !0);
  }
  if (o) {
    const r = n;
    n = (a) => o({
      className: a,
      parseClassName: r
    });
  }
  return n;
}, zd = (e) => {
  const t = /* @__PURE__ */ new Map();
  return e.orderSensitiveModifiers.forEach((o, n) => {
    t.set(o, 1e6 + n);
  }), (o) => {
    const n = [];
    let r = [];
    for (let a = 0; a < o.length; a++) {
      const i = o[a], s = i[0] === "[", d = t.has(i);
      s || d ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(i)) : r.push(i);
    }
    return r.length > 0 && (r.sort(), n.push(...r)), n;
  };
}, $d = (e) => ({
  cache: Dd(e.cacheSize),
  parseClassName: Ld(e),
  sortModifiers: zd(e),
  ...Rd(e)
}), Fd = /\s+/, Bd = (e, t) => {
  const {
    parseClassName: o,
    getClassGroupId: n,
    getConflictingClassGroupIds: r,
    sortModifiers: a
  } = t, i = [], s = e.trim().split(Fd);
  let d = "";
  for (let u = s.length - 1; u >= 0; u -= 1) {
    const f = s[u], {
      isExternal: p,
      modifiers: m,
      hasImportantModifier: h,
      baseClassName: b,
      maybePostfixModifierPosition: g
    } = o(f);
    if (p) {
      d = f + (d.length > 0 ? " " + d : d);
      continue;
    }
    let v = !!g, w = n(v ? b.substring(0, g) : b);
    if (!w) {
      if (!v) {
        d = f + (d.length > 0 ? " " + d : d);
        continue;
      }
      if (w = n(b), !w) {
        d = f + (d.length > 0 ? " " + d : d);
        continue;
      }
      v = !1;
    }
    const x = m.length === 0 ? "" : m.length === 1 ? m[0] : a(m).join(":"), y = h ? x + hn : x, C = y + w;
    if (i.indexOf(C) > -1)
      continue;
    i.push(C);
    const R = r(w, v);
    for (let A = 0; A < R.length; ++A) {
      const P = R[A];
      i.push(y + P);
    }
    d = f + (d.length > 0 ? " " + d : d);
  }
  return d;
}, Vd = (...e) => {
  let t = 0, o, n, r = "";
  for (; t < e.length; )
    (o = e[t++]) && (n = Aa(o)) && (r && (r += " "), r += n);
  return r;
}, Aa = (e) => {
  if (typeof e == "string")
    return e;
  let t, o = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = Aa(e[n])) && (o && (o += " "), o += t);
  return o;
}, Gd = (e, ...t) => {
  let o, n, r, a;
  const i = (d) => {
    const u = t.reduce((f, p) => p(f), e());
    return o = $d(u), n = o.cache.get, r = o.cache.set, a = s, s(d);
  }, s = (d) => {
    const u = n(d);
    if (u)
      return u;
    const f = Bd(d, o);
    return r(d, f), f;
  };
  return a = i, (...d) => a(Vd(...d));
}, Wd = [], ne = (e) => {
  const t = (o) => o[e] || Wd;
  return t.isThemeGetter = !0, t;
}, _a = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Ta = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Hd = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, Ud = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Kd = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, jd = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Yd = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Xd = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Oe = (e) => Hd.test(e), U = (e) => !!e && !Number.isNaN(Number(e)), Le = (e) => !!e && Number.isInteger(Number(e)), Jo = (e) => e.endsWith("%") && U(e.slice(0, -1)), Ne = (e) => Ud.test(e), Na = () => !0, qd = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Kd.test(e) && !jd.test(e)
), Ln = () => !1, Zd = (e) => Yd.test(e), Qd = (e) => Xd.test(e), Jd = (e) => !D(e) && !L(e), eu = (e) => We(e, Ma, Ln), D = (e) => _a.test(e), qe = (e) => We(e, Da, qd), Or = (e) => We(e, lu, U), tu = (e) => We(e, La, Na), ou = (e) => We(e, Oa, Ln), Lr = (e) => We(e, ka, Ln), nu = (e) => We(e, Ia, Qd), Ut = (e) => We(e, za, Zd), L = (e) => Ta.test(e), Rt = (e) => ot(e, Da), ru = (e) => ot(e, Oa), zr = (e) => ot(e, ka), au = (e) => ot(e, Ma), iu = (e) => ot(e, Ia), Kt = (e) => ot(e, za, !0), su = (e) => ot(e, La, !0), We = (e, t, o) => {
  const n = _a.exec(e);
  return n ? n[1] ? t(n[1]) : o(n[2]) : !1;
}, ot = (e, t, o = !1) => {
  const n = Ta.exec(e);
  return n ? n[1] ? t(n[1]) : o : !1;
}, ka = (e) => e === "position" || e === "percentage", Ia = (e) => e === "image" || e === "url", Ma = (e) => e === "length" || e === "size" || e === "bg-size", Da = (e) => e === "length", lu = (e) => e === "number", Oa = (e) => e === "family-name", La = (e) => e === "number" || e === "weight", za = (e) => e === "shadow", cu = () => {
  const e = ne("color"), t = ne("font"), o = ne("text"), n = ne("font-weight"), r = ne("tracking"), a = ne("leading"), i = ne("breakpoint"), s = ne("container"), d = ne("spacing"), u = ne("radius"), f = ne("shadow"), p = ne("inset-shadow"), m = ne("text-shadow"), h = ne("drop-shadow"), b = ne("blur"), g = ne("perspective"), v = ne("aspect"), w = ne("ease"), x = ne("animate"), y = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], C = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], R = () => [...C(), L, D], A = () => ["auto", "hidden", "clip", "visible", "scroll"], P = () => ["auto", "contain", "none"], S = () => [L, D, d], N = () => [Oe, "full", "auto", ...S()], $ = () => [Le, "none", "subgrid", L, D], F = () => ["auto", {
    span: ["full", Le, L, D]
  }, Le, L, D], V = () => [Le, "auto", L, D], H = () => ["auto", "min", "max", "fr", L, D], W = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], K = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], z = () => ["auto", ...S()], G = () => [Oe, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...S()], O = () => [Oe, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...S()], T = () => [Oe, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...S()], k = () => [e, L, D], ie = () => [...C(), zr, Lr, {
    position: [L, D]
  }], pe = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], he = () => ["auto", "cover", "contain", au, eu, {
    size: [L, D]
  }], ce = () => [Jo, Rt, qe], ee = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    u,
    L,
    D
  ], q = () => ["", U, Rt, qe], M = () => ["solid", "dashed", "dotted", "double"], Q = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], j = () => [U, Jo, zr, Lr], J = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    b,
    L,
    D
  ], Z = () => ["none", U, L, D], te = () => ["none", U, L, D], de = () => [U, L, D], ve = () => [Oe, "full", ...S()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [Ne],
      breakpoint: [Ne],
      color: [Na],
      container: [Ne],
      "drop-shadow": [Ne],
      ease: ["in", "out", "in-out"],
      font: [Jd],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [Ne],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [Ne],
      shadow: [Ne],
      spacing: ["px", U],
      text: [Ne],
      "text-shadow": [Ne],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", Oe, D, L, v]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [U, D, L, s]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": y()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": y()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: R()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: A()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": A()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": A()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: P()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": P()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": P()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: N()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": N()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": N()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": N(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: N()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": N(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: N()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": N()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": N()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: N()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: N()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: N()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: N()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Le, "auto", L, D]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [Oe, "full", "auto", s, ...S()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [U, Oe, "auto", "initial", "none", D]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", U, L, D]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", U, L, D]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Le, "first", "last", "none", L, D]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": $()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: F()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": V()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": V()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": $()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: F()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": V()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": V()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": H()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": H()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: S()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": S()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": S()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...W(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...K(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...K()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...W()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...K(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...K(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": W()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...K(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...K()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: S()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: S()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: S()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: S()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: S()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: S()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: S()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: S()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: S()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: S()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: S()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: z()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: z()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: z()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: z()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: z()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: z()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: z()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: z()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: z()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: z()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: z()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": S()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": S()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: G()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */
      "inline-size": [{
        inline: ["auto", ...O()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...O()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-inline-size": [{
        "max-inline": ["none", ...O()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */
      "block-size": [{
        block: ["auto", ...T()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-block-size": [{
        "min-block": ["auto", ...T()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-block-size": [{
        "max-block": ["none", ...T()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [s, "screen", ...G()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          s,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...G()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          s,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [i]
          },
          ...G()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...G()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...G()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...G()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", o, Rt, qe]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [n, su, tu]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Jo, D]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [ru, ou, t]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [D]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [r, L, D]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [U, "none", L, Or]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          a,
          ...S()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", L, D]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", L, D]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: k()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: k()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...M(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [U, "from-font", "auto", L, qe]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: k()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [U, "auto", L, D]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: S()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", L, D]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", L, D]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: ie()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: pe()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: he()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Le, L, D],
          radial: ["", L, D],
          conic: [Le, L, D]
        }, iu, nu]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: k()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: ce()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: ce()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: ce()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: k()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: k()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: k()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: ee()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": ee()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": ee()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": ee()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": ee()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": ee()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": ee()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": ee()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": ee()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": ee()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": ee()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": ee()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": ee()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": ee()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": ee()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: q()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": q()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": q()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": q()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": q()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": q()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": q()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": q()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": q()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": q()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": q()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": q()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": q()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...M(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...M(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: k()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": k()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": k()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": k()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": k()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": k()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": k()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": k()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": k()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": k()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": k()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: k()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...M(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [U, L, D]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", U, Rt, qe]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: k()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          f,
          Kt,
          Ut
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: k()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", p, Kt, Ut]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": k()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: q()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: k()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [U, qe]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": k()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": q()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": k()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", m, Kt, Ut]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": k()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [U, L, D]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Q(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Q()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [U]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": j()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": j()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": k()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": k()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": j()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": j()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": k()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": k()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": j()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": j()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": k()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": k()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": j()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": j()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": k()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": k()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": j()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": j()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": k()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": k()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": j()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": j()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": k()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": k()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": j()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": j()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": k()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": k()
      }],
      "mask-image-radial": [{
        "mask-radial": [L, D]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": j()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": j()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": k()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": k()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": C()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [U]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": j()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": j()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": k()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": k()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: ie()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: pe()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: he()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", L, D]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          L,
          D
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: J()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [U, L, D]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [U, L, D]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          h,
          Kt,
          Ut
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": k()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", U, L, D]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [U, L, D]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", U, L, D]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [U, L, D]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", U, L, D]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          L,
          D
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": J()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [U, L, D]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [U, L, D]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", U, L, D]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [U, L, D]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", U, L, D]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [U, L, D]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [U, L, D]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", U, L, D]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": S()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": S()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": S()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", L, D]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [U, "initial", L, D]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", w, L, D]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [U, L, D]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", x, L, D]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [g, L, D]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": R()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: Z()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": Z()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": Z()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": Z()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: te()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": te()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": te()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": te()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: de()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": de()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": de()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [L, D, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: R()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: ve()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": ve()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": ve()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": ve()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: k()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: k()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", L, D]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": S()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": S()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": S()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": S()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": S()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": S()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": S()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": S()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": S()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": S()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": S()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": S()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": S()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": S()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": S()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": S()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": S()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": S()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": S()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": S()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": S()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": S()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", L, D]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...k()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [U, Rt, qe, Or]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...k()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, du = /* @__PURE__ */ Gd(cu);
function E(...e) {
  return du(Sa(e));
}
const $r = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Fr = Sa, bt = (e, t) => (o) => {
  var n;
  if (t?.variants == null) return Fr(e, o?.class, o?.className);
  const { variants: r, defaultVariants: a } = t, i = Object.keys(r).map((u) => {
    const f = o?.[u], p = a?.[u];
    if (f === null) return null;
    const m = $r(f) || $r(p);
    return r[u][m];
  }), s = o && Object.entries(o).reduce((u, f) => {
    let [p, m] = f;
    return m === void 0 || (u[p] = m), u;
  }, {}), d = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((u, f) => {
    let { class: p, className: m, ...h } = f;
    return Object.entries(h).every((b) => {
      let [g, v] = b;
      return Array.isArray(v) ? v.includes({
        ...a,
        ...s
      }[g]) : {
        ...a,
        ...s
      }[g] === v;
    }) ? [
      ...u,
      p,
      m
    ] : u;
  }, []);
  return Fr(e, i, d, o?.class, o?.className);
};
function Br(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function wo(...e) {
  return (t) => {
    let o = !1;
    const n = e.map((r) => {
      const a = Br(r, t);
      return !o && typeof a == "function" && (o = !0), a;
    });
    if (o)
      return () => {
        for (let r = 0; r < n.length; r++) {
          const a = n[r];
          typeof a == "function" ? a() : Br(e[r], null);
        }
      };
  };
}
function B(...e) {
  return l.useCallback(wo(...e), e);
}
// @__NO_SIDE_EFFECTS__
function Be(e) {
  const t = /* @__PURE__ */ uu(e), o = l.forwardRef((n, r) => {
    const { children: a, ...i } = n, s = l.Children.toArray(a), d = s.find(fu);
    if (d) {
      const u = d.props.children, f = s.map((p) => p === d ? l.Children.count(u) > 1 ? l.Children.only(null) : l.isValidElement(u) ? u.props.children : null : p);
      return /* @__PURE__ */ c(t, { ...i, ref: r, children: l.isValidElement(u) ? l.cloneElement(u, void 0, f) : null });
    }
    return /* @__PURE__ */ c(t, { ...i, ref: r, children: a });
  });
  return o.displayName = `${e}.Slot`, o;
}
var $a = /* @__PURE__ */ Be("Slot");
// @__NO_SIDE_EFFECTS__
function uu(e) {
  const t = l.forwardRef((o, n) => {
    const { children: r, ...a } = o;
    if (l.isValidElement(r)) {
      const i = mu(r), s = pu(a, r.props);
      return r.type !== l.Fragment && (s.ref = n ? wo(n, i) : i), l.cloneElement(r, s);
    }
    return l.Children.count(r) > 1 ? l.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Fa = /* @__PURE__ */ Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Ba(e) {
  const t = ({ children: o }) => /* @__PURE__ */ c(Fe, { children: o });
  return t.displayName = `${e}.Slottable`, t.__radixId = Fa, t;
}
function fu(e) {
  return l.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Fa;
}
function pu(e, t) {
  const o = { ...t };
  for (const n in t) {
    const r = e[n], a = t[n];
    /^on[A-Z]/.test(n) ? r && a ? o[n] = (...s) => {
      const d = a(...s);
      return r(...s), d;
    } : r && (o[n] = r) : n === "style" ? o[n] = { ...r, ...a } : n === "className" && (o[n] = [r, a].filter(Boolean).join(" "));
  }
  return { ...e, ...o };
}
function mu(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning;
  return o ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
var gu = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], I = gu.reduce((e, t) => {
  const o = /* @__PURE__ */ Be(`Primitive.${t}`), n = l.forwardRef((r, a) => {
    const { asChild: i, ...s } = r, d = i ? o : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(d, { ...s, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Va(e, t) {
  e && bo.flushSync(() => e.dispatchEvent(t));
}
var Ga = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), hu = "VisuallyHidden", Wa = l.forwardRef(
  (e, t) => /* @__PURE__ */ c(
    I.span,
    {
      ...e,
      ref: t,
      style: { ...Ga, ...e.style }
    }
  )
);
Wa.displayName = hu;
var vu = Wa;
function bu(e, t) {
  const o = l.createContext(t), n = (a) => {
    const { children: i, ...s } = a, d = l.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ c(o.Provider, { value: d, children: i });
  };
  n.displayName = e + "Provider";
  function r(a) {
    const i = l.useContext(o);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [n, r];
}
function ae(e, t = []) {
  let o = [];
  function n(a, i) {
    const s = l.createContext(i), d = o.length;
    o = [...o, i];
    const u = (p) => {
      const { scope: m, children: h, ...b } = p, g = m?.[e]?.[d] || s, v = l.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ c(g.Provider, { value: v, children: h });
    };
    u.displayName = a + "Provider";
    function f(p, m) {
      const h = m?.[e]?.[d] || s, b = l.useContext(h);
      if (b) return b;
      if (i !== void 0) return i;
      throw new Error(`\`${p}\` must be used within \`${a}\``);
    }
    return [u, f];
  }
  const r = () => {
    const a = o.map((i) => l.createContext(i));
    return function(s) {
      const d = s?.[e] || a;
      return l.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: d } }),
        [s, d]
      );
    };
  };
  return r.scopeName = e, [n, wu(r, ...t)];
}
function wu(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const o = () => {
    const n = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const i = n.reduce((s, { useScope: d, scopeName: u }) => {
        const p = d(a)[`__scope${u}`];
        return { ...s, ...p };
      }, {});
      return l.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return o.scopeName = t.scopeName, o;
}
function Mt(e) {
  const t = e + "CollectionProvider", [o, n] = ae(t), [r, a] = o(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (g) => {
    const { scope: v, children: w } = g, x = X.useRef(null), y = X.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ c(r, { scope: v, itemMap: y, collectionRef: x, children: w });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", d = /* @__PURE__ */ Be(s), u = X.forwardRef(
    (g, v) => {
      const { scope: w, children: x } = g, y = a(s, w), C = B(v, y.collectionRef);
      return /* @__PURE__ */ c(d, { ref: C, children: x });
    }
  );
  u.displayName = s;
  const f = e + "CollectionItemSlot", p = "data-radix-collection-item", m = /* @__PURE__ */ Be(f), h = X.forwardRef(
    (g, v) => {
      const { scope: w, children: x, ...y } = g, C = X.useRef(null), R = B(v, C), A = a(f, w);
      return X.useEffect(() => (A.itemMap.set(C, { ref: C, ...y }), () => {
        A.itemMap.delete(C);
      })), /* @__PURE__ */ c(m, { [p]: "", ref: R, children: x });
    }
  );
  h.displayName = f;
  function b(g) {
    const v = a(e + "CollectionConsumer", g);
    return X.useCallback(() => {
      const x = v.collectionRef.current;
      if (!x) return [];
      const y = Array.from(x.querySelectorAll(`[${p}]`));
      return Array.from(v.itemMap.values()).sort(
        (A, P) => y.indexOf(A.ref.current) - y.indexOf(P.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: i, Slot: u, ItemSlot: h },
    b,
    n
  ];
}
function _(e, t, { checkForDefaultPrevented: o = !0 } = {}) {
  return function(r) {
    if (e?.(r), o === !1 || !r.defaultPrevented)
      return t?.(r);
  };
}
var oe = globalThis?.document ? l.useLayoutEffect : () => {
}, xu = l[" useInsertionEffect ".trim().toString()] || oe;
function le({
  prop: e,
  defaultProp: t,
  onChange: o = () => {
  },
  caller: n
}) {
  const [r, a, i] = yu({
    defaultProp: t,
    onChange: o
  }), s = e !== void 0, d = s ? e : r;
  {
    const f = l.useRef(e !== void 0);
    l.useEffect(() => {
      const p = f.current;
      p !== s && console.warn(
        `${n} is changing from ${p ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), f.current = s;
    }, [s, n]);
  }
  const u = l.useCallback(
    (f) => {
      if (s) {
        const p = Cu(f) ? f(e) : f;
        p !== e && i.current?.(p);
      } else
        a(f);
    },
    [s, e, a, i]
  );
  return [d, u];
}
function yu({
  defaultProp: e,
  onChange: t
}) {
  const [o, n] = l.useState(e), r = l.useRef(o), a = l.useRef(t);
  return xu(() => {
    a.current = t;
  }, [t]), l.useEffect(() => {
    r.current !== o && (a.current?.(o), r.current = o);
  }, [o, r]), [o, n, a];
}
function Cu(e) {
  return typeof e == "function";
}
function Su(e, t) {
  return l.useReducer((o, n) => t[o][n] ?? o, e);
}
var se = (e) => {
  const { present: t, children: o } = e, n = Eu(t), r = typeof o == "function" ? o({ present: n.isPresent }) : l.Children.only(o), a = B(n.ref, Ru(r));
  return typeof o == "function" || n.isPresent ? l.cloneElement(r, { ref: a }) : null;
};
se.displayName = "Presence";
function Eu(e) {
  const [t, o] = l.useState(), n = l.useRef(null), r = l.useRef(e), a = l.useRef("none"), i = e ? "mounted" : "unmounted", [s, d] = Su(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return l.useEffect(() => {
    const u = jt(n.current);
    a.current = s === "mounted" ? u : "none";
  }, [s]), oe(() => {
    const u = n.current, f = r.current;
    if (f !== e) {
      const m = a.current, h = jt(u);
      e ? d("MOUNT") : h === "none" || u?.display === "none" ? d("UNMOUNT") : d(f && m !== h ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, d]), oe(() => {
    if (t) {
      let u;
      const f = t.ownerDocument.defaultView ?? window, p = (h) => {
        const g = jt(n.current).includes(CSS.escape(h.animationName));
        if (h.target === t && g && (d("ANIMATION_END"), !r.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, m = (h) => {
        h.target === t && (a.current = jt(n.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", p), t.addEventListener("animationend", p), () => {
        f.clearTimeout(u), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", p), t.removeEventListener("animationend", p);
      };
    } else
      d("ANIMATION_END");
  }, [t, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: l.useCallback((u) => {
      n.current = u ? getComputedStyle(u) : null, o(u);
    }, [])
  };
}
function jt(e) {
  return e?.animationName || "none";
}
function Ru(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning;
  return o ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
var Pu = l[" useId ".trim().toString()] || (() => {
}), Au = 0;
function fe(e) {
  const [t, o] = l.useState(Pu());
  return oe(() => {
    o((n) => n ?? String(Au++));
  }, [e]), t ? `radix-${t}` : "";
}
var xo = "Collapsible", [_u, Ha] = ae(xo), [Tu, zn] = _u(xo), Ua = l.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: o,
      open: n,
      defaultOpen: r,
      disabled: a,
      onOpenChange: i,
      ...s
    } = e, [d, u] = le({
      prop: n,
      defaultProp: r ?? !1,
      onChange: i,
      caller: xo
    });
    return /* @__PURE__ */ c(
      Tu,
      {
        scope: o,
        disabled: a,
        contentId: fe(),
        open: d,
        onOpenToggle: l.useCallback(() => u((f) => !f), [u]),
        children: /* @__PURE__ */ c(
          I.div,
          {
            "data-state": Vn(d),
            "data-disabled": a ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
Ua.displayName = xo;
var Ka = "CollapsibleTrigger", $n = l.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: o, ...n } = e, r = zn(Ka, o);
    return /* @__PURE__ */ c(
      I.button,
      {
        type: "button",
        "aria-controls": r.contentId,
        "aria-expanded": r.open || !1,
        "data-state": Vn(r.open),
        "data-disabled": r.disabled ? "" : void 0,
        disabled: r.disabled,
        ...n,
        ref: t,
        onClick: _(e.onClick, r.onOpenToggle)
      }
    );
  }
);
$n.displayName = Ka;
var Fn = "CollapsibleContent", Bn = l.forwardRef(
  (e, t) => {
    const { forceMount: o, ...n } = e, r = zn(Fn, e.__scopeCollapsible);
    return /* @__PURE__ */ c(se, { present: o || r.open, children: ({ present: a }) => /* @__PURE__ */ c(Nu, { ...n, ref: t, present: a }) });
  }
);
Bn.displayName = Fn;
var Nu = l.forwardRef((e, t) => {
  const { __scopeCollapsible: o, present: n, children: r, ...a } = e, i = zn(Fn, o), [s, d] = l.useState(n), u = l.useRef(null), f = B(t, u), p = l.useRef(0), m = p.current, h = l.useRef(0), b = h.current, g = i.open || s, v = l.useRef(g), w = l.useRef(void 0);
  return l.useEffect(() => {
    const x = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(x);
  }, []), oe(() => {
    const x = u.current;
    if (x) {
      w.current = w.current || {
        transitionDuration: x.style.transitionDuration,
        animationName: x.style.animationName
      }, x.style.transitionDuration = "0s", x.style.animationName = "none";
      const y = x.getBoundingClientRect();
      p.current = y.height, h.current = y.width, v.current || (x.style.transitionDuration = w.current.transitionDuration, x.style.animationName = w.current.animationName), d(n);
    }
  }, [i.open, n]), /* @__PURE__ */ c(
    I.div,
    {
      "data-state": Vn(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !g,
      ...a,
      ref: f,
      style: {
        "--radix-collapsible-content-height": m ? `${m}px` : void 0,
        "--radix-collapsible-content-width": b ? `${b}px` : void 0,
        ...e.style
      },
      children: g && r
    }
  );
});
function Vn(e) {
  return e ? "open" : "closed";
}
var ja = Ua, ku = $n, Iu = Bn, Mu = l.createContext(void 0);
function nt(e) {
  const t = l.useContext(Mu);
  return e || t || "ltr";
}
var Se = "Accordion", Du = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Gn, Ou, Lu] = Mt(Se), [yo] = ae(Se, [
  Lu,
  Ha
]), Wn = Ha(), Ya = X.forwardRef(
  (e, t) => {
    const { type: o, ...n } = e, r = n, a = n;
    return /* @__PURE__ */ c(Gn.Provider, { scope: e.__scopeAccordion, children: o === "multiple" ? /* @__PURE__ */ c(Bu, { ...a, ref: t }) : /* @__PURE__ */ c(Fu, { ...r, ref: t }) });
  }
);
Ya.displayName = Se;
var [Xa, zu] = yo(Se), [qa, $u] = yo(
  Se,
  { collapsible: !1 }
), Fu = X.forwardRef(
  (e, t) => {
    const {
      value: o,
      defaultValue: n,
      onValueChange: r = () => {
      },
      collapsible: a = !1,
      ...i
    } = e, [s, d] = le({
      prop: o,
      defaultProp: n ?? "",
      onChange: r,
      caller: Se
    });
    return /* @__PURE__ */ c(
      Xa,
      {
        scope: e.__scopeAccordion,
        value: X.useMemo(() => s ? [s] : [], [s]),
        onItemOpen: d,
        onItemClose: X.useCallback(() => a && d(""), [a, d]),
        children: /* @__PURE__ */ c(qa, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ c(Za, { ...i, ref: t }) })
      }
    );
  }
), Bu = X.forwardRef((e, t) => {
  const {
    value: o,
    defaultValue: n,
    onValueChange: r = () => {
    },
    ...a
  } = e, [i, s] = le({
    prop: o,
    defaultProp: n ?? [],
    onChange: r,
    caller: Se
  }), d = X.useCallback(
    (f) => s((p = []) => [...p, f]),
    [s]
  ), u = X.useCallback(
    (f) => s((p = []) => p.filter((m) => m !== f)),
    [s]
  );
  return /* @__PURE__ */ c(
    Xa,
    {
      scope: e.__scopeAccordion,
      value: i,
      onItemOpen: d,
      onItemClose: u,
      children: /* @__PURE__ */ c(qa, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ c(Za, { ...a, ref: t }) })
    }
  );
}), [Vu, Co] = yo(Se), Za = X.forwardRef(
  (e, t) => {
    const { __scopeAccordion: o, disabled: n, dir: r, orientation: a = "vertical", ...i } = e, s = X.useRef(null), d = B(s, t), u = Ou(o), p = nt(r) === "ltr", m = _(e.onKeyDown, (h) => {
      if (!Du.includes(h.key)) return;
      const b = h.target, g = u().filter((S) => !S.ref.current?.disabled), v = g.findIndex((S) => S.ref.current === b), w = g.length;
      if (v === -1) return;
      h.preventDefault();
      let x = v;
      const y = 0, C = w - 1, R = () => {
        x = v + 1, x > C && (x = y);
      }, A = () => {
        x = v - 1, x < y && (x = C);
      };
      switch (h.key) {
        case "Home":
          x = y;
          break;
        case "End":
          x = C;
          break;
        case "ArrowRight":
          a === "horizontal" && (p ? R() : A());
          break;
        case "ArrowDown":
          a === "vertical" && R();
          break;
        case "ArrowLeft":
          a === "horizontal" && (p ? A() : R());
          break;
        case "ArrowUp":
          a === "vertical" && A();
          break;
      }
      const P = x % w;
      g[P].ref.current?.focus();
    });
    return /* @__PURE__ */ c(
      Vu,
      {
        scope: o,
        disabled: n,
        direction: r,
        orientation: a,
        children: /* @__PURE__ */ c(Gn.Slot, { scope: o, children: /* @__PURE__ */ c(
          I.div,
          {
            ...i,
            "data-orientation": a,
            ref: d,
            onKeyDown: n ? void 0 : m
          }
        ) })
      }
    );
  }
), ro = "AccordionItem", [Gu, Hn] = yo(ro), Qa = X.forwardRef(
  (e, t) => {
    const { __scopeAccordion: o, value: n, ...r } = e, a = Co(ro, o), i = zu(ro, o), s = Wn(o), d = fe(), u = n && i.value.includes(n) || !1, f = a.disabled || e.disabled;
    return /* @__PURE__ */ c(
      Gu,
      {
        scope: o,
        open: u,
        disabled: f,
        triggerId: d,
        children: /* @__PURE__ */ c(
          ja,
          {
            "data-orientation": a.orientation,
            "data-state": ri(u),
            ...s,
            ...r,
            ref: t,
            disabled: f,
            open: u,
            onOpenChange: (p) => {
              p ? i.onItemOpen(n) : i.onItemClose(n);
            }
          }
        )
      }
    );
  }
);
Qa.displayName = ro;
var Ja = "AccordionHeader", ei = X.forwardRef(
  (e, t) => {
    const { __scopeAccordion: o, ...n } = e, r = Co(Se, o), a = Hn(Ja, o);
    return /* @__PURE__ */ c(
      I.h3,
      {
        "data-orientation": r.orientation,
        "data-state": ri(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...n,
        ref: t
      }
    );
  }
);
ei.displayName = Ja;
var vn = "AccordionTrigger", ti = X.forwardRef(
  (e, t) => {
    const { __scopeAccordion: o, ...n } = e, r = Co(Se, o), a = Hn(vn, o), i = $u(vn, o), s = Wn(o);
    return /* @__PURE__ */ c(Gn.ItemSlot, { scope: o, children: /* @__PURE__ */ c(
      ku,
      {
        "aria-disabled": a.open && !i.collapsible || void 0,
        "data-orientation": r.orientation,
        id: a.triggerId,
        ...s,
        ...n,
        ref: t
      }
    ) });
  }
);
ti.displayName = vn;
var oi = "AccordionContent", ni = X.forwardRef(
  (e, t) => {
    const { __scopeAccordion: o, ...n } = e, r = Co(Se, o), a = Hn(oi, o), i = Wn(o);
    return /* @__PURE__ */ c(
      Iu,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": r.orientation,
        ...i,
        ...n,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
ni.displayName = oi;
function ri(e) {
  return e ? "open" : "closed";
}
var Wu = Ya, Hu = Qa, Uu = ei, Ku = ti, ju = ni;
function re(e) {
  const t = l.useRef(e);
  return l.useEffect(() => {
    t.current = e;
  }), l.useMemo(() => (...o) => t.current?.(...o), []);
}
function Yu(e, t = globalThis?.document) {
  const o = re(e);
  l.useEffect(() => {
    const n = (r) => {
      r.key === "Escape" && o(r);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [o, t]);
}
var Xu = "DismissableLayer", bn = "dismissableLayer.update", qu = "dismissableLayer.pointerDownOutside", Zu = "dismissableLayer.focusOutside", Vr, ai = l.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), wt = l.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: o = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: r,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...d
    } = e, u = l.useContext(ai), [f, p] = l.useState(null), m = f?.ownerDocument ?? globalThis?.document, [, h] = l.useState({}), b = B(t, (P) => p(P)), g = Array.from(u.layers), [v] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = g.indexOf(v), x = f ? g.indexOf(f) : -1, y = u.layersWithOutsidePointerEventsDisabled.size > 0, C = x >= w, R = ef((P) => {
      const S = P.target, N = [...u.branches].some(($) => $.contains(S));
      !C || N || (r?.(P), i?.(P), P.defaultPrevented || s?.());
    }, m), A = tf((P) => {
      const S = P.target;
      [...u.branches].some(($) => $.contains(S)) || (a?.(P), i?.(P), P.defaultPrevented || s?.());
    }, m);
    return Yu((P) => {
      x === u.layers.size - 1 && (n?.(P), !P.defaultPrevented && s && (P.preventDefault(), s()));
    }, m), l.useEffect(() => {
      if (f)
        return o && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Vr = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(f)), u.layers.add(f), Gr(), () => {
          o && u.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = Vr);
        };
    }, [f, m, o, u]), l.useEffect(() => () => {
      f && (u.layers.delete(f), u.layersWithOutsidePointerEventsDisabled.delete(f), Gr());
    }, [f, u]), l.useEffect(() => {
      const P = () => h({});
      return document.addEventListener(bn, P), () => document.removeEventListener(bn, P);
    }, []), /* @__PURE__ */ c(
      I.div,
      {
        ...d,
        ref: b,
        style: {
          pointerEvents: y ? C ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: _(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: _(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: _(
          e.onPointerDownCapture,
          R.onPointerDownCapture
        )
      }
    );
  }
);
wt.displayName = Xu;
var Qu = "DismissableLayerBranch", Ju = l.forwardRef((e, t) => {
  const o = l.useContext(ai), n = l.useRef(null), r = B(t, n);
  return l.useEffect(() => {
    const a = n.current;
    if (a)
      return o.branches.add(a), () => {
        o.branches.delete(a);
      };
  }, [o.branches]), /* @__PURE__ */ c(I.div, { ...e, ref: r });
});
Ju.displayName = Qu;
function ef(e, t = globalThis?.document) {
  const o = re(e), n = l.useRef(!1), r = l.useRef(() => {
  });
  return l.useEffect(() => {
    const a = (s) => {
      if (s.target && !n.current) {
        let d = function() {
          ii(
            qu,
            o,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = d, t.addEventListener("click", r.current, { once: !0 })) : d();
      } else
        t.removeEventListener("click", r.current);
      n.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", r.current);
    };
  }, [t, o]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function tf(e, t = globalThis?.document) {
  const o = re(e), n = l.useRef(!1);
  return l.useEffect(() => {
    const r = (a) => {
      a.target && !n.current && ii(Zu, o, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [t, o]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function Gr() {
  const e = new CustomEvent(bn);
  document.dispatchEvent(e);
}
function ii(e, t, o, { discrete: n }) {
  const r = o.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: o });
  t && r.addEventListener(e, t, { once: !0 }), n ? Va(r, a) : r.dispatchEvent(a);
}
var en = "focusScope.autoFocusOnMount", tn = "focusScope.autoFocusOnUnmount", Wr = { bubbles: !1, cancelable: !0 }, of = "FocusScope", Dt = l.forwardRef((e, t) => {
  const {
    loop: o = !1,
    trapped: n = !1,
    onMountAutoFocus: r,
    onUnmountAutoFocus: a,
    ...i
  } = e, [s, d] = l.useState(null), u = re(r), f = re(a), p = l.useRef(null), m = B(t, (g) => d(g)), h = l.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  l.useEffect(() => {
    if (n) {
      let g = function(y) {
        if (h.paused || !s) return;
        const C = y.target;
        s.contains(C) ? p.current = C : ze(p.current, { select: !0 });
      }, v = function(y) {
        if (h.paused || !s) return;
        const C = y.relatedTarget;
        C !== null && (s.contains(C) || ze(p.current, { select: !0 }));
      }, w = function(y) {
        if (document.activeElement === document.body)
          for (const R of y)
            R.removedNodes.length > 0 && ze(s);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", v);
      const x = new MutationObserver(w);
      return s && x.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", v), x.disconnect();
      };
    }
  }, [n, s, h.paused]), l.useEffect(() => {
    if (s) {
      Ur.add(h);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const w = new CustomEvent(en, Wr);
        s.addEventListener(en, u), s.dispatchEvent(w), w.defaultPrevented || (nf(cf(si(s)), { select: !0 }), document.activeElement === g && ze(s));
      }
      return () => {
        s.removeEventListener(en, u), setTimeout(() => {
          const w = new CustomEvent(tn, Wr);
          s.addEventListener(tn, f), s.dispatchEvent(w), w.defaultPrevented || ze(g ?? document.body, { select: !0 }), s.removeEventListener(tn, f), Ur.remove(h);
        }, 0);
      };
    }
  }, [s, u, f, h]);
  const b = l.useCallback(
    (g) => {
      if (!o && !n || h.paused) return;
      const v = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, w = document.activeElement;
      if (v && w) {
        const x = g.currentTarget, [y, C] = rf(x);
        y && C ? !g.shiftKey && w === C ? (g.preventDefault(), o && ze(y, { select: !0 })) : g.shiftKey && w === y && (g.preventDefault(), o && ze(C, { select: !0 })) : w === x && g.preventDefault();
      }
    },
    [o, n, h.paused]
  );
  return /* @__PURE__ */ c(I.div, { tabIndex: -1, ...i, ref: m, onKeyDown: b });
});
Dt.displayName = of;
function nf(e, { select: t = !1 } = {}) {
  const o = document.activeElement;
  for (const n of e)
    if (ze(n, { select: t }), document.activeElement !== o) return;
}
function rf(e) {
  const t = si(e), o = Hr(t, e), n = Hr(t.reverse(), e);
  return [o, n];
}
function si(e) {
  const t = [], o = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const r = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || r ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; o.nextNode(); ) t.push(o.currentNode);
  return t;
}
function Hr(e, t) {
  for (const o of e)
    if (!af(o, { upTo: t })) return o;
}
function af(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function sf(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ze(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const o = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== o && sf(e) && t && e.select();
  }
}
var Ur = lf();
function lf() {
  let e = [];
  return {
    add(t) {
      const o = e[0];
      t !== o && o?.pause(), e = Kr(e, t), e.unshift(t);
    },
    remove(t) {
      e = Kr(e, t), e[0]?.resume();
    }
  };
}
function Kr(e, t) {
  const o = [...e], n = o.indexOf(t);
  return n !== -1 && o.splice(n, 1), o;
}
function cf(e) {
  return e.filter((t) => t.tagName !== "A");
}
var df = "Portal", xt = l.forwardRef((e, t) => {
  const { container: o, ...n } = e, [r, a] = l.useState(!1);
  oe(() => a(!0), []);
  const i = o || r && globalThis?.document?.body;
  return i ? yd.createPortal(/* @__PURE__ */ c(I.div, { ...n, ref: t }), i) : null;
});
xt.displayName = df;
var on = 0;
function So() {
  l.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? jr()), document.body.insertAdjacentElement("beforeend", e[1] ?? jr()), on++, () => {
      on === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), on--;
    };
  }, []);
}
function jr() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Re = function() {
  return Re = Object.assign || function(t) {
    for (var o, n = 1, r = arguments.length; n < r; n++) {
      o = arguments[n];
      for (var a in o) Object.prototype.hasOwnProperty.call(o, a) && (t[a] = o[a]);
    }
    return t;
  }, Re.apply(this, arguments);
};
function li(e, t) {
  var o = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (o[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, n = Object.getOwnPropertySymbols(e); r < n.length; r++)
      t.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[r]) && (o[n[r]] = e[n[r]]);
  return o;
}
function uf(e, t, o) {
  if (o || arguments.length === 2) for (var n = 0, r = t.length, a; n < r; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var eo = "right-scroll-bar-position", to = "width-before-scroll-bar", ff = "with-scroll-bars-hidden", pf = "--removed-body-scroll-bar-size";
function nn(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function mf(e, t) {
  var o = hd(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return o.value;
        },
        set current(n) {
          var r = o.value;
          r !== n && (o.value = n, o.callback(n, r));
        }
      }
    };
  })[0];
  return o.callback = t, o.facade;
}
var gf = typeof window < "u" ? l.useLayoutEffect : l.useEffect, Yr = /* @__PURE__ */ new WeakMap();
function hf(e, t) {
  var o = mf(null, function(n) {
    return e.forEach(function(r) {
      return nn(r, n);
    });
  });
  return gf(function() {
    var n = Yr.get(o);
    if (n) {
      var r = new Set(n), a = new Set(e), i = o.current;
      r.forEach(function(s) {
        a.has(s) || nn(s, null);
      }), a.forEach(function(s) {
        r.has(s) || nn(s, i);
      });
    }
    Yr.set(o, e);
  }, [e]), o;
}
function vf(e) {
  return e;
}
function bf(e, t) {
  t === void 0 && (t = vf);
  var o = [], n = !1, r = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return o.length ? o[o.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, n);
      return o.push(i), function() {
        o = o.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (n = !0; o.length; ) {
        var i = o;
        o = [], i.forEach(a);
      }
      o = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return o;
        }
      };
    },
    assignMedium: function(a) {
      n = !0;
      var i = [];
      if (o.length) {
        var s = o;
        o = [], s.forEach(a), i = o;
      }
      var d = function() {
        var f = i;
        i = [], f.forEach(a);
      }, u = function() {
        return Promise.resolve().then(d);
      };
      u(), o = {
        push: function(f) {
          i.push(f), u();
        },
        filter: function(f) {
          return i = i.filter(f), o;
        }
      };
    }
  };
  return r;
}
function wf(e) {
  e === void 0 && (e = {});
  var t = bf(null);
  return t.options = Re({ async: !0, ssr: !1 }, e), t;
}
var ci = function(e) {
  var t = e.sideCar, o = li(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return l.createElement(n, Re({}, o));
};
ci.isSideCarExport = !0;
function xf(e, t) {
  return e.useMedium(t), ci;
}
var di = wf(), rn = function() {
}, Eo = l.forwardRef(function(e, t) {
  var o = l.useRef(null), n = l.useState({
    onScrollCapture: rn,
    onWheelCapture: rn,
    onTouchMoveCapture: rn
  }), r = n[0], a = n[1], i = e.forwardProps, s = e.children, d = e.className, u = e.removeScrollBar, f = e.enabled, p = e.shards, m = e.sideCar, h = e.noRelative, b = e.noIsolation, g = e.inert, v = e.allowPinchZoom, w = e.as, x = w === void 0 ? "div" : w, y = e.gapMode, C = li(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), R = m, A = hf([o, t]), P = Re(Re({}, C), r);
  return l.createElement(
    l.Fragment,
    null,
    f && l.createElement(R, { sideCar: di, removeScrollBar: u, shards: p, noRelative: h, noIsolation: b, inert: g, setCallbacks: a, allowPinchZoom: !!v, lockRef: o, gapMode: y }),
    i ? l.cloneElement(l.Children.only(s), Re(Re({}, P), { ref: A })) : l.createElement(x, Re({}, P, { className: d, ref: A }), s)
  );
});
Eo.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Eo.classNames = {
  fullWidth: to,
  zeroRight: eo
};
var yf = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Cf() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = yf();
  return t && e.setAttribute("nonce", t), e;
}
function Sf(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Ef(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Rf = function() {
  var e = 0, t = null;
  return {
    add: function(o) {
      e == 0 && (t = Cf()) && (Sf(t, o), Ef(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Pf = function() {
  var e = Rf();
  return function(t, o) {
    l.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && o]);
  };
}, ui = function() {
  var e = Pf(), t = function(o) {
    var n = o.styles, r = o.dynamic;
    return e(n, r), null;
  };
  return t;
}, Af = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, an = function(e) {
  return parseInt(e || "", 10) || 0;
}, _f = function(e) {
  var t = window.getComputedStyle(document.body), o = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [an(o), an(n), an(r)];
}, Tf = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Af;
  var t = _f(e), o = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - o + t[2] - t[0])
  };
}, Nf = ui(), ut = "data-scroll-locked", kf = function(e, t, o, n) {
  var r = e.left, a = e.top, i = e.right, s = e.gap;
  return o === void 0 && (o = "margin"), `
  .`.concat(ff, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body[`).concat(ut, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    o === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `),
    o === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(eo, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(to, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(eo, " .").concat(eo, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(to, " .").concat(to, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(ut, `] {
    `).concat(pf, ": ").concat(s, `px;
  }
`);
}, Xr = function() {
  var e = parseInt(document.body.getAttribute(ut) || "0", 10);
  return isFinite(e) ? e : 0;
}, If = function() {
  l.useEffect(function() {
    return document.body.setAttribute(ut, (Xr() + 1).toString()), function() {
      var e = Xr() - 1;
      e <= 0 ? document.body.removeAttribute(ut) : document.body.setAttribute(ut, e.toString());
    };
  }, []);
}, Mf = function(e) {
  var t = e.noRelative, o = e.noImportant, n = e.gapMode, r = n === void 0 ? "margin" : n;
  If();
  var a = l.useMemo(function() {
    return Tf(r);
  }, [r]);
  return l.createElement(Nf, { styles: kf(a, !t, r, o ? "" : "!important") });
}, wn = !1;
if (typeof window < "u")
  try {
    var Yt = Object.defineProperty({}, "passive", {
      get: function() {
        return wn = !0, !0;
      }
    });
    window.addEventListener("test", Yt, Yt), window.removeEventListener("test", Yt, Yt);
  } catch {
    wn = !1;
  }
var lt = wn ? { passive: !1 } : !1, Df = function(e) {
  return e.tagName === "TEXTAREA";
}, fi = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var o = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    o[t] !== "hidden" && // contains scroll inside self
    !(o.overflowY === o.overflowX && !Df(e) && o[t] === "visible")
  );
}, Of = function(e) {
  return fi(e, "overflowY");
}, Lf = function(e) {
  return fi(e, "overflowX");
}, qr = function(e, t) {
  var o = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = pi(e, n);
    if (r) {
      var a = mi(e, n), i = a[1], s = a[2];
      if (i > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== o.body);
  return !1;
}, zf = function(e) {
  var t = e.scrollTop, o = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    o,
    n
  ];
}, $f = function(e) {
  var t = e.scrollLeft, o = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    o,
    n
  ];
}, pi = function(e, t) {
  return e === "v" ? Of(t) : Lf(t);
}, mi = function(e, t) {
  return e === "v" ? zf(t) : $f(t);
}, Ff = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Bf = function(e, t, o, n, r) {
  var a = Ff(e, window.getComputedStyle(t).direction), i = a * n, s = o.target, d = t.contains(s), u = !1, f = i > 0, p = 0, m = 0;
  do {
    if (!s)
      break;
    var h = mi(e, s), b = h[0], g = h[1], v = h[2], w = g - v - a * b;
    (b || w) && pi(e, s) && (p += w, m += b);
    var x = s.parentNode;
    s = x && x.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? x.host : x;
  } while (
    // portaled content
    !d && s !== document.body || // self content
    d && (t.contains(s) || t === s)
  );
  return (f && Math.abs(p) < 1 || !f && Math.abs(m) < 1) && (u = !0), u;
}, Xt = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Zr = function(e) {
  return [e.deltaX, e.deltaY];
}, Qr = function(e) {
  return e && "current" in e ? e.current : e;
}, Vf = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Gf = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Wf = 0, ct = [];
function Hf(e) {
  var t = l.useRef([]), o = l.useRef([0, 0]), n = l.useRef(), r = l.useState(Wf++)[0], a = l.useState(ui)[0], i = l.useRef(e);
  l.useEffect(function() {
    i.current = e;
  }, [e]), l.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var g = uf([e.lockRef.current], (e.shards || []).map(Qr), !0).filter(Boolean);
      return g.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), g.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = l.useCallback(function(g, v) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = Xt(g), x = o.current, y = "deltaX" in g ? g.deltaX : x[0] - w[0], C = "deltaY" in g ? g.deltaY : x[1] - w[1], R, A = g.target, P = Math.abs(y) > Math.abs(C) ? "h" : "v";
    if ("touches" in g && P === "h" && A.type === "range")
      return !1;
    var S = window.getSelection(), N = S && S.anchorNode, $ = N ? N === A || N.contains(A) : !1;
    if ($)
      return !1;
    var F = qr(P, A);
    if (!F)
      return !0;
    if (F ? R = P : (R = P === "v" ? "h" : "v", F = qr(P, A)), !F)
      return !1;
    if (!n.current && "changedTouches" in g && (y || C) && (n.current = R), !R)
      return !0;
    var V = n.current || R;
    return Bf(V, v, g, V === "h" ? y : C);
  }, []), d = l.useCallback(function(g) {
    var v = g;
    if (!(!ct.length || ct[ct.length - 1] !== a)) {
      var w = "deltaY" in v ? Zr(v) : Xt(v), x = t.current.filter(function(R) {
        return R.name === v.type && (R.target === v.target || v.target === R.shadowParent) && Vf(R.delta, w);
      })[0];
      if (x && x.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!x) {
        var y = (i.current.shards || []).map(Qr).filter(Boolean).filter(function(R) {
          return R.contains(v.target);
        }), C = y.length > 0 ? s(v, y[0]) : !i.current.noIsolation;
        C && v.cancelable && v.preventDefault();
      }
    }
  }, []), u = l.useCallback(function(g, v, w, x) {
    var y = { name: g, delta: v, target: w, should: x, shadowParent: Uf(w) };
    t.current.push(y), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== y;
      });
    }, 1);
  }, []), f = l.useCallback(function(g) {
    o.current = Xt(g), n.current = void 0;
  }, []), p = l.useCallback(function(g) {
    u(g.type, Zr(g), g.target, s(g, e.lockRef.current));
  }, []), m = l.useCallback(function(g) {
    u(g.type, Xt(g), g.target, s(g, e.lockRef.current));
  }, []);
  l.useEffect(function() {
    return ct.push(a), e.setCallbacks({
      onScrollCapture: p,
      onWheelCapture: p,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", d, lt), document.addEventListener("touchmove", d, lt), document.addEventListener("touchstart", f, lt), function() {
      ct = ct.filter(function(g) {
        return g !== a;
      }), document.removeEventListener("wheel", d, lt), document.removeEventListener("touchmove", d, lt), document.removeEventListener("touchstart", f, lt);
    };
  }, []);
  var h = e.removeScrollBar, b = e.inert;
  return l.createElement(
    l.Fragment,
    null,
    b ? l.createElement(a, { styles: Gf(r) }) : null,
    h ? l.createElement(Mf, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function Uf(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Kf = xf(di, Hf);
var Ot = l.forwardRef(function(e, t) {
  return l.createElement(Eo, Re({}, e, { ref: t, sideCar: Kf }));
});
Ot.classNames = Eo.classNames;
var jf = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, dt = /* @__PURE__ */ new WeakMap(), qt = /* @__PURE__ */ new WeakMap(), Zt = {}, sn = 0, gi = function(e) {
  return e && (e.host || gi(e.parentNode));
}, Yf = function(e, t) {
  return t.map(function(o) {
    if (e.contains(o))
      return o;
    var n = gi(o);
    return n && e.contains(n) ? n : (console.error("aria-hidden", o, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(o) {
    return !!o;
  });
}, Xf = function(e, t, o, n) {
  var r = Yf(t, Array.isArray(e) ? e : [e]);
  Zt[o] || (Zt[o] = /* @__PURE__ */ new WeakMap());
  var a = Zt[o], i = [], s = /* @__PURE__ */ new Set(), d = new Set(r), u = function(p) {
    !p || s.has(p) || (s.add(p), u(p.parentNode));
  };
  r.forEach(u);
  var f = function(p) {
    !p || d.has(p) || Array.prototype.forEach.call(p.children, function(m) {
      if (s.has(m))
        f(m);
      else
        try {
          var h = m.getAttribute(n), b = h !== null && h !== "false", g = (dt.get(m) || 0) + 1, v = (a.get(m) || 0) + 1;
          dt.set(m, g), a.set(m, v), i.push(m), g === 1 && b && qt.set(m, !0), v === 1 && m.setAttribute(o, "true"), b || m.setAttribute(n, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", m, w);
        }
    });
  };
  return f(t), s.clear(), sn++, function() {
    i.forEach(function(p) {
      var m = dt.get(p) - 1, h = a.get(p) - 1;
      dt.set(p, m), a.set(p, h), m || (qt.has(p) || p.removeAttribute(n), qt.delete(p)), h || p.removeAttribute(o);
    }), sn--, sn || (dt = /* @__PURE__ */ new WeakMap(), dt = /* @__PURE__ */ new WeakMap(), qt = /* @__PURE__ */ new WeakMap(), Zt = {});
  };
}, Ro = function(e, t, o) {
  o === void 0 && (o = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), r = jf(e);
  return r ? (n.push.apply(n, Array.from(r.querySelectorAll("[aria-live], script"))), Xf(n, r, o, "aria-hidden")) : function() {
    return null;
  };
}, Po = "Dialog", [hi, vi] = ae(Po), [qf, Ee] = hi(Po), bi = (e) => {
  const {
    __scopeDialog: t,
    children: o,
    open: n,
    defaultOpen: r,
    onOpenChange: a,
    modal: i = !0
  } = e, s = l.useRef(null), d = l.useRef(null), [u, f] = le({
    prop: n,
    defaultProp: r ?? !1,
    onChange: a,
    caller: Po
  });
  return /* @__PURE__ */ c(
    qf,
    {
      scope: t,
      triggerRef: s,
      contentRef: d,
      contentId: fe(),
      titleId: fe(),
      descriptionId: fe(),
      open: u,
      onOpenChange: f,
      onOpenToggle: l.useCallback(() => f((p) => !p), [f]),
      modal: i,
      children: o
    }
  );
};
bi.displayName = Po;
var wi = "DialogTrigger", xi = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: o, ...n } = e, r = Ee(wi, o), a = B(t, r.triggerRef);
    return /* @__PURE__ */ c(
      I.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": jn(r.open),
        ...n,
        ref: a,
        onClick: _(e.onClick, r.onOpenToggle)
      }
    );
  }
);
xi.displayName = wi;
var Un = "DialogPortal", [Zf, yi] = hi(Un, {
  forceMount: void 0
}), Ci = (e) => {
  const { __scopeDialog: t, forceMount: o, children: n, container: r } = e, a = Ee(Un, t);
  return /* @__PURE__ */ c(Zf, { scope: t, forceMount: o, children: l.Children.map(n, (i) => /* @__PURE__ */ c(se, { present: o || a.open, children: /* @__PURE__ */ c(xt, { asChild: !0, container: r, children: i }) })) });
};
Ci.displayName = Un;
var ao = "DialogOverlay", Si = l.forwardRef(
  (e, t) => {
    const o = yi(ao, e.__scopeDialog), { forceMount: n = o.forceMount, ...r } = e, a = Ee(ao, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ c(se, { present: n || a.open, children: /* @__PURE__ */ c(Jf, { ...r, ref: t }) }) : null;
  }
);
Si.displayName = ao;
var Qf = /* @__PURE__ */ Be("DialogOverlay.RemoveScroll"), Jf = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: o, ...n } = e, r = Ee(ao, o);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ c(Ot, { as: Qf, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ c(
        I.div,
        {
          "data-state": jn(r.open),
          ...n,
          ref: t,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), Qe = "DialogContent", Ei = l.forwardRef(
  (e, t) => {
    const o = yi(Qe, e.__scopeDialog), { forceMount: n = o.forceMount, ...r } = e, a = Ee(Qe, e.__scopeDialog);
    return /* @__PURE__ */ c(se, { present: n || a.open, children: a.modal ? /* @__PURE__ */ c(ep, { ...r, ref: t }) : /* @__PURE__ */ c(tp, { ...r, ref: t }) });
  }
);
Ei.displayName = Qe;
var ep = l.forwardRef(
  (e, t) => {
    const o = Ee(Qe, e.__scopeDialog), n = l.useRef(null), r = B(t, o.contentRef, n);
    return l.useEffect(() => {
      const a = n.current;
      if (a) return Ro(a);
    }, []), /* @__PURE__ */ c(
      Ri,
      {
        ...e,
        ref: r,
        trapFocus: o.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: _(e.onCloseAutoFocus, (a) => {
          a.preventDefault(), o.triggerRef.current?.focus();
        }),
        onPointerDownOutside: _(e.onPointerDownOutside, (a) => {
          const i = a.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && a.preventDefault();
        }),
        onFocusOutside: _(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), tp = l.forwardRef(
  (e, t) => {
    const o = Ee(Qe, e.__scopeDialog), n = l.useRef(!1), r = l.useRef(!1);
    return /* @__PURE__ */ c(
      Ri,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          e.onCloseAutoFocus?.(a), a.defaultPrevented || (n.current || o.triggerRef.current?.focus(), a.preventDefault()), n.current = !1, r.current = !1;
        },
        onInteractOutside: (a) => {
          e.onInteractOutside?.(a), a.defaultPrevented || (n.current = !0, a.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const i = a.target;
          o.triggerRef.current?.contains(i) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && r.current && a.preventDefault();
        }
      }
    );
  }
), Ri = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: o, trapFocus: n, onOpenAutoFocus: r, onCloseAutoFocus: a, ...i } = e, s = Ee(Qe, o), d = l.useRef(null), u = B(t, d);
    return So(), /* @__PURE__ */ Y(Fe, { children: [
      /* @__PURE__ */ c(
        Dt,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: r,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ c(
            wt,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": jn(s.open),
              ...i,
              ref: u,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ Y(Fe, { children: [
        /* @__PURE__ */ c(np, { titleId: s.titleId }),
        /* @__PURE__ */ c(ap, { contentRef: d, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Kn = "DialogTitle", Pi = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: o, ...n } = e, r = Ee(Kn, o);
    return /* @__PURE__ */ c(I.h2, { id: r.titleId, ...n, ref: t });
  }
);
Pi.displayName = Kn;
var Ai = "DialogDescription", _i = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: o, ...n } = e, r = Ee(Ai, o);
    return /* @__PURE__ */ c(I.p, { id: r.descriptionId, ...n, ref: t });
  }
);
_i.displayName = Ai;
var Ti = "DialogClose", Ni = l.forwardRef(
  (e, t) => {
    const { __scopeDialog: o, ...n } = e, r = Ee(Ti, o);
    return /* @__PURE__ */ c(
      I.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: _(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
Ni.displayName = Ti;
function jn(e) {
  return e ? "open" : "closed";
}
var ki = "DialogTitleWarning", [op, Ii] = bu(ki, {
  contentName: Qe,
  titleName: Kn,
  docsSlug: "dialog"
}), np = ({ titleId: e }) => {
  const t = Ii(ki), o = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return l.useEffect(() => {
    e && (document.getElementById(e) || console.error(o));
  }, [o, e]), null;
}, rp = "DialogDescriptionWarning", ap = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Ii(rp).contentName}}.`;
  return l.useEffect(() => {
    const r = e.current?.getAttribute("aria-describedby");
    t && r && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, Yn = bi, Xn = xi, qn = Ci, Zn = Si, Qn = Ei, Jn = Pi, er = _i, rt = Ni, Mi = "AlertDialog", [ip] = ae(Mi, [
  vi
]), Me = vi(), Di = (e) => {
  const { __scopeAlertDialog: t, ...o } = e, n = Me(t);
  return /* @__PURE__ */ c(Yn, { ...n, ...o, modal: !0 });
};
Di.displayName = Mi;
var sp = "AlertDialogTrigger", Oi = l.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: o, ...n } = e, r = Me(o);
    return /* @__PURE__ */ c(Xn, { ...r, ...n, ref: t });
  }
);
Oi.displayName = sp;
var lp = "AlertDialogPortal", Li = (e) => {
  const { __scopeAlertDialog: t, ...o } = e, n = Me(t);
  return /* @__PURE__ */ c(qn, { ...n, ...o });
};
Li.displayName = lp;
var cp = "AlertDialogOverlay", zi = l.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: o, ...n } = e, r = Me(o);
    return /* @__PURE__ */ c(Zn, { ...r, ...n, ref: t });
  }
);
zi.displayName = cp;
var ft = "AlertDialogContent", [dp, up] = ip(ft), fp = /* @__PURE__ */ Ba("AlertDialogContent"), $i = l.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: o, children: n, ...r } = e, a = Me(o), i = l.useRef(null), s = B(t, i), d = l.useRef(null);
    return /* @__PURE__ */ c(
      op,
      {
        contentName: ft,
        titleName: Fi,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ c(dp, { scope: o, cancelRef: d, children: /* @__PURE__ */ Y(
          Qn,
          {
            role: "alertdialog",
            ...a,
            ...r,
            ref: s,
            onOpenAutoFocus: _(r.onOpenAutoFocus, (u) => {
              u.preventDefault(), d.current?.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (u) => u.preventDefault(),
            onInteractOutside: (u) => u.preventDefault(),
            children: [
              /* @__PURE__ */ c(fp, { children: n }),
              /* @__PURE__ */ c(mp, { contentRef: i })
            ]
          }
        ) })
      }
    );
  }
);
$i.displayName = ft;
var Fi = "AlertDialogTitle", Bi = l.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: o, ...n } = e, r = Me(o);
    return /* @__PURE__ */ c(Jn, { ...r, ...n, ref: t });
  }
);
Bi.displayName = Fi;
var Vi = "AlertDialogDescription", Gi = l.forwardRef((e, t) => {
  const { __scopeAlertDialog: o, ...n } = e, r = Me(o);
  return /* @__PURE__ */ c(er, { ...r, ...n, ref: t });
});
Gi.displayName = Vi;
var pp = "AlertDialogAction", Wi = l.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: o, ...n } = e, r = Me(o);
    return /* @__PURE__ */ c(rt, { ...r, ...n, ref: t });
  }
);
Wi.displayName = pp;
var Hi = "AlertDialogCancel", Ui = l.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: o, ...n } = e, { cancelRef: r } = up(Hi, o), a = Me(o), i = B(t, r);
    return /* @__PURE__ */ c(rt, { ...a, ...n, ref: i });
  }
);
Ui.displayName = Hi;
var mp = ({ contentRef: e }) => {
  const t = `\`${ft}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${ft}\` by passing a \`${Vi}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${ft}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return l.useEffect(() => {
    document.getElementById(
      e.current?.getAttribute("aria-describedby")
    ) || console.warn(t);
  }, [t, e]), null;
}, gp = Di, hp = Oi, vp = Li, bp = zi, wp = $i, xp = Wi, yp = Ui, Cp = Bi, Sp = Gi, Qt = { exports: {} }, ln = {};
var Jr;
function Ep() {
  if (Jr) return ln;
  Jr = 1;
  var e = X;
  function t(p, m) {
    return p === m && (p !== 0 || 1 / p === 1 / m) || p !== p && m !== m;
  }
  var o = typeof Object.is == "function" ? Object.is : t, n = e.useState, r = e.useEffect, a = e.useLayoutEffect, i = e.useDebugValue;
  function s(p, m) {
    var h = m(), b = n({ inst: { value: h, getSnapshot: m } }), g = b[0].inst, v = b[1];
    return a(
      function() {
        g.value = h, g.getSnapshot = m, d(g) && v({ inst: g });
      },
      [p, h, m]
    ), r(
      function() {
        return d(g) && v({ inst: g }), p(function() {
          d(g) && v({ inst: g });
        });
      },
      [p]
    ), i(h), h;
  }
  function d(p) {
    var m = p.getSnapshot;
    p = p.value;
    try {
      var h = m();
      return !o(p, h);
    } catch {
      return !0;
    }
  }
  function u(p, m) {
    return m();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : s;
  return ln.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : f, ln;
}
var cn = {};
var ea;
function Rp() {
  return ea || (ea = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(h, b) {
      return h === b && (h !== 0 || 1 / h === 1 / b) || h !== h && b !== b;
    }
    function t(h, b) {
      f || r.startTransition === void 0 || (f = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var g = b();
      if (!p) {
        var v = b();
        a(g, v) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), p = !0);
      }
      v = i({
        inst: { value: g, getSnapshot: b }
      });
      var w = v[0].inst, x = v[1];
      return d(
        function() {
          w.value = g, w.getSnapshot = b, o(w) && x({ inst: w });
        },
        [h, g, b]
      ), s(
        function() {
          return o(w) && x({ inst: w }), h(function() {
            o(w) && x({ inst: w });
          });
        },
        [h]
      ), u(g), g;
    }
    function o(h) {
      var b = h.getSnapshot;
      h = h.value;
      try {
        var g = b();
        return !a(h, g);
      } catch {
        return !0;
      }
    }
    function n(h, b) {
      return b();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var r = X, a = typeof Object.is == "function" ? Object.is : e, i = r.useState, s = r.useEffect, d = r.useLayoutEffect, u = r.useDebugValue, f = !1, p = !1, m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? n : t;
    cn.useSyncExternalStore = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : m, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), cn;
}
var ta;
function Pp() {
  return ta || (ta = 1, process.env.NODE_ENV === "production" ? Qt.exports = Ep() : Qt.exports = Rp()), Qt.exports;
}
var Ap = Pp();
function _p() {
  return Ap.useSyncExternalStore(
    Tp,
    () => !0,
    () => !1
  );
}
function Tp() {
  return () => {
  };
}
var tr = "Avatar", [Np] = ae(tr), [kp, Ki] = Np(tr), ji = l.forwardRef(
  (e, t) => {
    const { __scopeAvatar: o, ...n } = e, [r, a] = l.useState("idle");
    return /* @__PURE__ */ c(
      kp,
      {
        scope: o,
        imageLoadingStatus: r,
        onImageLoadingStatusChange: a,
        children: /* @__PURE__ */ c(I.span, { ...n, ref: t })
      }
    );
  }
);
ji.displayName = tr;
var Yi = "AvatarImage", Xi = l.forwardRef(
  (e, t) => {
    const { __scopeAvatar: o, src: n, onLoadingStatusChange: r = () => {
    }, ...a } = e, i = Ki(Yi, o), s = Ip(n, a), d = re((u) => {
      r(u), i.onImageLoadingStatusChange(u);
    });
    return oe(() => {
      s !== "idle" && d(s);
    }, [s, d]), s === "loaded" ? /* @__PURE__ */ c(I.img, { ...a, ref: t, src: n }) : null;
  }
);
Xi.displayName = Yi;
var qi = "AvatarFallback", Zi = l.forwardRef(
  (e, t) => {
    const { __scopeAvatar: o, delayMs: n, ...r } = e, a = Ki(qi, o), [i, s] = l.useState(n === void 0);
    return l.useEffect(() => {
      if (n !== void 0) {
        const d = window.setTimeout(() => s(!0), n);
        return () => window.clearTimeout(d);
      }
    }, [n]), i && a.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ c(I.span, { ...r, ref: t }) : null;
  }
);
Zi.displayName = qi;
function oa(e, t) {
  return e ? t ? (e.src !== t && (e.src = t), e.complete && e.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function Ip(e, { referrerPolicy: t, crossOrigin: o }) {
  const n = _p(), r = l.useRef(null), a = n ? (r.current || (r.current = new window.Image()), r.current) : null, [i, s] = l.useState(
    () => oa(a, e)
  );
  return oe(() => {
    s(oa(a, e));
  }, [a, e]), oe(() => {
    const d = (p) => () => {
      s(p);
    };
    if (!a) return;
    const u = d("loaded"), f = d("error");
    return a.addEventListener("load", u), a.addEventListener("error", f), t && (a.referrerPolicy = t), typeof o == "string" && (a.crossOrigin = o), () => {
      a.removeEventListener("load", u), a.removeEventListener("error", f);
    };
  }, [a, o, t]), i;
}
var Mp = ji, Dp = Xi, Op = Zi;
function Ao(e) {
  const t = l.useRef({ value: e, previous: e });
  return l.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function _o(e) {
  const [t, o] = l.useState(void 0);
  return oe(() => {
    if (e) {
      o({ width: e.offsetWidth, height: e.offsetHeight });
      const n = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const a = r[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const d = a.borderBoxSize, u = Array.isArray(d) ? d[0] : d;
          i = u.inlineSize, s = u.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        o({ width: i, height: s });
      });
      return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
    } else
      o(void 0);
  }, [e]), t;
}
var To = "Checkbox", [Lp] = ae(To), [zp, or] = Lp(To);
function $p(e) {
  const {
    __scopeCheckbox: t,
    checked: o,
    children: n,
    defaultChecked: r,
    disabled: a,
    form: i,
    name: s,
    onCheckedChange: d,
    required: u,
    value: f = "on",
    // @ts-expect-error
    internal_do_not_use_render: p
  } = e, [m, h] = le({
    prop: o,
    defaultProp: r ?? !1,
    onChange: d,
    caller: To
  }), [b, g] = l.useState(null), [v, w] = l.useState(null), x = l.useRef(!1), y = b ? !!i || !!b.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), C = {
    checked: m,
    disabled: a,
    setChecked: h,
    control: b,
    setControl: g,
    name: s,
    form: i,
    value: f,
    hasConsumerStoppedPropagationRef: x,
    required: u,
    defaultChecked: $e(r) ? !1 : r,
    isFormControl: y,
    bubbleInput: v,
    setBubbleInput: w
  };
  return /* @__PURE__ */ c(
    zp,
    {
      scope: t,
      ...C,
      children: Fp(p) ? p(C) : n
    }
  );
}
var Qi = "CheckboxTrigger", Ji = l.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: o, ...n }, r) => {
    const {
      control: a,
      value: i,
      disabled: s,
      checked: d,
      required: u,
      setControl: f,
      setChecked: p,
      hasConsumerStoppedPropagationRef: m,
      isFormControl: h,
      bubbleInput: b
    } = or(Qi, e), g = B(r, f), v = l.useRef(d);
    return l.useEffect(() => {
      const w = a?.form;
      if (w) {
        const x = () => p(v.current);
        return w.addEventListener("reset", x), () => w.removeEventListener("reset", x);
      }
    }, [a, p]), /* @__PURE__ */ c(
      I.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": $e(d) ? "mixed" : d,
        "aria-required": u,
        "data-state": as(d),
        "data-disabled": s ? "" : void 0,
        disabled: s,
        value: i,
        ...n,
        ref: g,
        onKeyDown: _(t, (w) => {
          w.key === "Enter" && w.preventDefault();
        }),
        onClick: _(o, (w) => {
          p((x) => $e(x) ? !0 : !x), b && h && (m.current = w.isPropagationStopped(), m.current || w.stopPropagation());
        })
      }
    );
  }
);
Ji.displayName = Qi;
var es = l.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: o,
      name: n,
      checked: r,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: d,
      onCheckedChange: u,
      form: f,
      ...p
    } = e;
    return /* @__PURE__ */ c(
      $p,
      {
        __scopeCheckbox: o,
        checked: r,
        defaultChecked: a,
        disabled: s,
        required: i,
        onCheckedChange: u,
        name: n,
        form: f,
        value: d,
        internal_do_not_use_render: ({ isFormControl: m }) => /* @__PURE__ */ Y(Fe, { children: [
          /* @__PURE__ */ c(
            Ji,
            {
              ...p,
              ref: t,
              __scopeCheckbox: o
            }
          ),
          m && /* @__PURE__ */ c(
            rs,
            {
              __scopeCheckbox: o
            }
          )
        ] })
      }
    );
  }
);
es.displayName = To;
var ts = "CheckboxIndicator", os = l.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: o, forceMount: n, ...r } = e, a = or(ts, o);
    return /* @__PURE__ */ c(
      se,
      {
        present: n || $e(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ c(
          I.span,
          {
            "data-state": as(a.checked),
            "data-disabled": a.disabled ? "" : void 0,
            ...r,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
os.displayName = ts;
var ns = "CheckboxBubbleInput", rs = l.forwardRef(
  ({ __scopeCheckbox: e, ...t }, o) => {
    const {
      control: n,
      hasConsumerStoppedPropagationRef: r,
      checked: a,
      defaultChecked: i,
      required: s,
      disabled: d,
      name: u,
      value: f,
      form: p,
      bubbleInput: m,
      setBubbleInput: h
    } = or(ns, e), b = B(o, h), g = Ao(a), v = _o(n);
    l.useEffect(() => {
      const x = m;
      if (!x) return;
      const y = window.HTMLInputElement.prototype, R = Object.getOwnPropertyDescriptor(
        y,
        "checked"
      ).set, A = !r.current;
      if (g !== a && R) {
        const P = new Event("click", { bubbles: A });
        x.indeterminate = $e(a), R.call(x, $e(a) ? !1 : a), x.dispatchEvent(P);
      }
    }, [m, g, a, r]);
    const w = l.useRef($e(a) ? !1 : a);
    return /* @__PURE__ */ c(
      I.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: i ?? w.current,
        required: s,
        disabled: d,
        name: u,
        value: f,
        form: p,
        ...t,
        tabIndex: -1,
        ref: b,
        style: {
          ...t.style,
          ...v,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
rs.displayName = ns;
function Fp(e) {
  return typeof e == "function";
}
function $e(e) {
  return e === "indeterminate";
}
function as(e) {
  return $e(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const Bp = ["top", "right", "bottom", "left"], Ve = Math.min, me = Math.max, io = Math.round, Jt = Math.floor, Ae = (e) => ({
  x: e,
  y: e
}), Vp = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function xn(e, t, o) {
  return me(e, Ve(t, o));
}
function ke(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ie(e) {
  return e.split("-")[0];
}
function yt(e) {
  return e.split("-")[1];
}
function nr(e) {
  return e === "x" ? "y" : "x";
}
function rr(e) {
  return e === "y" ? "height" : "width";
}
function Pe(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function ar(e) {
  return nr(Pe(e));
}
function Gp(e, t, o) {
  o === void 0 && (o = !1);
  const n = yt(e), r = ar(e), a = rr(r);
  let i = r === "x" ? n === (o ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = so(i)), [i, so(i)];
}
function Wp(e) {
  const t = so(e);
  return [yn(e), t, yn(t)];
}
function yn(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const na = ["left", "right"], ra = ["right", "left"], Hp = ["top", "bottom"], Up = ["bottom", "top"];
function Kp(e, t, o) {
  switch (e) {
    case "top":
    case "bottom":
      return o ? t ? ra : na : t ? na : ra;
    case "left":
    case "right":
      return t ? Hp : Up;
    default:
      return [];
  }
}
function jp(e, t, o, n) {
  const r = yt(e);
  let a = Kp(Ie(e), o === "start", n);
  return r && (a = a.map((i) => i + "-" + r), t && (a = a.concat(a.map(yn)))), a;
}
function so(e) {
  const t = Ie(e);
  return Vp[t] + e.slice(t.length);
}
function Yp(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function is(e) {
  return typeof e != "number" ? Yp(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function lo(e) {
  const {
    x: t,
    y: o,
    width: n,
    height: r
  } = e;
  return {
    width: n,
    height: r,
    top: o,
    left: t,
    right: t + n,
    bottom: o + r,
    x: t,
    y: o
  };
}
function aa(e, t, o) {
  let {
    reference: n,
    floating: r
  } = e;
  const a = Pe(t), i = ar(t), s = rr(i), d = Ie(t), u = a === "y", f = n.x + n.width / 2 - r.width / 2, p = n.y + n.height / 2 - r.height / 2, m = n[s] / 2 - r[s] / 2;
  let h;
  switch (d) {
    case "top":
      h = {
        x: f,
        y: n.y - r.height
      };
      break;
    case "bottom":
      h = {
        x: f,
        y: n.y + n.height
      };
      break;
    case "right":
      h = {
        x: n.x + n.width,
        y: p
      };
      break;
    case "left":
      h = {
        x: n.x - r.width,
        y: p
      };
      break;
    default:
      h = {
        x: n.x,
        y: n.y
      };
  }
  switch (yt(t)) {
    case "start":
      h[i] -= m * (o && u ? -1 : 1);
      break;
    case "end":
      h[i] += m * (o && u ? -1 : 1);
      break;
  }
  return h;
}
async function Xp(e, t) {
  var o;
  t === void 0 && (t = {});
  const {
    x: n,
    y: r,
    platform: a,
    rects: i,
    elements: s,
    strategy: d
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: p = "floating",
    altBoundary: m = !1,
    padding: h = 0
  } = ke(t, e), b = is(h), v = s[m ? p === "floating" ? "reference" : "floating" : p], w = lo(await a.getClippingRect({
    element: (o = await (a.isElement == null ? void 0 : a.isElement(v))) == null || o ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: f,
    strategy: d
  })), x = p === "floating" ? {
    x: n,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, y = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), C = await (a.isElement == null ? void 0 : a.isElement(y)) ? await (a.getScale == null ? void 0 : a.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, R = lo(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: x,
    offsetParent: y,
    strategy: d
  }) : x);
  return {
    top: (w.top - R.top + b.top) / C.y,
    bottom: (R.bottom - w.bottom + b.bottom) / C.y,
    left: (w.left - R.left + b.left) / C.x,
    right: (R.right - w.right + b.right) / C.x
  };
}
const qp = 50, Zp = async (e, t, o) => {
  const {
    placement: n = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: i
  } = o, s = i.detectOverflow ? i : {
    ...i,
    detectOverflow: Xp
  }, d = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let u = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: f,
    y: p
  } = aa(u, n, d), m = n, h = 0;
  const b = {};
  for (let g = 0; g < a.length; g++) {
    const v = a[g];
    if (!v)
      continue;
    const {
      name: w,
      fn: x
    } = v, {
      x: y,
      y: C,
      data: R,
      reset: A
    } = await x({
      x: f,
      y: p,
      initialPlacement: n,
      placement: m,
      strategy: r,
      middlewareData: b,
      rects: u,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = y ?? f, p = C ?? p, b[w] = {
      ...b[w],
      ...R
    }, A && h < qp && (h++, typeof A == "object" && (A.placement && (m = A.placement), A.rects && (u = A.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : A.rects), {
      x: f,
      y: p
    } = aa(u, m, d)), g = -1);
  }
  return {
    x: f,
    y: p,
    placement: m,
    strategy: r,
    middlewareData: b
  };
}, Qp = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: o,
      y: n,
      placement: r,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: d
    } = t, {
      element: u,
      padding: f = 0
    } = ke(e, t) || {};
    if (u == null)
      return {};
    const p = is(f), m = {
      x: o,
      y: n
    }, h = ar(r), b = rr(h), g = await i.getDimensions(u), v = h === "y", w = v ? "top" : "left", x = v ? "bottom" : "right", y = v ? "clientHeight" : "clientWidth", C = a.reference[b] + a.reference[h] - m[h] - a.floating[b], R = m[h] - a.reference[h], A = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u));
    let P = A ? A[y] : 0;
    (!P || !await (i.isElement == null ? void 0 : i.isElement(A))) && (P = s.floating[y] || a.floating[b]);
    const S = C / 2 - R / 2, N = P / 2 - g[b] / 2 - 1, $ = Ve(p[w], N), F = Ve(p[x], N), V = $, H = P - g[b] - F, W = P / 2 - g[b] / 2 + S, K = xn(V, W, H), z = !d.arrow && yt(r) != null && W !== K && a.reference[b] / 2 - (W < V ? $ : F) - g[b] / 2 < 0, G = z ? W < V ? W - V : W - H : 0;
    return {
      [h]: m[h] + G,
      data: {
        [h]: K,
        centerOffset: W - K - G,
        ...z && {
          alignmentOffset: G
        }
      },
      reset: z
    };
  }
}), Jp = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var o, n;
      const {
        placement: r,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: d,
        elements: u
      } = t, {
        mainAxis: f = !0,
        crossAxis: p = !0,
        fallbackPlacements: m,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: g = !0,
        ...v
      } = ke(e, t);
      if ((o = a.arrow) != null && o.alignmentOffset)
        return {};
      const w = Ie(r), x = Pe(s), y = Ie(s) === s, C = await (d.isRTL == null ? void 0 : d.isRTL(u.floating)), R = m || (y || !g ? [so(s)] : Wp(s)), A = b !== "none";
      !m && A && R.push(...jp(s, g, b, C));
      const P = [s, ...R], S = await d.detectOverflow(t, v), N = [];
      let $ = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (f && N.push(S[w]), p) {
        const W = Gp(r, i, C);
        N.push(S[W[0]], S[W[1]]);
      }
      if ($ = [...$, {
        placement: r,
        overflows: N
      }], !N.every((W) => W <= 0)) {
        var F, V;
        const W = (((F = a.flip) == null ? void 0 : F.index) || 0) + 1, K = P[W];
        if (K && (!(p === "alignment" ? x !== Pe(K) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        $.every((O) => Pe(O.placement) === x ? O.overflows[0] > 0 : !0)))
          return {
            data: {
              index: W,
              overflows: $
            },
            reset: {
              placement: K
            }
          };
        let z = (V = $.filter((G) => G.overflows[0] <= 0).sort((G, O) => G.overflows[1] - O.overflows[1])[0]) == null ? void 0 : V.placement;
        if (!z)
          switch (h) {
            case "bestFit": {
              var H;
              const G = (H = $.filter((O) => {
                if (A) {
                  const T = Pe(O.placement);
                  return T === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  T === "y";
                }
                return !0;
              }).map((O) => [O.placement, O.overflows.filter((T) => T > 0).reduce((T, k) => T + k, 0)]).sort((O, T) => O[1] - T[1])[0]) == null ? void 0 : H[0];
              G && (z = G);
              break;
            }
            case "initialPlacement":
              z = s;
              break;
          }
        if (r !== z)
          return {
            reset: {
              placement: z
            }
          };
      }
      return {};
    }
  };
};
function ia(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function sa(e) {
  return Bp.some((t) => e[t] >= 0);
}
const em = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: o,
        platform: n
      } = t, {
        strategy: r = "referenceHidden",
        ...a
      } = ke(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await n.detectOverflow(t, {
            ...a,
            elementContext: "reference"
          }), s = ia(i, o.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: sa(s)
            }
          };
        }
        case "escaped": {
          const i = await n.detectOverflow(t, {
            ...a,
            altBoundary: !0
          }), s = ia(i, o.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: sa(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, ss = /* @__PURE__ */ new Set(["left", "top"]);
async function tm(e, t) {
  const {
    placement: o,
    platform: n,
    elements: r
  } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(r.floating)), i = Ie(o), s = yt(o), d = Pe(o) === "y", u = ss.has(i) ? -1 : 1, f = a && d ? -1 : 1, p = ke(t, e);
  let {
    mainAxis: m,
    crossAxis: h,
    alignmentAxis: b
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: p.mainAxis || 0,
    crossAxis: p.crossAxis || 0,
    alignmentAxis: p.alignmentAxis
  };
  return s && typeof b == "number" && (h = s === "end" ? b * -1 : b), d ? {
    x: h * f,
    y: m * u
  } : {
    x: m * u,
    y: h * f
  };
}
const om = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var o, n;
      const {
        x: r,
        y: a,
        placement: i,
        middlewareData: s
      } = t, d = await tm(t, e);
      return i === ((o = s.offset) == null ? void 0 : o.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: r + d.x,
        y: a + d.y,
        data: {
          ...d,
          placement: i
        }
      };
    }
  };
}, nm = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: o,
        y: n,
        placement: r,
        platform: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: d = {
          fn: (w) => {
            let {
              x,
              y
            } = w;
            return {
              x,
              y
            };
          }
        },
        ...u
      } = ke(e, t), f = {
        x: o,
        y: n
      }, p = await a.detectOverflow(t, u), m = Pe(Ie(r)), h = nr(m);
      let b = f[h], g = f[m];
      if (i) {
        const w = h === "y" ? "top" : "left", x = h === "y" ? "bottom" : "right", y = b + p[w], C = b - p[x];
        b = xn(y, b, C);
      }
      if (s) {
        const w = m === "y" ? "top" : "left", x = m === "y" ? "bottom" : "right", y = g + p[w], C = g - p[x];
        g = xn(y, g, C);
      }
      const v = d.fn({
        ...t,
        [h]: b,
        [m]: g
      });
      return {
        ...v,
        data: {
          x: v.x - o,
          y: v.y - n,
          enabled: {
            [h]: i,
            [m]: s
          }
        }
      };
    }
  };
}, rm = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: o,
        y: n,
        placement: r,
        rects: a,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: d = !0,
        crossAxis: u = !0
      } = ke(e, t), f = {
        x: o,
        y: n
      }, p = Pe(r), m = nr(p);
      let h = f[m], b = f[p];
      const g = ke(s, t), v = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (d) {
        const y = m === "y" ? "height" : "width", C = a.reference[m] - a.floating[y] + v.mainAxis, R = a.reference[m] + a.reference[y] - v.mainAxis;
        h < C ? h = C : h > R && (h = R);
      }
      if (u) {
        var w, x;
        const y = m === "y" ? "width" : "height", C = ss.has(Ie(r)), R = a.reference[p] - a.floating[y] + (C && ((w = i.offset) == null ? void 0 : w[p]) || 0) + (C ? 0 : v.crossAxis), A = a.reference[p] + a.reference[y] + (C ? 0 : ((x = i.offset) == null ? void 0 : x[p]) || 0) - (C ? v.crossAxis : 0);
        b < R ? b = R : b > A && (b = A);
      }
      return {
        [m]: h,
        [p]: b
      };
    }
  };
}, am = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var o, n;
      const {
        placement: r,
        rects: a,
        platform: i,
        elements: s
      } = t, {
        apply: d = () => {
        },
        ...u
      } = ke(e, t), f = await i.detectOverflow(t, u), p = Ie(r), m = yt(r), h = Pe(r) === "y", {
        width: b,
        height: g
      } = a.floating;
      let v, w;
      p === "top" || p === "bottom" ? (v = p, w = m === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (w = p, v = m === "end" ? "top" : "bottom");
      const x = g - f.top - f.bottom, y = b - f.left - f.right, C = Ve(g - f[v], x), R = Ve(b - f[w], y), A = !t.middlewareData.shift;
      let P = C, S = R;
      if ((o = t.middlewareData.shift) != null && o.enabled.x && (S = y), (n = t.middlewareData.shift) != null && n.enabled.y && (P = x), A && !m) {
        const $ = me(f.left, 0), F = me(f.right, 0), V = me(f.top, 0), H = me(f.bottom, 0);
        h ? S = b - 2 * ($ !== 0 || F !== 0 ? $ + F : me(f.left, f.right)) : P = g - 2 * (V !== 0 || H !== 0 ? V + H : me(f.top, f.bottom));
      }
      await d({
        ...t,
        availableWidth: S,
        availableHeight: P
      });
      const N = await i.getDimensions(s.floating);
      return b !== N.width || g !== N.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function No() {
  return typeof window < "u";
}
function Ct(e) {
  return ls(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ge(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function _e(e) {
  var t;
  return (t = (ls(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ls(e) {
  return No() ? e instanceof Node || e instanceof ge(e).Node : !1;
}
function ye(e) {
  return No() ? e instanceof Element || e instanceof ge(e).Element : !1;
}
function De(e) {
  return No() ? e instanceof HTMLElement || e instanceof ge(e).HTMLElement : !1;
}
function la(e) {
  return !No() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ge(e).ShadowRoot;
}
function Lt(e) {
  const {
    overflow: t,
    overflowX: o,
    overflowY: n,
    display: r
  } = Ce(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + o) && r !== "inline" && r !== "contents";
}
function im(e) {
  return /^(table|td|th)$/.test(Ct(e));
}
function ko(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const sm = /transform|translate|scale|rotate|perspective|filter/, lm = /paint|layout|strict|content/, Ze = (e) => !!e && e !== "none";
let dn;
function ir(e) {
  const t = ye(e) ? Ce(e) : e;
  return Ze(t.transform) || Ze(t.translate) || Ze(t.scale) || Ze(t.rotate) || Ze(t.perspective) || !sr() && (Ze(t.backdropFilter) || Ze(t.filter)) || sm.test(t.willChange || "") || lm.test(t.contain || "");
}
function cm(e) {
  let t = Ge(e);
  for (; De(t) && !mt(t); ) {
    if (ir(t))
      return t;
    if (ko(t))
      return null;
    t = Ge(t);
  }
  return null;
}
function sr() {
  return dn == null && (dn = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), dn;
}
function mt(e) {
  return /^(html|body|#document)$/.test(Ct(e));
}
function Ce(e) {
  return ge(e).getComputedStyle(e);
}
function Io(e) {
  return ye(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Ge(e) {
  if (Ct(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    la(e) && e.host || // Fallback.
    _e(e)
  );
  return la(t) ? t.host : t;
}
function cs(e) {
  const t = Ge(e);
  return mt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : De(t) && Lt(t) ? t : cs(t);
}
function _t(e, t, o) {
  var n;
  t === void 0 && (t = []), o === void 0 && (o = !0);
  const r = cs(e), a = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = ge(r);
  if (a) {
    const s = Cn(i);
    return t.concat(i, i.visualViewport || [], Lt(r) ? r : [], s && o ? _t(s) : []);
  } else
    return t.concat(r, _t(r, [], o));
}
function Cn(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ds(e) {
  const t = Ce(e);
  let o = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const r = De(e), a = r ? e.offsetWidth : o, i = r ? e.offsetHeight : n, s = io(o) !== a || io(n) !== i;
  return s && (o = a, n = i), {
    width: o,
    height: n,
    $: s
  };
}
function lr(e) {
  return ye(e) ? e : e.contextElement;
}
function pt(e) {
  const t = lr(e);
  if (!De(t))
    return Ae(1);
  const o = t.getBoundingClientRect(), {
    width: n,
    height: r,
    $: a
  } = ds(t);
  let i = (a ? io(o.width) : o.width) / n, s = (a ? io(o.height) : o.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const dm = /* @__PURE__ */ Ae(0);
function us(e) {
  const t = ge(e);
  return !sr() || !t.visualViewport ? dm : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function um(e, t, o) {
  return t === void 0 && (t = !1), !o || t && o !== ge(e) ? !1 : t;
}
function Je(e, t, o, n) {
  t === void 0 && (t = !1), o === void 0 && (o = !1);
  const r = e.getBoundingClientRect(), a = lr(e);
  let i = Ae(1);
  t && (n ? ye(n) && (i = pt(n)) : i = pt(e));
  const s = um(a, o, n) ? us(a) : Ae(0);
  let d = (r.left + s.x) / i.x, u = (r.top + s.y) / i.y, f = r.width / i.x, p = r.height / i.y;
  if (a) {
    const m = ge(a), h = n && ye(n) ? ge(n) : n;
    let b = m, g = Cn(b);
    for (; g && n && h !== b; ) {
      const v = pt(g), w = g.getBoundingClientRect(), x = Ce(g), y = w.left + (g.clientLeft + parseFloat(x.paddingLeft)) * v.x, C = w.top + (g.clientTop + parseFloat(x.paddingTop)) * v.y;
      d *= v.x, u *= v.y, f *= v.x, p *= v.y, d += y, u += C, b = ge(g), g = Cn(b);
    }
  }
  return lo({
    width: f,
    height: p,
    x: d,
    y: u
  });
}
function Mo(e, t) {
  const o = Io(e).scrollLeft;
  return t ? t.left + o : Je(_e(e)).left + o;
}
function fs(e, t) {
  const o = e.getBoundingClientRect(), n = o.left + t.scrollLeft - Mo(e, o), r = o.top + t.scrollTop;
  return {
    x: n,
    y: r
  };
}
function fm(e) {
  let {
    elements: t,
    rect: o,
    offsetParent: n,
    strategy: r
  } = e;
  const a = r === "fixed", i = _e(n), s = t ? ko(t.floating) : !1;
  if (n === i || s && a)
    return o;
  let d = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Ae(1);
  const f = Ae(0), p = De(n);
  if ((p || !p && !a) && ((Ct(n) !== "body" || Lt(i)) && (d = Io(n)), p)) {
    const h = Je(n);
    u = pt(n), f.x = h.x + n.clientLeft, f.y = h.y + n.clientTop;
  }
  const m = i && !p && !a ? fs(i, d) : Ae(0);
  return {
    width: o.width * u.x,
    height: o.height * u.y,
    x: o.x * u.x - d.scrollLeft * u.x + f.x + m.x,
    y: o.y * u.y - d.scrollTop * u.y + f.y + m.y
  };
}
function pm(e) {
  return Array.from(e.getClientRects());
}
function mm(e) {
  const t = _e(e), o = Io(e), n = e.ownerDocument.body, r = me(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), a = me(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -o.scrollLeft + Mo(e);
  const s = -o.scrollTop;
  return Ce(n).direction === "rtl" && (i += me(t.clientWidth, n.clientWidth) - r), {
    width: r,
    height: a,
    x: i,
    y: s
  };
}
const ca = 25;
function gm(e, t) {
  const o = ge(e), n = _e(e), r = o.visualViewport;
  let a = n.clientWidth, i = n.clientHeight, s = 0, d = 0;
  if (r) {
    a = r.width, i = r.height;
    const f = sr();
    (!f || f && t === "fixed") && (s = r.offsetLeft, d = r.offsetTop);
  }
  const u = Mo(n);
  if (u <= 0) {
    const f = n.ownerDocument, p = f.body, m = getComputedStyle(p), h = f.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, b = Math.abs(n.clientWidth - p.clientWidth - h);
    b <= ca && (a -= b);
  } else u <= ca && (a += u);
  return {
    width: a,
    height: i,
    x: s,
    y: d
  };
}
function hm(e, t) {
  const o = Je(e, !0, t === "fixed"), n = o.top + e.clientTop, r = o.left + e.clientLeft, a = De(e) ? pt(e) : Ae(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, d = r * a.x, u = n * a.y;
  return {
    width: i,
    height: s,
    x: d,
    y: u
  };
}
function da(e, t, o) {
  let n;
  if (t === "viewport")
    n = gm(e, o);
  else if (t === "document")
    n = mm(_e(e));
  else if (ye(t))
    n = hm(t, o);
  else {
    const r = us(e);
    n = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return lo(n);
}
function ps(e, t) {
  const o = Ge(e);
  return o === t || !ye(o) || mt(o) ? !1 : Ce(o).position === "fixed" || ps(o, t);
}
function vm(e, t) {
  const o = t.get(e);
  if (o)
    return o;
  let n = _t(e, [], !1).filter((s) => ye(s) && Ct(s) !== "body"), r = null;
  const a = Ce(e).position === "fixed";
  let i = a ? Ge(e) : e;
  for (; ye(i) && !mt(i); ) {
    const s = Ce(i), d = ir(i);
    !d && s.position === "fixed" && (r = null), (a ? !d && !r : !d && s.position === "static" && !!r && (r.position === "absolute" || r.position === "fixed") || Lt(i) && !d && ps(e, i)) ? n = n.filter((f) => f !== i) : r = s, i = Ge(i);
  }
  return t.set(e, n), n;
}
function bm(e) {
  let {
    element: t,
    boundary: o,
    rootBoundary: n,
    strategy: r
  } = e;
  const i = [...o === "clippingAncestors" ? ko(t) ? [] : vm(t, this._c) : [].concat(o), n], s = da(t, i[0], r);
  let d = s.top, u = s.right, f = s.bottom, p = s.left;
  for (let m = 1; m < i.length; m++) {
    const h = da(t, i[m], r);
    d = me(h.top, d), u = Ve(h.right, u), f = Ve(h.bottom, f), p = me(h.left, p);
  }
  return {
    width: u - p,
    height: f - d,
    x: p,
    y: d
  };
}
function wm(e) {
  const {
    width: t,
    height: o
  } = ds(e);
  return {
    width: t,
    height: o
  };
}
function xm(e, t, o) {
  const n = De(t), r = _e(t), a = o === "fixed", i = Je(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const d = Ae(0);
  function u() {
    d.x = Mo(r);
  }
  if (n || !n && !a)
    if ((Ct(t) !== "body" || Lt(r)) && (s = Io(t)), n) {
      const h = Je(t, !0, a, t);
      d.x = h.x + t.clientLeft, d.y = h.y + t.clientTop;
    } else r && u();
  a && !n && r && u();
  const f = r && !n && !a ? fs(r, s) : Ae(0), p = i.left + s.scrollLeft - d.x - f.x, m = i.top + s.scrollTop - d.y - f.y;
  return {
    x: p,
    y: m,
    width: i.width,
    height: i.height
  };
}
function un(e) {
  return Ce(e).position === "static";
}
function ua(e, t) {
  if (!De(e) || Ce(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let o = e.offsetParent;
  return _e(e) === o && (o = o.ownerDocument.body), o;
}
function ms(e, t) {
  const o = ge(e);
  if (ko(e))
    return o;
  if (!De(e)) {
    let r = Ge(e);
    for (; r && !mt(r); ) {
      if (ye(r) && !un(r))
        return r;
      r = Ge(r);
    }
    return o;
  }
  let n = ua(e, t);
  for (; n && im(n) && un(n); )
    n = ua(n, t);
  return n && mt(n) && un(n) && !ir(n) ? o : n || cm(e) || o;
}
const ym = async function(e) {
  const t = this.getOffsetParent || ms, o = this.getDimensions, n = await o(e.floating);
  return {
    reference: xm(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Cm(e) {
  return Ce(e).direction === "rtl";
}
const Sm = {
  convertOffsetParentRelativeRectToViewportRelativeRect: fm,
  getDocumentElement: _e,
  getClippingRect: bm,
  getOffsetParent: ms,
  getElementRects: ym,
  getClientRects: pm,
  getDimensions: wm,
  getScale: pt,
  isElement: ye,
  isRTL: Cm
};
function gs(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Em(e, t) {
  let o = null, n;
  const r = _e(e);
  function a() {
    var s;
    clearTimeout(n), (s = o) == null || s.disconnect(), o = null;
  }
  function i(s, d) {
    s === void 0 && (s = !1), d === void 0 && (d = 1), a();
    const u = e.getBoundingClientRect(), {
      left: f,
      top: p,
      width: m,
      height: h
    } = u;
    if (s || t(), !m || !h)
      return;
    const b = Jt(p), g = Jt(r.clientWidth - (f + m)), v = Jt(r.clientHeight - (p + h)), w = Jt(f), y = {
      rootMargin: -b + "px " + -g + "px " + -v + "px " + -w + "px",
      threshold: me(0, Ve(1, d)) || 1
    };
    let C = !0;
    function R(A) {
      const P = A[0].intersectionRatio;
      if (P !== d) {
        if (!C)
          return i();
        P ? i(!1, P) : n = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      P === 1 && !gs(u, e.getBoundingClientRect()) && i(), C = !1;
    }
    try {
      o = new IntersectionObserver(R, {
        ...y,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      o = new IntersectionObserver(R, y);
    }
    o.observe(e);
  }
  return i(!0), a;
}
function Rm(e, t, o, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: d = !1
  } = n, u = lr(e), f = r || a ? [...u ? _t(u) : [], ...t ? _t(t) : []] : [];
  f.forEach((w) => {
    r && w.addEventListener("scroll", o, {
      passive: !0
    }), a && w.addEventListener("resize", o);
  });
  const p = u && s ? Em(u, o) : null;
  let m = -1, h = null;
  i && (h = new ResizeObserver((w) => {
    let [x] = w;
    x && x.target === u && h && t && (h.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var y;
      (y = h) == null || y.observe(t);
    })), o();
  }), u && !d && h.observe(u), t && h.observe(t));
  let b, g = d ? Je(e) : null;
  d && v();
  function v() {
    const w = Je(e);
    g && !gs(g, w) && o(), g = w, b = requestAnimationFrame(v);
  }
  return o(), () => {
    var w;
    f.forEach((x) => {
      r && x.removeEventListener("scroll", o), a && x.removeEventListener("resize", o);
    }), p?.(), (w = h) == null || w.disconnect(), h = null, d && cancelAnimationFrame(b);
  };
}
const Pm = om, Am = nm, _m = Jp, Tm = am, Nm = em, fa = Qp, km = rm, Im = (e, t, o) => {
  const n = /* @__PURE__ */ new Map(), r = {
    platform: Sm,
    ...o
  }, a = {
    ...r.platform,
    _c: n
  };
  return Zp(e, t, {
    ...r,
    platform: a
  });
};
var Mm = typeof document < "u", Dm = function() {
}, oo = Mm ? vd : Dm;
function co(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let o, n, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (o = e.length, o !== t.length) return !1;
      for (n = o; n-- !== 0; )
        if (!co(e[n], t[n]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), o = r.length, o !== Object.keys(t).length)
      return !1;
    for (n = o; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[n]))
        return !1;
    for (n = o; n-- !== 0; ) {
      const a = r[n];
      if (!(a === "_owner" && e.$$typeof) && !co(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function hs(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function pa(e, t) {
  const o = hs(e);
  return Math.round(t * o) / o;
}
function fn(e) {
  const t = l.useRef(e);
  return oo(() => {
    t.current = e;
  }), t;
}
function Om(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: o = "absolute",
    middleware: n = [],
    platform: r,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: d,
    open: u
  } = e, [f, p] = l.useState({
    x: 0,
    y: 0,
    strategy: o,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, h] = l.useState(n);
  co(m, n) || h(n);
  const [b, g] = l.useState(null), [v, w] = l.useState(null), x = l.useCallback((O) => {
    O !== A.current && (A.current = O, g(O));
  }, []), y = l.useCallback((O) => {
    O !== P.current && (P.current = O, w(O));
  }, []), C = a || b, R = i || v, A = l.useRef(null), P = l.useRef(null), S = l.useRef(f), N = d != null, $ = fn(d), F = fn(r), V = fn(u), H = l.useCallback(() => {
    if (!A.current || !P.current)
      return;
    const O = {
      placement: t,
      strategy: o,
      middleware: m
    };
    F.current && (O.platform = F.current), Im(A.current, P.current, O).then((T) => {
      const k = {
        ...T,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: V.current !== !1
      };
      W.current && !co(S.current, k) && (S.current = k, bo.flushSync(() => {
        p(k);
      }));
    });
  }, [m, t, o, F, V]);
  oo(() => {
    u === !1 && S.current.isPositioned && (S.current.isPositioned = !1, p((O) => ({
      ...O,
      isPositioned: !1
    })));
  }, [u]);
  const W = l.useRef(!1);
  oo(() => (W.current = !0, () => {
    W.current = !1;
  }), []), oo(() => {
    if (C && (A.current = C), R && (P.current = R), C && R) {
      if ($.current)
        return $.current(C, R, H);
      H();
    }
  }, [C, R, H, $, N]);
  const K = l.useMemo(() => ({
    reference: A,
    floating: P,
    setReference: x,
    setFloating: y
  }), [x, y]), z = l.useMemo(() => ({
    reference: C,
    floating: R
  }), [C, R]), G = l.useMemo(() => {
    const O = {
      position: o,
      left: 0,
      top: 0
    };
    if (!z.floating)
      return O;
    const T = pa(z.floating, f.x), k = pa(z.floating, f.y);
    return s ? {
      ...O,
      transform: "translate(" + T + "px, " + k + "px)",
      ...hs(z.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: o,
      left: T,
      top: k
    };
  }, [o, s, z.floating, f.x, f.y]);
  return l.useMemo(() => ({
    ...f,
    update: H,
    refs: K,
    elements: z,
    floatingStyles: G
  }), [f, H, K, z, G]);
}
const Lm = (e) => {
  function t(o) {
    return {}.hasOwnProperty.call(o, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(o) {
      const {
        element: n,
        padding: r
      } = typeof e == "function" ? e(o) : e;
      return n && t(n) ? n.current != null ? fa({
        element: n.current,
        padding: r
      }).fn(o) : {} : n ? fa({
        element: n,
        padding: r
      }).fn(o) : {};
    }
  };
}, zm = (e, t) => {
  const o = Pm(e);
  return {
    name: o.name,
    fn: o.fn,
    options: [e, t]
  };
}, $m = (e, t) => {
  const o = Am(e);
  return {
    name: o.name,
    fn: o.fn,
    options: [e, t]
  };
}, Fm = (e, t) => ({
  fn: km(e).fn,
  options: [e, t]
}), Bm = (e, t) => {
  const o = _m(e);
  return {
    name: o.name,
    fn: o.fn,
    options: [e, t]
  };
}, Vm = (e, t) => {
  const o = Tm(e);
  return {
    name: o.name,
    fn: o.fn,
    options: [e, t]
  };
}, Gm = (e, t) => {
  const o = Nm(e);
  return {
    name: o.name,
    fn: o.fn,
    options: [e, t]
  };
}, Wm = (e, t) => {
  const o = Lm(e);
  return {
    name: o.name,
    fn: o.fn,
    options: [e, t]
  };
};
var Hm = "Arrow", vs = l.forwardRef((e, t) => {
  const { children: o, width: n = 10, height: r = 5, ...a } = e;
  return /* @__PURE__ */ c(
    I.svg,
    {
      ...a,
      ref: t,
      width: n,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? o : /* @__PURE__ */ c("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
vs.displayName = Hm;
var Um = vs, cr = "Popper", [bs, He] = ae(cr), [Km, ws] = bs(cr), xs = (e) => {
  const { __scopePopper: t, children: o } = e, [n, r] = l.useState(null);
  return /* @__PURE__ */ c(Km, { scope: t, anchor: n, onAnchorChange: r, children: o });
};
xs.displayName = cr;
var ys = "PopperAnchor", Cs = l.forwardRef(
  (e, t) => {
    const { __scopePopper: o, virtualRef: n, ...r } = e, a = ws(ys, o), i = l.useRef(null), s = B(t, i), d = l.useRef(null);
    return l.useEffect(() => {
      const u = d.current;
      d.current = n?.current || i.current, u !== d.current && a.onAnchorChange(d.current);
    }), n ? null : /* @__PURE__ */ c(I.div, { ...r, ref: s });
  }
);
Cs.displayName = ys;
var dr = "PopperContent", [jm, Ym] = bs(dr), Ss = l.forwardRef(
  (e, t) => {
    const {
      __scopePopper: o,
      side: n = "bottom",
      sideOffset: r = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: d = !0,
      collisionBoundary: u = [],
      collisionPadding: f = 0,
      sticky: p = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: b,
      ...g
    } = e, v = ws(dr, o), [w, x] = l.useState(null), y = B(t, (M) => x(M)), [C, R] = l.useState(null), A = _o(C), P = A?.width ?? 0, S = A?.height ?? 0, N = n + (a !== "center" ? "-" + a : ""), $ = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, F = Array.isArray(u) ? u : [u], V = F.length > 0, H = {
      padding: $,
      boundary: F.filter(qm),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: V
    }, { refs: W, floatingStyles: K, placement: z, isPositioned: G, middlewareData: O } = Om({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: N,
      whileElementsMounted: (...M) => Rm(...M, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        zm({ mainAxis: r + S, alignmentAxis: i }),
        d && $m({
          mainAxis: !0,
          crossAxis: !1,
          limiter: p === "partial" ? Fm() : void 0,
          ...H
        }),
        d && Bm({ ...H }),
        Vm({
          ...H,
          apply: ({ elements: M, rects: Q, availableWidth: j, availableHeight: J }) => {
            const { width: Z, height: te } = Q.reference, de = M.floating.style;
            de.setProperty("--radix-popper-available-width", `${j}px`), de.setProperty("--radix-popper-available-height", `${J}px`), de.setProperty("--radix-popper-anchor-width", `${Z}px`), de.setProperty("--radix-popper-anchor-height", `${te}px`);
          }
        }),
        C && Wm({ element: C, padding: s }),
        Zm({ arrowWidth: P, arrowHeight: S }),
        m && Gm({ strategy: "referenceHidden", ...H })
      ]
    }), [T, k] = Ps(z), ie = re(b);
    oe(() => {
      G && ie?.();
    }, [G, ie]);
    const pe = O.arrow?.x, he = O.arrow?.y, ce = O.arrow?.centerOffset !== 0, [ee, q] = l.useState();
    return oe(() => {
      w && q(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ c(
      "div",
      {
        ref: W.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...K,
          transform: G ? K.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ee,
          "--radix-popper-transform-origin": [
            O.transformOrigin?.x,
            O.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...O.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ c(
          jm,
          {
            scope: o,
            placedSide: T,
            onArrowChange: R,
            arrowX: pe,
            arrowY: he,
            shouldHideArrow: ce,
            children: /* @__PURE__ */ c(
              I.div,
              {
                "data-side": T,
                "data-align": k,
                ...g,
                ref: y,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: G ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Ss.displayName = dr;
var Es = "PopperArrow", Xm = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Rs = l.forwardRef(function(t, o) {
  const { __scopePopper: n, ...r } = t, a = Ym(Es, n), i = Xm[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ c(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ c(
          Um,
          {
            ...r,
            ref: o,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Rs.displayName = Es;
function qm(e) {
  return e !== null;
}
var Zm = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: o, rects: n, middlewareData: r } = t, i = r.arrow?.centerOffset !== 0, s = i ? 0 : e.arrowWidth, d = i ? 0 : e.arrowHeight, [u, f] = Ps(o), p = { start: "0%", center: "50%", end: "100%" }[f], m = (r.arrow?.x ?? 0) + s / 2, h = (r.arrow?.y ?? 0) + d / 2;
    let b = "", g = "";
    return u === "bottom" ? (b = i ? p : `${m}px`, g = `${-d}px`) : u === "top" ? (b = i ? p : `${m}px`, g = `${n.floating.height + d}px`) : u === "right" ? (b = `${-d}px`, g = i ? p : `${h}px`) : u === "left" && (b = `${n.floating.width + d}px`, g = i ? p : `${h}px`), { data: { x: b, y: g } };
  }
});
function Ps(e) {
  const [t, o = "center"] = e.split("-");
  return [t, o];
}
var zt = xs, $t = Cs, Do = Ss, Oo = Rs, pn = "rovingFocusGroup.onEntryFocus", Qm = { bubbles: !1, cancelable: !0 }, Ft = "RovingFocusGroup", [Sn, As, Jm] = Mt(Ft), [eg, Lo] = ae(
  Ft,
  [Jm]
), [tg, og] = eg(Ft), _s = l.forwardRef(
  (e, t) => /* @__PURE__ */ c(Sn.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ c(Sn.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ c(ng, { ...e, ref: t }) }) })
);
_s.displayName = Ft;
var ng = l.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: o,
    orientation: n,
    loop: r = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: d,
    onEntryFocus: u,
    preventScrollOnEntryFocus: f = !1,
    ...p
  } = e, m = l.useRef(null), h = B(t, m), b = nt(a), [g, v] = le({
    prop: i,
    defaultProp: s ?? null,
    onChange: d,
    caller: Ft
  }), [w, x] = l.useState(!1), y = re(u), C = As(o), R = l.useRef(!1), [A, P] = l.useState(0);
  return l.useEffect(() => {
    const S = m.current;
    if (S)
      return S.addEventListener(pn, y), () => S.removeEventListener(pn, y);
  }, [y]), /* @__PURE__ */ c(
    tg,
    {
      scope: o,
      orientation: n,
      dir: b,
      loop: r,
      currentTabStopId: g,
      onItemFocus: l.useCallback(
        (S) => v(S),
        [v]
      ),
      onItemShiftTab: l.useCallback(() => x(!0), []),
      onFocusableItemAdd: l.useCallback(
        () => P((S) => S + 1),
        []
      ),
      onFocusableItemRemove: l.useCallback(
        () => P((S) => S - 1),
        []
      ),
      children: /* @__PURE__ */ c(
        I.div,
        {
          tabIndex: w || A === 0 ? -1 : 0,
          "data-orientation": n,
          ...p,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: _(e.onMouseDown, () => {
            R.current = !0;
          }),
          onFocus: _(e.onFocus, (S) => {
            const N = !R.current;
            if (S.target === S.currentTarget && N && !w) {
              const $ = new CustomEvent(pn, Qm);
              if (S.currentTarget.dispatchEvent($), !$.defaultPrevented) {
                const F = C().filter((z) => z.focusable), V = F.find((z) => z.active), H = F.find((z) => z.id === g), K = [V, H, ...F].filter(
                  Boolean
                ).map((z) => z.ref.current);
                ks(K, f);
              }
            }
            R.current = !1;
          }),
          onBlur: _(e.onBlur, () => x(!1))
        }
      )
    }
  );
}), Ts = "RovingFocusGroupItem", Ns = l.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: o,
      focusable: n = !0,
      active: r = !1,
      tabStopId: a,
      children: i,
      ...s
    } = e, d = fe(), u = a || d, f = og(Ts, o), p = f.currentTabStopId === u, m = As(o), { onFocusableItemAdd: h, onFocusableItemRemove: b, currentTabStopId: g } = f;
    return l.useEffect(() => {
      if (n)
        return h(), () => b();
    }, [n, h, b]), /* @__PURE__ */ c(
      Sn.ItemSlot,
      {
        scope: o,
        id: u,
        focusable: n,
        active: r,
        children: /* @__PURE__ */ c(
          I.span,
          {
            tabIndex: p ? 0 : -1,
            "data-orientation": f.orientation,
            ...s,
            ref: t,
            onMouseDown: _(e.onMouseDown, (v) => {
              n ? f.onItemFocus(u) : v.preventDefault();
            }),
            onFocus: _(e.onFocus, () => f.onItemFocus(u)),
            onKeyDown: _(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                f.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const w = ig(v, f.orientation, f.dir);
              if (w !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let y = m().filter((C) => C.focusable).map((C) => C.ref.current);
                if (w === "last") y.reverse();
                else if (w === "prev" || w === "next") {
                  w === "prev" && y.reverse();
                  const C = y.indexOf(v.currentTarget);
                  y = f.loop ? sg(y, C + 1) : y.slice(C + 1);
                }
                setTimeout(() => ks(y));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: p, hasTabStop: g != null }) : i
          }
        )
      }
    );
  }
);
Ns.displayName = Ts;
var rg = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function ag(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function ig(e, t, o) {
  const n = ag(e.key, o);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
    return rg[n];
}
function ks(e, t = !1) {
  const o = document.activeElement;
  for (const n of e)
    if (n === o || (n.focus({ preventScroll: t }), document.activeElement !== o)) return;
}
function sg(e, t) {
  return e.map((o, n) => e[(t + n) % e.length]);
}
var Is = _s, Ms = Ns, En = ["Enter", " "], lg = ["ArrowDown", "PageUp", "Home"], Ds = ["ArrowUp", "PageDown", "End"], cg = [...lg, ...Ds], dg = {
  ltr: [...En, "ArrowRight"],
  rtl: [...En, "ArrowLeft"]
}, ug = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Bt = "Menu", [Tt, fg, pg] = Mt(Bt), [at, Os] = ae(Bt, [
  pg,
  He,
  Lo
]), Vt = He(), Ls = Lo(), [zs, Ue] = at(Bt), [mg, Gt] = at(Bt), $s = (e) => {
  const { __scopeMenu: t, open: o = !1, children: n, dir: r, onOpenChange: a, modal: i = !0 } = e, s = Vt(t), [d, u] = l.useState(null), f = l.useRef(!1), p = re(a), m = nt(r);
  return l.useEffect(() => {
    const h = () => {
      f.current = !0, document.addEventListener("pointerdown", b, { capture: !0, once: !0 }), document.addEventListener("pointermove", b, { capture: !0, once: !0 });
    }, b = () => f.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", b, { capture: !0 }), document.removeEventListener("pointermove", b, { capture: !0 });
    };
  }, []), /* @__PURE__ */ c(zt, { ...s, children: /* @__PURE__ */ c(
    zs,
    {
      scope: t,
      open: o,
      onOpenChange: p,
      content: d,
      onContentChange: u,
      children: /* @__PURE__ */ c(
        mg,
        {
          scope: t,
          onClose: l.useCallback(() => p(!1), [p]),
          isUsingKeyboardRef: f,
          dir: m,
          modal: i,
          children: n
        }
      )
    }
  ) });
};
$s.displayName = Bt;
var gg = "MenuAnchor", ur = l.forwardRef(
  (e, t) => {
    const { __scopeMenu: o, ...n } = e, r = Vt(o);
    return /* @__PURE__ */ c($t, { ...r, ...n, ref: t });
  }
);
ur.displayName = gg;
var fr = "MenuPortal", [hg, Fs] = at(fr, {
  forceMount: void 0
}), Bs = (e) => {
  const { __scopeMenu: t, forceMount: o, children: n, container: r } = e, a = Ue(fr, t);
  return /* @__PURE__ */ c(hg, { scope: t, forceMount: o, children: /* @__PURE__ */ c(se, { present: o || a.open, children: /* @__PURE__ */ c(xt, { asChild: !0, container: r, children: n }) }) });
};
Bs.displayName = fr;
var be = "MenuContent", [vg, pr] = at(be), Vs = l.forwardRef(
  (e, t) => {
    const o = Fs(be, e.__scopeMenu), { forceMount: n = o.forceMount, ...r } = e, a = Ue(be, e.__scopeMenu), i = Gt(be, e.__scopeMenu);
    return /* @__PURE__ */ c(Tt.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ c(se, { present: n || a.open, children: /* @__PURE__ */ c(Tt.Slot, { scope: e.__scopeMenu, children: i.modal ? /* @__PURE__ */ c(bg, { ...r, ref: t }) : /* @__PURE__ */ c(wg, { ...r, ref: t }) }) }) });
  }
), bg = l.forwardRef(
  (e, t) => {
    const o = Ue(be, e.__scopeMenu), n = l.useRef(null), r = B(t, n);
    return l.useEffect(() => {
      const a = n.current;
      if (a) return Ro(a);
    }, []), /* @__PURE__ */ c(
      mr,
      {
        ...e,
        ref: r,
        trapFocus: o.open,
        disableOutsidePointerEvents: o.open,
        disableOutsideScroll: !0,
        onFocusOutside: _(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => o.onOpenChange(!1)
      }
    );
  }
), wg = l.forwardRef((e, t) => {
  const o = Ue(be, e.__scopeMenu);
  return /* @__PURE__ */ c(
    mr,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => o.onOpenChange(!1)
    }
  );
}), xg = /* @__PURE__ */ Be("MenuContent.ScrollLock"), mr = l.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: o,
      loop: n = !1,
      trapFocus: r,
      onOpenAutoFocus: a,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEntryFocus: d,
      onEscapeKeyDown: u,
      onPointerDownOutside: f,
      onFocusOutside: p,
      onInteractOutside: m,
      onDismiss: h,
      disableOutsideScroll: b,
      ...g
    } = e, v = Ue(be, o), w = Gt(be, o), x = Vt(o), y = Ls(o), C = fg(o), [R, A] = l.useState(null), P = l.useRef(null), S = B(t, P, v.onContentChange), N = l.useRef(0), $ = l.useRef(""), F = l.useRef(0), V = l.useRef(null), H = l.useRef("right"), W = l.useRef(0), K = b ? Ot : l.Fragment, z = b ? { as: xg, allowPinchZoom: !0 } : void 0, G = (T) => {
      const k = $.current + T, ie = C().filter((M) => !M.disabled), pe = document.activeElement, he = ie.find((M) => M.ref.current === pe)?.textValue, ce = ie.map((M) => M.textValue), ee = Ig(ce, k, he), q = ie.find((M) => M.textValue === ee)?.ref.current;
      (function M(Q) {
        $.current = Q, window.clearTimeout(N.current), Q !== "" && (N.current = window.setTimeout(() => M(""), 1e3));
      })(k), q && setTimeout(() => q.focus());
    };
    l.useEffect(() => () => window.clearTimeout(N.current), []), So();
    const O = l.useCallback((T) => H.current === V.current?.side && Dg(T, V.current?.area), []);
    return /* @__PURE__ */ c(
      vg,
      {
        scope: o,
        searchRef: $,
        onItemEnter: l.useCallback(
          (T) => {
            O(T) && T.preventDefault();
          },
          [O]
        ),
        onItemLeave: l.useCallback(
          (T) => {
            O(T) || (P.current?.focus(), A(null));
          },
          [O]
        ),
        onTriggerLeave: l.useCallback(
          (T) => {
            O(T) && T.preventDefault();
          },
          [O]
        ),
        pointerGraceTimerRef: F,
        onPointerGraceIntentChange: l.useCallback((T) => {
          V.current = T;
        }, []),
        children: /* @__PURE__ */ c(K, { ...z, children: /* @__PURE__ */ c(
          Dt,
          {
            asChild: !0,
            trapped: r,
            onMountAutoFocus: _(a, (T) => {
              T.preventDefault(), P.current?.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ c(
              wt,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: u,
                onPointerDownOutside: f,
                onFocusOutside: p,
                onInteractOutside: m,
                onDismiss: h,
                children: /* @__PURE__ */ c(
                  Is,
                  {
                    asChild: !0,
                    ...y,
                    dir: w.dir,
                    orientation: "vertical",
                    loop: n,
                    currentTabStopId: R,
                    onCurrentTabStopIdChange: A,
                    onEntryFocus: _(d, (T) => {
                      w.isUsingKeyboardRef.current || T.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ c(
                      Do,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": rl(v.open),
                        "data-radix-menu-content": "",
                        dir: w.dir,
                        ...x,
                        ...g,
                        ref: S,
                        style: { outline: "none", ...g.style },
                        onKeyDown: _(g.onKeyDown, (T) => {
                          const ie = T.target.closest("[data-radix-menu-content]") === T.currentTarget, pe = T.ctrlKey || T.altKey || T.metaKey, he = T.key.length === 1;
                          ie && (T.key === "Tab" && T.preventDefault(), !pe && he && G(T.key));
                          const ce = P.current;
                          if (T.target !== ce || !cg.includes(T.key)) return;
                          T.preventDefault();
                          const q = C().filter((M) => !M.disabled).map((M) => M.ref.current);
                          Ds.includes(T.key) && q.reverse(), Ng(q);
                        }),
                        onBlur: _(e.onBlur, (T) => {
                          T.currentTarget.contains(T.target) || (window.clearTimeout(N.current), $.current = "");
                        }),
                        onPointerMove: _(
                          e.onPointerMove,
                          Nt((T) => {
                            const k = T.target, ie = W.current !== T.clientX;
                            if (T.currentTarget.contains(k) && ie) {
                              const pe = T.clientX > W.current ? "right" : "left";
                              H.current = pe, W.current = T.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Vs.displayName = be;
var yg = "MenuGroup", gr = l.forwardRef(
  (e, t) => {
    const { __scopeMenu: o, ...n } = e;
    return /* @__PURE__ */ c(I.div, { role: "group", ...n, ref: t });
  }
);
gr.displayName = yg;
var Cg = "MenuLabel", Gs = l.forwardRef(
  (e, t) => {
    const { __scopeMenu: o, ...n } = e;
    return /* @__PURE__ */ c(I.div, { ...n, ref: t });
  }
);
Gs.displayName = Cg;
var uo = "MenuItem", ma = "menu.itemSelect", zo = l.forwardRef(
  (e, t) => {
    const { disabled: o = !1, onSelect: n, ...r } = e, a = l.useRef(null), i = Gt(uo, e.__scopeMenu), s = pr(uo, e.__scopeMenu), d = B(t, a), u = l.useRef(!1), f = () => {
      const p = a.current;
      if (!o && p) {
        const m = new CustomEvent(ma, { bubbles: !0, cancelable: !0 });
        p.addEventListener(ma, (h) => n?.(h), { once: !0 }), Va(p, m), m.defaultPrevented ? u.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ c(
      Ws,
      {
        ...r,
        ref: d,
        disabled: o,
        onClick: _(e.onClick, f),
        onPointerDown: (p) => {
          e.onPointerDown?.(p), u.current = !0;
        },
        onPointerUp: _(e.onPointerUp, (p) => {
          u.current || p.currentTarget?.click();
        }),
        onKeyDown: _(e.onKeyDown, (p) => {
          const m = s.searchRef.current !== "";
          o || m && p.key === " " || En.includes(p.key) && (p.currentTarget.click(), p.preventDefault());
        })
      }
    );
  }
);
zo.displayName = uo;
var Ws = l.forwardRef(
  (e, t) => {
    const { __scopeMenu: o, disabled: n = !1, textValue: r, ...a } = e, i = pr(uo, o), s = Ls(o), d = l.useRef(null), u = B(t, d), [f, p] = l.useState(!1), [m, h] = l.useState("");
    return l.useEffect(() => {
      const b = d.current;
      b && h((b.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ c(
      Tt.ItemSlot,
      {
        scope: o,
        disabled: n,
        textValue: r ?? m,
        children: /* @__PURE__ */ c(Ms, { asChild: !0, ...s, focusable: !n, children: /* @__PURE__ */ c(
          I.div,
          {
            role: "menuitem",
            "data-highlighted": f ? "" : void 0,
            "aria-disabled": n || void 0,
            "data-disabled": n ? "" : void 0,
            ...a,
            ref: u,
            onPointerMove: _(
              e.onPointerMove,
              Nt((b) => {
                n ? i.onItemLeave(b) : (i.onItemEnter(b), b.defaultPrevented || b.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: _(
              e.onPointerLeave,
              Nt((b) => i.onItemLeave(b))
            ),
            onFocus: _(e.onFocus, () => p(!0)),
            onBlur: _(e.onBlur, () => p(!1))
          }
        ) })
      }
    );
  }
), Sg = "MenuCheckboxItem", Hs = l.forwardRef(
  (e, t) => {
    const { checked: o = !1, onCheckedChange: n, ...r } = e;
    return /* @__PURE__ */ c(Xs, { scope: e.__scopeMenu, checked: o, children: /* @__PURE__ */ c(
      zo,
      {
        role: "menuitemcheckbox",
        "aria-checked": fo(o) ? "mixed" : o,
        ...r,
        ref: t,
        "data-state": br(o),
        onSelect: _(
          r.onSelect,
          () => n?.(fo(o) ? !0 : !o),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Hs.displayName = Sg;
var Us = "MenuRadioGroup", [Eg, Rg] = at(
  Us,
  { value: void 0, onValueChange: () => {
  } }
), Ks = l.forwardRef(
  (e, t) => {
    const { value: o, onValueChange: n, ...r } = e, a = re(n);
    return /* @__PURE__ */ c(Eg, { scope: e.__scopeMenu, value: o, onValueChange: a, children: /* @__PURE__ */ c(gr, { ...r, ref: t }) });
  }
);
Ks.displayName = Us;
var js = "MenuRadioItem", Ys = l.forwardRef(
  (e, t) => {
    const { value: o, ...n } = e, r = Rg(js, e.__scopeMenu), a = o === r.value;
    return /* @__PURE__ */ c(Xs, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ c(
      zo,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...n,
        ref: t,
        "data-state": br(a),
        onSelect: _(
          n.onSelect,
          () => r.onValueChange?.(o),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Ys.displayName = js;
var hr = "MenuItemIndicator", [Xs, Pg] = at(
  hr,
  { checked: !1 }
), qs = l.forwardRef(
  (e, t) => {
    const { __scopeMenu: o, forceMount: n, ...r } = e, a = Pg(hr, o);
    return /* @__PURE__ */ c(
      se,
      {
        present: n || fo(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ c(
          I.span,
          {
            ...r,
            ref: t,
            "data-state": br(a.checked)
          }
        )
      }
    );
  }
);
qs.displayName = hr;
var Ag = "MenuSeparator", Zs = l.forwardRef(
  (e, t) => {
    const { __scopeMenu: o, ...n } = e;
    return /* @__PURE__ */ c(
      I.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...n,
        ref: t
      }
    );
  }
);
Zs.displayName = Ag;
var _g = "MenuArrow", Qs = l.forwardRef(
  (e, t) => {
    const { __scopeMenu: o, ...n } = e, r = Vt(o);
    return /* @__PURE__ */ c(Oo, { ...r, ...n, ref: t });
  }
);
Qs.displayName = _g;
var vr = "MenuSub", [Tg, Js] = at(vr), el = (e) => {
  const { __scopeMenu: t, children: o, open: n = !1, onOpenChange: r } = e, a = Ue(vr, t), i = Vt(t), [s, d] = l.useState(null), [u, f] = l.useState(null), p = re(r);
  return l.useEffect(() => (a.open === !1 && p(!1), () => p(!1)), [a.open, p]), /* @__PURE__ */ c(zt, { ...i, children: /* @__PURE__ */ c(
    zs,
    {
      scope: t,
      open: n,
      onOpenChange: p,
      content: u,
      onContentChange: f,
      children: /* @__PURE__ */ c(
        Tg,
        {
          scope: t,
          contentId: fe(),
          triggerId: fe(),
          trigger: s,
          onTriggerChange: d,
          children: o
        }
      )
    }
  ) });
};
el.displayName = vr;
var Pt = "MenuSubTrigger", tl = l.forwardRef(
  (e, t) => {
    const o = Ue(Pt, e.__scopeMenu), n = Gt(Pt, e.__scopeMenu), r = Js(Pt, e.__scopeMenu), a = pr(Pt, e.__scopeMenu), i = l.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: d } = a, u = { __scopeMenu: e.__scopeMenu }, f = l.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    return l.useEffect(() => f, [f]), l.useEffect(() => {
      const p = s.current;
      return () => {
        window.clearTimeout(p), d(null);
      };
    }, [s, d]), /* @__PURE__ */ c(ur, { asChild: !0, ...u, children: /* @__PURE__ */ c(
      Ws,
      {
        id: r.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": o.open,
        "aria-controls": r.contentId,
        "data-state": rl(o.open),
        ...e,
        ref: wo(t, r.onTriggerChange),
        onClick: (p) => {
          e.onClick?.(p), !(e.disabled || p.defaultPrevented) && (p.currentTarget.focus(), o.open || o.onOpenChange(!0));
        },
        onPointerMove: _(
          e.onPointerMove,
          Nt((p) => {
            a.onItemEnter(p), !p.defaultPrevented && !e.disabled && !o.open && !i.current && (a.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              o.onOpenChange(!0), f();
            }, 100));
          })
        ),
        onPointerLeave: _(
          e.onPointerLeave,
          Nt((p) => {
            f();
            const m = o.content?.getBoundingClientRect();
            if (m) {
              const h = o.content?.dataset.side, b = h === "right", g = b ? -5 : 5, v = m[b ? "left" : "right"], w = m[b ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: p.clientX + g, y: p.clientY },
                  { x: v, y: m.top },
                  { x: w, y: m.top },
                  { x: w, y: m.bottom },
                  { x: v, y: m.bottom }
                ],
                side: h
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(p), p.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: _(e.onKeyDown, (p) => {
          const m = a.searchRef.current !== "";
          e.disabled || m && p.key === " " || dg[n.dir].includes(p.key) && (o.onOpenChange(!0), o.content?.focus(), p.preventDefault());
        })
      }
    ) });
  }
);
tl.displayName = Pt;
var ol = "MenuSubContent", nl = l.forwardRef(
  (e, t) => {
    const o = Fs(be, e.__scopeMenu), { forceMount: n = o.forceMount, ...r } = e, a = Ue(be, e.__scopeMenu), i = Gt(be, e.__scopeMenu), s = Js(ol, e.__scopeMenu), d = l.useRef(null), u = B(t, d);
    return /* @__PURE__ */ c(Tt.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ c(se, { present: n || a.open, children: /* @__PURE__ */ c(Tt.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ c(
      mr,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...r,
        ref: u,
        align: "start",
        side: i.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (f) => {
          i.isUsingKeyboardRef.current && d.current?.focus(), f.preventDefault();
        },
        onCloseAutoFocus: (f) => f.preventDefault(),
        onFocusOutside: _(e.onFocusOutside, (f) => {
          f.target !== s.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: _(e.onEscapeKeyDown, (f) => {
          i.onClose(), f.preventDefault();
        }),
        onKeyDown: _(e.onKeyDown, (f) => {
          const p = f.currentTarget.contains(f.target), m = ug[i.dir].includes(f.key);
          p && m && (a.onOpenChange(!1), s.trigger?.focus(), f.preventDefault());
        })
      }
    ) }) }) });
  }
);
nl.displayName = ol;
function rl(e) {
  return e ? "open" : "closed";
}
function fo(e) {
  return e === "indeterminate";
}
function br(e) {
  return fo(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Ng(e) {
  const t = document.activeElement;
  for (const o of e)
    if (o === t || (o.focus(), document.activeElement !== t)) return;
}
function kg(e, t) {
  return e.map((o, n) => e[(t + n) % e.length]);
}
function Ig(e, t, o) {
  const r = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, a = o ? e.indexOf(o) : -1;
  let i = kg(e, Math.max(a, 0));
  r.length === 1 && (i = i.filter((u) => u !== o));
  const d = i.find(
    (u) => u.toLowerCase().startsWith(r.toLowerCase())
  );
  return d !== o ? d : void 0;
}
function Mg(e, t) {
  const { x: o, y: n } = e;
  let r = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a], d = t[i], u = s.x, f = s.y, p = d.x, m = d.y;
    f > n != m > n && o < (p - u) * (n - f) / (m - f) + u && (r = !r);
  }
  return r;
}
function Dg(e, t) {
  if (!t) return !1;
  const o = { x: e.clientX, y: e.clientY };
  return Mg(o, t);
}
function Nt(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Og = $s, Lg = ur, zg = Bs, $g = Vs, Fg = gr, Bg = Gs, Vg = zo, Gg = Hs, Wg = Ks, Hg = Ys, Ug = qs, Kg = Zs, jg = Qs, Yg = el, Xg = tl, qg = nl, $o = "DropdownMenu", [Zg] = ae(
  $o,
  [Os]
), ue = Os(), [Qg, al] = Zg($o), il = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: o,
    dir: n,
    open: r,
    defaultOpen: a,
    onOpenChange: i,
    modal: s = !0
  } = e, d = ue(t), u = l.useRef(null), [f, p] = le({
    prop: r,
    defaultProp: a ?? !1,
    onChange: i,
    caller: $o
  });
  return /* @__PURE__ */ c(
    Qg,
    {
      scope: t,
      triggerId: fe(),
      triggerRef: u,
      contentId: fe(),
      open: f,
      onOpenChange: p,
      onOpenToggle: l.useCallback(() => p((m) => !m), [p]),
      modal: s,
      children: /* @__PURE__ */ c(Og, { ...d, open: f, onOpenChange: p, dir: n, modal: s, children: o })
    }
  );
};
il.displayName = $o;
var sl = "DropdownMenuTrigger", ll = l.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: o, disabled: n = !1, ...r } = e, a = al(sl, o), i = ue(o);
    return /* @__PURE__ */ c(Lg, { asChild: !0, ...i, children: /* @__PURE__ */ c(
      I.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": n ? "" : void 0,
        disabled: n,
        ...r,
        ref: wo(t, a.triggerRef),
        onPointerDown: _(e.onPointerDown, (s) => {
          !n && s.button === 0 && s.ctrlKey === !1 && (a.onOpenToggle(), a.open || s.preventDefault());
        }),
        onKeyDown: _(e.onKeyDown, (s) => {
          n || (["Enter", " "].includes(s.key) && a.onOpenToggle(), s.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
ll.displayName = sl;
var Jg = "DropdownMenuPortal", cl = (e) => {
  const { __scopeDropdownMenu: t, ...o } = e, n = ue(t);
  return /* @__PURE__ */ c(zg, { ...n, ...o });
};
cl.displayName = Jg;
var dl = "DropdownMenuContent", ul = l.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: o, ...n } = e, r = al(dl, o), a = ue(o), i = l.useRef(!1);
    return /* @__PURE__ */ c(
      $g,
      {
        id: r.contentId,
        "aria-labelledby": r.triggerId,
        ...a,
        ...n,
        ref: t,
        onCloseAutoFocus: _(e.onCloseAutoFocus, (s) => {
          i.current || r.triggerRef.current?.focus(), i.current = !1, s.preventDefault();
        }),
        onInteractOutside: _(e.onInteractOutside, (s) => {
          const d = s.detail.originalEvent, u = d.button === 0 && d.ctrlKey === !0, f = d.button === 2 || u;
          (!r.modal || f) && (i.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
ul.displayName = dl;
var eh = "DropdownMenuGroup", fl = l.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: o, ...n } = e, r = ue(o);
    return /* @__PURE__ */ c(Fg, { ...r, ...n, ref: t });
  }
);
fl.displayName = eh;
var th = "DropdownMenuLabel", pl = l.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: o, ...n } = e, r = ue(o);
    return /* @__PURE__ */ c(Bg, { ...r, ...n, ref: t });
  }
);
pl.displayName = th;
var oh = "DropdownMenuItem", ml = l.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: o, ...n } = e, r = ue(o);
    return /* @__PURE__ */ c(Vg, { ...r, ...n, ref: t });
  }
);
ml.displayName = oh;
var nh = "DropdownMenuCheckboxItem", gl = l.forwardRef((e, t) => {
  const { __scopeDropdownMenu: o, ...n } = e, r = ue(o);
  return /* @__PURE__ */ c(Gg, { ...r, ...n, ref: t });
});
gl.displayName = nh;
var rh = "DropdownMenuRadioGroup", hl = l.forwardRef((e, t) => {
  const { __scopeDropdownMenu: o, ...n } = e, r = ue(o);
  return /* @__PURE__ */ c(Wg, { ...r, ...n, ref: t });
});
hl.displayName = rh;
var ah = "DropdownMenuRadioItem", vl = l.forwardRef((e, t) => {
  const { __scopeDropdownMenu: o, ...n } = e, r = ue(o);
  return /* @__PURE__ */ c(Hg, { ...r, ...n, ref: t });
});
vl.displayName = ah;
var ih = "DropdownMenuItemIndicator", bl = l.forwardRef((e, t) => {
  const { __scopeDropdownMenu: o, ...n } = e, r = ue(o);
  return /* @__PURE__ */ c(Ug, { ...r, ...n, ref: t });
});
bl.displayName = ih;
var sh = "DropdownMenuSeparator", wl = l.forwardRef((e, t) => {
  const { __scopeDropdownMenu: o, ...n } = e, r = ue(o);
  return /* @__PURE__ */ c(Kg, { ...r, ...n, ref: t });
});
wl.displayName = sh;
var lh = "DropdownMenuArrow", ch = l.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: o, ...n } = e, r = ue(o);
    return /* @__PURE__ */ c(jg, { ...r, ...n, ref: t });
  }
);
ch.displayName = lh;
var dh = (e) => {
  const { __scopeDropdownMenu: t, children: o, open: n, onOpenChange: r, defaultOpen: a } = e, i = ue(t), [s, d] = le({
    prop: n,
    defaultProp: a ?? !1,
    onChange: r,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ c(Yg, { ...i, open: s, onOpenChange: d, children: o });
}, uh = "DropdownMenuSubTrigger", xl = l.forwardRef((e, t) => {
  const { __scopeDropdownMenu: o, ...n } = e, r = ue(o);
  return /* @__PURE__ */ c(Xg, { ...r, ...n, ref: t });
});
xl.displayName = uh;
var fh = "DropdownMenuSubContent", yl = l.forwardRef((e, t) => {
  const { __scopeDropdownMenu: o, ...n } = e, r = ue(o);
  return /* @__PURE__ */ c(
    qg,
    {
      ...r,
      ...n,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
yl.displayName = fh;
var ph = il, mh = ll, Cl = cl, gh = ul, hh = fl, vh = pl, bh = ml, wh = gl, xh = hl, yh = vl, Sl = bl, Ch = wl, Sh = dh, Eh = xl, Rh = yl, Ph = "Label", El = l.forwardRef((e, t) => /* @__PURE__ */ c(
  I.label,
  {
    ...e,
    ref: t,
    onMouseDown: (o) => {
      o.target.closest("button, input, select, textarea") || (e.onMouseDown?.(o), !o.defaultPrevented && o.detail > 1 && o.preventDefault());
    }
  }
));
El.displayName = Ph;
var Ah = El;
function kt(e, [t, o]) {
  return Math.min(o, Math.max(t, e));
}
var Fo = "Popover", [Rl] = ae(Fo, [
  He
]), Wt = He(), [_h, Ke] = Rl(Fo), Pl = (e) => {
  const {
    __scopePopover: t,
    children: o,
    open: n,
    defaultOpen: r,
    onOpenChange: a,
    modal: i = !1
  } = e, s = Wt(t), d = l.useRef(null), [u, f] = l.useState(!1), [p, m] = le({
    prop: n,
    defaultProp: r ?? !1,
    onChange: a,
    caller: Fo
  });
  return /* @__PURE__ */ c(zt, { ...s, children: /* @__PURE__ */ c(
    _h,
    {
      scope: t,
      contentId: fe(),
      triggerRef: d,
      open: p,
      onOpenChange: m,
      onOpenToggle: l.useCallback(() => m((h) => !h), [m]),
      hasCustomAnchor: u,
      onCustomAnchorAdd: l.useCallback(() => f(!0), []),
      onCustomAnchorRemove: l.useCallback(() => f(!1), []),
      modal: i,
      children: o
    }
  ) });
};
Pl.displayName = Fo;
var Al = "PopoverAnchor", Th = l.forwardRef(
  (e, t) => {
    const { __scopePopover: o, ...n } = e, r = Ke(Al, o), a = Wt(o), { onCustomAnchorAdd: i, onCustomAnchorRemove: s } = r;
    return l.useEffect(() => (i(), () => s()), [i, s]), /* @__PURE__ */ c($t, { ...a, ...n, ref: t });
  }
);
Th.displayName = Al;
var _l = "PopoverTrigger", Tl = l.forwardRef(
  (e, t) => {
    const { __scopePopover: o, ...n } = e, r = Ke(_l, o), a = Wt(o), i = B(t, r.triggerRef), s = /* @__PURE__ */ c(
      I.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": Dl(r.open),
        ...n,
        ref: i,
        onClick: _(e.onClick, r.onOpenToggle)
      }
    );
    return r.hasCustomAnchor ? s : /* @__PURE__ */ c($t, { asChild: !0, ...a, children: s });
  }
);
Tl.displayName = _l;
var wr = "PopoverPortal", [Nh, kh] = Rl(wr, {
  forceMount: void 0
}), Nl = (e) => {
  const { __scopePopover: t, forceMount: o, children: n, container: r } = e, a = Ke(wr, t);
  return /* @__PURE__ */ c(Nh, { scope: t, forceMount: o, children: /* @__PURE__ */ c(se, { present: o || a.open, children: /* @__PURE__ */ c(xt, { asChild: !0, container: r, children: n }) }) });
};
Nl.displayName = wr;
var gt = "PopoverContent", kl = l.forwardRef(
  (e, t) => {
    const o = kh(gt, e.__scopePopover), { forceMount: n = o.forceMount, ...r } = e, a = Ke(gt, e.__scopePopover);
    return /* @__PURE__ */ c(se, { present: n || a.open, children: a.modal ? /* @__PURE__ */ c(Mh, { ...r, ref: t }) : /* @__PURE__ */ c(Dh, { ...r, ref: t }) });
  }
);
kl.displayName = gt;
var Ih = /* @__PURE__ */ Be("PopoverContent.RemoveScroll"), Mh = l.forwardRef(
  (e, t) => {
    const o = Ke(gt, e.__scopePopover), n = l.useRef(null), r = B(t, n), a = l.useRef(!1);
    return l.useEffect(() => {
      const i = n.current;
      if (i) return Ro(i);
    }, []), /* @__PURE__ */ c(Ot, { as: Ih, allowPinchZoom: !0, children: /* @__PURE__ */ c(
      Il,
      {
        ...e,
        ref: r,
        trapFocus: o.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: _(e.onCloseAutoFocus, (i) => {
          i.preventDefault(), a.current || o.triggerRef.current?.focus();
        }),
        onPointerDownOutside: _(
          e.onPointerDownOutside,
          (i) => {
            const s = i.detail.originalEvent, d = s.button === 0 && s.ctrlKey === !0, u = s.button === 2 || d;
            a.current = u;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: _(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Dh = l.forwardRef(
  (e, t) => {
    const o = Ke(gt, e.__scopePopover), n = l.useRef(!1), r = l.useRef(!1);
    return /* @__PURE__ */ c(
      Il,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          e.onCloseAutoFocus?.(a), a.defaultPrevented || (n.current || o.triggerRef.current?.focus(), a.preventDefault()), n.current = !1, r.current = !1;
        },
        onInteractOutside: (a) => {
          e.onInteractOutside?.(a), a.defaultPrevented || (n.current = !0, a.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const i = a.target;
          o.triggerRef.current?.contains(i) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && r.current && a.preventDefault();
        }
      }
    );
  }
), Il = l.forwardRef(
  (e, t) => {
    const {
      __scopePopover: o,
      trapFocus: n,
      onOpenAutoFocus: r,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: s,
      onPointerDownOutside: d,
      onFocusOutside: u,
      onInteractOutside: f,
      ...p
    } = e, m = Ke(gt, o), h = Wt(o);
    return So(), /* @__PURE__ */ c(
      Dt,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: r,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ c(
          wt,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: f,
            onEscapeKeyDown: s,
            onPointerDownOutside: d,
            onFocusOutside: u,
            onDismiss: () => m.onOpenChange(!1),
            children: /* @__PURE__ */ c(
              Do,
              {
                "data-state": Dl(m.open),
                role: "dialog",
                id: m.contentId,
                ...h,
                ...p,
                ref: t,
                style: {
                  ...p.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Ml = "PopoverClose", Oh = l.forwardRef(
  (e, t) => {
    const { __scopePopover: o, ...n } = e, r = Ke(Ml, o);
    return /* @__PURE__ */ c(
      I.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: _(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
Oh.displayName = Ml;
var Lh = "PopoverArrow", zh = l.forwardRef(
  (e, t) => {
    const { __scopePopover: o, ...n } = e, r = Wt(o);
    return /* @__PURE__ */ c(Oo, { ...r, ...n, ref: t });
  }
);
zh.displayName = Lh;
function Dl(e) {
  return e ? "open" : "closed";
}
var $h = Pl, Fh = Tl, Bh = Nl, Vh = kl, xr = "Progress", yr = 100, [Gh] = ae(xr), [Wh, Hh] = Gh(xr), Ol = l.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: o,
      value: n = null,
      max: r,
      getValueLabel: a = Uh,
      ...i
    } = e;
    (r || r === 0) && !ga(r) && console.error(Kh(`${r}`, "Progress"));
    const s = ga(r) ? r : yr;
    n !== null && !ha(n, s) && console.error(jh(`${n}`, "Progress"));
    const d = ha(n, s) ? n : null, u = po(d) ? a(d, s) : void 0;
    return /* @__PURE__ */ c(Wh, { scope: o, value: d, max: s, children: /* @__PURE__ */ c(
      I.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": po(d) ? d : void 0,
        "aria-valuetext": u,
        role: "progressbar",
        "data-state": $l(d, s),
        "data-value": d ?? void 0,
        "data-max": s,
        ...i,
        ref: t
      }
    ) });
  }
);
Ol.displayName = xr;
var Ll = "ProgressIndicator", zl = l.forwardRef(
  (e, t) => {
    const { __scopeProgress: o, ...n } = e, r = Hh(Ll, o);
    return /* @__PURE__ */ c(
      I.div,
      {
        "data-state": $l(r.value, r.max),
        "data-value": r.value ?? void 0,
        "data-max": r.max,
        ...n,
        ref: t
      }
    );
  }
);
zl.displayName = Ll;
function Uh(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function $l(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function po(e) {
  return typeof e == "number";
}
function ga(e) {
  return po(e) && !isNaN(e) && e > 0;
}
function ha(e, t) {
  return po(e) && !isNaN(e) && e <= t && e >= 0;
}
function Kh(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${yr}\`.`;
}
function jh(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${yr} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var Yh = Ol, Xh = zl;
function qh(e, t) {
  return l.useReducer((o, n) => t[o][n] ?? o, e);
}
var Cr = "ScrollArea", [Fl] = ae(Cr), [Zh, we] = Fl(Cr), Bl = l.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: o,
      type: n = "hover",
      dir: r,
      scrollHideDelay: a = 600,
      ...i
    } = e, [s, d] = l.useState(null), [u, f] = l.useState(null), [p, m] = l.useState(null), [h, b] = l.useState(null), [g, v] = l.useState(null), [w, x] = l.useState(0), [y, C] = l.useState(0), [R, A] = l.useState(!1), [P, S] = l.useState(!1), N = B(t, (F) => d(F)), $ = nt(r);
    return /* @__PURE__ */ c(
      Zh,
      {
        scope: o,
        type: n,
        dir: $,
        scrollHideDelay: a,
        scrollArea: s,
        viewport: u,
        onViewportChange: f,
        content: p,
        onContentChange: m,
        scrollbarX: h,
        onScrollbarXChange: b,
        scrollbarXEnabled: R,
        onScrollbarXEnabledChange: A,
        scrollbarY: g,
        onScrollbarYChange: v,
        scrollbarYEnabled: P,
        onScrollbarYEnabledChange: S,
        onCornerWidthChange: x,
        onCornerHeightChange: C,
        children: /* @__PURE__ */ c(
          I.div,
          {
            dir: $,
            ...i,
            ref: N,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": y + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Bl.displayName = Cr;
var Vl = "ScrollAreaViewport", Gl = l.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: o, children: n, nonce: r, ...a } = e, i = we(Vl, o), s = l.useRef(null), d = B(t, s, i.onViewportChange);
    return /* @__PURE__ */ Y(Fe, { children: [
      /* @__PURE__ */ c(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ c(
        I.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...a,
          ref: d,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ c("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: n })
        }
      )
    ] });
  }
);
Gl.displayName = Vl;
var Te = "ScrollAreaScrollbar", Wl = l.forwardRef(
  (e, t) => {
    const { forceMount: o, ...n } = e, r = we(Te, e.__scopeScrollArea), { onScrollbarXEnabledChange: a, onScrollbarYEnabledChange: i } = r, s = e.orientation === "horizontal";
    return l.useEffect(() => (s ? a(!0) : i(!0), () => {
      s ? a(!1) : i(!1);
    }), [s, a, i]), r.type === "hover" ? /* @__PURE__ */ c(Qh, { ...n, ref: t, forceMount: o }) : r.type === "scroll" ? /* @__PURE__ */ c(Jh, { ...n, ref: t, forceMount: o }) : r.type === "auto" ? /* @__PURE__ */ c(Hl, { ...n, ref: t, forceMount: o }) : r.type === "always" ? /* @__PURE__ */ c(Sr, { ...n, ref: t }) : null;
  }
);
Wl.displayName = Te;
var Qh = l.forwardRef((e, t) => {
  const { forceMount: o, ...n } = e, r = we(Te, e.__scopeScrollArea), [a, i] = l.useState(!1);
  return l.useEffect(() => {
    const s = r.scrollArea;
    let d = 0;
    if (s) {
      const u = () => {
        window.clearTimeout(d), i(!0);
      }, f = () => {
        d = window.setTimeout(() => i(!1), r.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", u), s.addEventListener("pointerleave", f), () => {
        window.clearTimeout(d), s.removeEventListener("pointerenter", u), s.removeEventListener("pointerleave", f);
      };
    }
  }, [r.scrollArea, r.scrollHideDelay]), /* @__PURE__ */ c(se, { present: o || a, children: /* @__PURE__ */ c(
    Hl,
    {
      "data-state": a ? "visible" : "hidden",
      ...n,
      ref: t
    }
  ) });
}), Jh = l.forwardRef((e, t) => {
  const { forceMount: o, ...n } = e, r = we(Te, e.__scopeScrollArea), a = e.orientation === "horizontal", i = Vo(() => d("SCROLL_END"), 100), [s, d] = qh("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return l.useEffect(() => {
    if (s === "idle") {
      const u = window.setTimeout(() => d("HIDE"), r.scrollHideDelay);
      return () => window.clearTimeout(u);
    }
  }, [s, r.scrollHideDelay, d]), l.useEffect(() => {
    const u = r.viewport, f = a ? "scrollLeft" : "scrollTop";
    if (u) {
      let p = u[f];
      const m = () => {
        const h = u[f];
        p !== h && (d("SCROLL"), i()), p = h;
      };
      return u.addEventListener("scroll", m), () => u.removeEventListener("scroll", m);
    }
  }, [r.viewport, a, d, i]), /* @__PURE__ */ c(se, { present: o || s !== "hidden", children: /* @__PURE__ */ c(
    Sr,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...n,
      ref: t,
      onPointerEnter: _(e.onPointerEnter, () => d("POINTER_ENTER")),
      onPointerLeave: _(e.onPointerLeave, () => d("POINTER_LEAVE"))
    }
  ) });
}), Hl = l.forwardRef((e, t) => {
  const o = we(Te, e.__scopeScrollArea), { forceMount: n, ...r } = e, [a, i] = l.useState(!1), s = e.orientation === "horizontal", d = Vo(() => {
    if (o.viewport) {
      const u = o.viewport.offsetWidth < o.viewport.scrollWidth, f = o.viewport.offsetHeight < o.viewport.scrollHeight;
      i(s ? u : f);
    }
  }, 10);
  return ht(o.viewport, d), ht(o.content, d), /* @__PURE__ */ c(se, { present: n || a, children: /* @__PURE__ */ c(
    Sr,
    {
      "data-state": a ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), Sr = l.forwardRef((e, t) => {
  const { orientation: o = "vertical", ...n } = e, r = we(Te, e.__scopeScrollArea), a = l.useRef(null), i = l.useRef(0), [s, d] = l.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), u = Xl(s.viewport, s.content), f = {
    ...n,
    sizes: s,
    onSizesChange: d,
    hasThumb: u > 0 && u < 1,
    onThumbChange: (m) => a.current = m,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (m) => i.current = m
  };
  function p(m, h) {
    return av(m, i.current, s, h);
  }
  return o === "horizontal" ? /* @__PURE__ */ c(
    ev,
    {
      ...f,
      ref: t,
      onThumbPositionChange: () => {
        if (r.viewport && a.current) {
          const m = r.viewport.scrollLeft, h = va(m, s, r.dir);
          a.current.style.transform = `translate3d(${h}px, 0, 0)`;
        }
      },
      onWheelScroll: (m) => {
        r.viewport && (r.viewport.scrollLeft = m);
      },
      onDragScroll: (m) => {
        r.viewport && (r.viewport.scrollLeft = p(m, r.dir));
      }
    }
  ) : o === "vertical" ? /* @__PURE__ */ c(
    tv,
    {
      ...f,
      ref: t,
      onThumbPositionChange: () => {
        if (r.viewport && a.current) {
          const m = r.viewport.scrollTop, h = va(m, s);
          a.current.style.transform = `translate3d(0, ${h}px, 0)`;
        }
      },
      onWheelScroll: (m) => {
        r.viewport && (r.viewport.scrollTop = m);
      },
      onDragScroll: (m) => {
        r.viewport && (r.viewport.scrollTop = p(m));
      }
    }
  ) : null;
}), ev = l.forwardRef((e, t) => {
  const { sizes: o, onSizesChange: n, ...r } = e, a = we(Te, e.__scopeScrollArea), [i, s] = l.useState(), d = l.useRef(null), u = B(t, d, a.onScrollbarXChange);
  return l.useEffect(() => {
    d.current && s(getComputedStyle(d.current));
  }, [d]), /* @__PURE__ */ c(
    Kl,
    {
      "data-orientation": "horizontal",
      ...r,
      ref: u,
      sizes: o,
      style: {
        bottom: 0,
        left: a.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: a.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Bo(o) + "px",
        ...e.style
      },
      onThumbPointerDown: (f) => e.onThumbPointerDown(f.x),
      onDragScroll: (f) => e.onDragScroll(f.x),
      onWheelScroll: (f, p) => {
        if (a.viewport) {
          const m = a.viewport.scrollLeft + f.deltaX;
          e.onWheelScroll(m), Zl(m, p) && f.preventDefault();
        }
      },
      onResize: () => {
        d.current && a.viewport && i && n({
          content: a.viewport.scrollWidth,
          viewport: a.viewport.offsetWidth,
          scrollbar: {
            size: d.current.clientWidth,
            paddingStart: go(i.paddingLeft),
            paddingEnd: go(i.paddingRight)
          }
        });
      }
    }
  );
}), tv = l.forwardRef((e, t) => {
  const { sizes: o, onSizesChange: n, ...r } = e, a = we(Te, e.__scopeScrollArea), [i, s] = l.useState(), d = l.useRef(null), u = B(t, d, a.onScrollbarYChange);
  return l.useEffect(() => {
    d.current && s(getComputedStyle(d.current));
  }, [d]), /* @__PURE__ */ c(
    Kl,
    {
      "data-orientation": "vertical",
      ...r,
      ref: u,
      sizes: o,
      style: {
        top: 0,
        right: a.dir === "ltr" ? 0 : void 0,
        left: a.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Bo(o) + "px",
        ...e.style
      },
      onThumbPointerDown: (f) => e.onThumbPointerDown(f.y),
      onDragScroll: (f) => e.onDragScroll(f.y),
      onWheelScroll: (f, p) => {
        if (a.viewport) {
          const m = a.viewport.scrollTop + f.deltaY;
          e.onWheelScroll(m), Zl(m, p) && f.preventDefault();
        }
      },
      onResize: () => {
        d.current && a.viewport && i && n({
          content: a.viewport.scrollHeight,
          viewport: a.viewport.offsetHeight,
          scrollbar: {
            size: d.current.clientHeight,
            paddingStart: go(i.paddingTop),
            paddingEnd: go(i.paddingBottom)
          }
        });
      }
    }
  );
}), [ov, Ul] = Fl(Te), Kl = l.forwardRef((e, t) => {
  const {
    __scopeScrollArea: o,
    sizes: n,
    hasThumb: r,
    onThumbChange: a,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: d,
    onDragScroll: u,
    onWheelScroll: f,
    onResize: p,
    ...m
  } = e, h = we(Te, o), [b, g] = l.useState(null), v = B(t, (N) => g(N)), w = l.useRef(null), x = l.useRef(""), y = h.viewport, C = n.content - n.viewport, R = re(f), A = re(d), P = Vo(p, 10);
  function S(N) {
    if (w.current) {
      const $ = N.clientX - w.current.left, F = N.clientY - w.current.top;
      u({ x: $, y: F });
    }
  }
  return l.useEffect(() => {
    const N = ($) => {
      const F = $.target;
      b?.contains(F) && R($, C);
    };
    return document.addEventListener("wheel", N, { passive: !1 }), () => document.removeEventListener("wheel", N, { passive: !1 });
  }, [y, b, C, R]), l.useEffect(A, [n, A]), ht(b, P), ht(h.content, P), /* @__PURE__ */ c(
    ov,
    {
      scope: o,
      scrollbar: b,
      hasThumb: r,
      onThumbChange: re(a),
      onThumbPointerUp: re(i),
      onThumbPositionChange: A,
      onThumbPointerDown: re(s),
      children: /* @__PURE__ */ c(
        I.div,
        {
          ...m,
          ref: v,
          style: { position: "absolute", ...m.style },
          onPointerDown: _(e.onPointerDown, (N) => {
            N.button === 0 && (N.target.setPointerCapture(N.pointerId), w.current = b.getBoundingClientRect(), x.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", h.viewport && (h.viewport.style.scrollBehavior = "auto"), S(N));
          }),
          onPointerMove: _(e.onPointerMove, S),
          onPointerUp: _(e.onPointerUp, (N) => {
            const $ = N.target;
            $.hasPointerCapture(N.pointerId) && $.releasePointerCapture(N.pointerId), document.body.style.webkitUserSelect = x.current, h.viewport && (h.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), mo = "ScrollAreaThumb", jl = l.forwardRef(
  (e, t) => {
    const { forceMount: o, ...n } = e, r = Ul(mo, e.__scopeScrollArea);
    return /* @__PURE__ */ c(se, { present: o || r.hasThumb, children: /* @__PURE__ */ c(nv, { ref: t, ...n }) });
  }
), nv = l.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: o, style: n, ...r } = e, a = we(mo, o), i = Ul(mo, o), { onThumbPositionChange: s } = i, d = B(
      t,
      (p) => i.onThumbChange(p)
    ), u = l.useRef(void 0), f = Vo(() => {
      u.current && (u.current(), u.current = void 0);
    }, 100);
    return l.useEffect(() => {
      const p = a.viewport;
      if (p) {
        const m = () => {
          if (f(), !u.current) {
            const h = iv(p, s);
            u.current = h, s();
          }
        };
        return s(), p.addEventListener("scroll", m), () => p.removeEventListener("scroll", m);
      }
    }, [a.viewport, f, s]), /* @__PURE__ */ c(
      I.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...r,
        ref: d,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...n
        },
        onPointerDownCapture: _(e.onPointerDownCapture, (p) => {
          const h = p.target.getBoundingClientRect(), b = p.clientX - h.left, g = p.clientY - h.top;
          i.onThumbPointerDown({ x: b, y: g });
        }),
        onPointerUp: _(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
jl.displayName = mo;
var Er = "ScrollAreaCorner", Yl = l.forwardRef(
  (e, t) => {
    const o = we(Er, e.__scopeScrollArea), n = !!(o.scrollbarX && o.scrollbarY);
    return o.type !== "scroll" && n ? /* @__PURE__ */ c(rv, { ...e, ref: t }) : null;
  }
);
Yl.displayName = Er;
var rv = l.forwardRef((e, t) => {
  const { __scopeScrollArea: o, ...n } = e, r = we(Er, o), [a, i] = l.useState(0), [s, d] = l.useState(0), u = !!(a && s);
  return ht(r.scrollbarX, () => {
    const f = r.scrollbarX?.offsetHeight || 0;
    r.onCornerHeightChange(f), d(f);
  }), ht(r.scrollbarY, () => {
    const f = r.scrollbarY?.offsetWidth || 0;
    r.onCornerWidthChange(f), i(f);
  }), u ? /* @__PURE__ */ c(
    I.div,
    {
      ...n,
      ref: t,
      style: {
        width: a,
        height: s,
        position: "absolute",
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function go(e) {
  return e ? parseInt(e, 10) : 0;
}
function Xl(e, t) {
  const o = e / t;
  return isNaN(o) ? 0 : o;
}
function Bo(e) {
  const t = Xl(e.viewport, e.content), o = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, n = (e.scrollbar.size - o) * t;
  return Math.max(n, 18);
}
function av(e, t, o, n = "ltr") {
  const r = Bo(o), a = r / 2, i = t || a, s = r - i, d = o.scrollbar.paddingStart + i, u = o.scrollbar.size - o.scrollbar.paddingEnd - s, f = o.content - o.viewport, p = n === "ltr" ? [0, f] : [f * -1, 0];
  return ql([d, u], p)(e);
}
function va(e, t, o = "ltr") {
  const n = Bo(t), r = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, a = t.scrollbar.size - r, i = t.content - t.viewport, s = a - n, d = o === "ltr" ? [0, i] : [i * -1, 0], u = kt(e, d);
  return ql([0, i], [0, s])(u);
}
function ql(e, t) {
  return (o) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (o - e[0]);
  };
}
function Zl(e, t) {
  return e > 0 && e < t;
}
var iv = (e, t = () => {
}) => {
  let o = { left: e.scrollLeft, top: e.scrollTop }, n = 0;
  return (function r() {
    const a = { left: e.scrollLeft, top: e.scrollTop }, i = o.left !== a.left, s = o.top !== a.top;
    (i || s) && t(), o = a, n = window.requestAnimationFrame(r);
  })(), () => window.cancelAnimationFrame(n);
};
function Vo(e, t) {
  const o = re(e), n = l.useRef(0);
  return l.useEffect(() => () => window.clearTimeout(n.current), []), l.useCallback(() => {
    window.clearTimeout(n.current), n.current = window.setTimeout(o, t);
  }, [o, t]);
}
function ht(e, t) {
  const o = re(t);
  oe(() => {
    let n = 0;
    if (e) {
      const r = new ResizeObserver(() => {
        cancelAnimationFrame(n), n = window.requestAnimationFrame(o);
      });
      return r.observe(e), () => {
        window.cancelAnimationFrame(n), r.unobserve(e);
      };
    }
  }, [e, o]);
}
var sv = Bl, lv = Gl, cv = Yl, dv = [" ", "Enter", "ArrowUp", "ArrowDown"], uv = [" ", "Enter"], et = "Select", [Go, Wo, fv] = Mt(et), [St] = ae(et, [
  fv,
  He
]), Ho = He(), [pv, je] = St(et), [mv, gv] = St(et), Ql = (e) => {
  const {
    __scopeSelect: t,
    children: o,
    open: n,
    defaultOpen: r,
    onOpenChange: a,
    value: i,
    defaultValue: s,
    onValueChange: d,
    dir: u,
    name: f,
    autoComplete: p,
    disabled: m,
    required: h,
    form: b
  } = e, g = Ho(t), [v, w] = l.useState(null), [x, y] = l.useState(null), [C, R] = l.useState(!1), A = nt(u), [P, S] = le({
    prop: n,
    defaultProp: r ?? !1,
    onChange: a,
    caller: et
  }), [N, $] = le({
    prop: i,
    defaultProp: s,
    onChange: d,
    caller: et
  }), F = l.useRef(null), V = v ? b || !!v.closest("form") : !0, [H, W] = l.useState(/* @__PURE__ */ new Set()), K = Array.from(H).map((z) => z.props.value).join(";");
  return /* @__PURE__ */ c(zt, { ...g, children: /* @__PURE__ */ Y(
    pv,
    {
      required: h,
      scope: t,
      trigger: v,
      onTriggerChange: w,
      valueNode: x,
      onValueNodeChange: y,
      valueNodeHasChildren: C,
      onValueNodeHasChildrenChange: R,
      contentId: fe(),
      value: N,
      onValueChange: $,
      open: P,
      onOpenChange: S,
      dir: A,
      triggerPointerDownPosRef: F,
      disabled: m,
      children: [
        /* @__PURE__ */ c(Go.Provider, { scope: t, children: /* @__PURE__ */ c(
          mv,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: l.useCallback((z) => {
              W((G) => new Set(G).add(z));
            }, []),
            onNativeOptionRemove: l.useCallback((z) => {
              W((G) => {
                const O = new Set(G);
                return O.delete(z), O;
              });
            }, []),
            children: o
          }
        ) }),
        V ? /* @__PURE__ */ Y(
          Sc,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: f,
            autoComplete: p,
            value: N,
            onChange: (z) => $(z.target.value),
            disabled: m,
            form: b,
            children: [
              N === void 0 ? /* @__PURE__ */ c("option", { value: "" }) : null,
              Array.from(H)
            ]
          },
          K
        ) : null
      ]
    }
  ) });
};
Ql.displayName = et;
var Jl = "SelectTrigger", ec = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, disabled: n = !1, ...r } = e, a = Ho(o), i = je(Jl, o), s = i.disabled || n, d = B(t, i.onTriggerChange), u = Wo(o), f = l.useRef("touch"), [p, m, h] = Rc((g) => {
      const v = u().filter((y) => !y.disabled), w = v.find((y) => y.value === i.value), x = Pc(v, g, w);
      x !== void 0 && i.onValueChange(x.value);
    }), b = (g) => {
      s || (i.onOpenChange(!0), h()), g && (i.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ c($t, { asChild: !0, ...a, children: /* @__PURE__ */ c(
      I.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": Ec(i.value) ? "" : void 0,
        ...r,
        ref: d,
        onClick: _(r.onClick, (g) => {
          g.currentTarget.focus(), f.current !== "mouse" && b(g);
        }),
        onPointerDown: _(r.onPointerDown, (g) => {
          f.current = g.pointerType;
          const v = g.target;
          v.hasPointerCapture(g.pointerId) && v.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (b(g), g.preventDefault());
        }),
        onKeyDown: _(r.onKeyDown, (g) => {
          const v = p.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && m(g.key), !(v && g.key === " ") && dv.includes(g.key) && (b(), g.preventDefault());
        })
      }
    ) });
  }
);
ec.displayName = Jl;
var tc = "SelectValue", oc = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, className: n, style: r, children: a, placeholder: i = "", ...s } = e, d = je(tc, o), { onValueNodeHasChildrenChange: u } = d, f = a !== void 0, p = B(t, d.onValueNodeChange);
    return oe(() => {
      u(f);
    }, [u, f]), /* @__PURE__ */ c(
      I.span,
      {
        ...s,
        ref: p,
        style: { pointerEvents: "none" },
        children: Ec(d.value) ? /* @__PURE__ */ c(Fe, { children: i }) : a
      }
    );
  }
);
oc.displayName = tc;
var hv = "SelectIcon", nc = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, children: n, ...r } = e;
    return /* @__PURE__ */ c(I.span, { "aria-hidden": !0, ...r, ref: t, children: n || "▼" });
  }
);
nc.displayName = hv;
var vv = "SelectPortal", rc = (e) => /* @__PURE__ */ c(xt, { asChild: !0, ...e });
rc.displayName = vv;
var tt = "SelectContent", ac = l.forwardRef(
  (e, t) => {
    const o = je(tt, e.__scopeSelect), [n, r] = l.useState();
    if (oe(() => {
      r(new DocumentFragment());
    }, []), !o.open) {
      const a = n;
      return a ? bo.createPortal(
        /* @__PURE__ */ c(ic, { scope: e.__scopeSelect, children: /* @__PURE__ */ c(Go.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ c("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ c(sc, { ...e, ref: t });
  }
);
ac.displayName = tt;
var xe = 10, [ic, Ye] = St(tt), bv = "SelectContentImpl", wv = /* @__PURE__ */ Be("SelectContent.RemoveScroll"), sc = l.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: o,
      position: n = "item-aligned",
      onCloseAutoFocus: r,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: s,
      sideOffset: d,
      align: u,
      alignOffset: f,
      arrowPadding: p,
      collisionBoundary: m,
      collisionPadding: h,
      sticky: b,
      hideWhenDetached: g,
      avoidCollisions: v,
      //
      ...w
    } = e, x = je(tt, o), [y, C] = l.useState(null), [R, A] = l.useState(null), P = B(t, (M) => C(M)), [S, N] = l.useState(null), [$, F] = l.useState(
      null
    ), V = Wo(o), [H, W] = l.useState(!1), K = l.useRef(!1);
    l.useEffect(() => {
      if (y) return Ro(y);
    }, [y]), So();
    const z = l.useCallback(
      (M) => {
        const [Q, ...j] = V().map((te) => te.ref.current), [J] = j.slice(-1), Z = document.activeElement;
        for (const te of M)
          if (te === Z || (te?.scrollIntoView({ block: "nearest" }), te === Q && R && (R.scrollTop = 0), te === J && R && (R.scrollTop = R.scrollHeight), te?.focus(), document.activeElement !== Z)) return;
      },
      [V, R]
    ), G = l.useCallback(
      () => z([S, y]),
      [z, S, y]
    );
    l.useEffect(() => {
      H && G();
    }, [H, G]);
    const { onOpenChange: O, triggerPointerDownPosRef: T } = x;
    l.useEffect(() => {
      if (y) {
        let M = { x: 0, y: 0 };
        const Q = (J) => {
          M = {
            x: Math.abs(Math.round(J.pageX) - (T.current?.x ?? 0)),
            y: Math.abs(Math.round(J.pageY) - (T.current?.y ?? 0))
          };
        }, j = (J) => {
          M.x <= 10 && M.y <= 10 ? J.preventDefault() : y.contains(J.target) || O(!1), document.removeEventListener("pointermove", Q), T.current = null;
        };
        return T.current !== null && (document.addEventListener("pointermove", Q), document.addEventListener("pointerup", j, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Q), document.removeEventListener("pointerup", j, { capture: !0 });
        };
      }
    }, [y, O, T]), l.useEffect(() => {
      const M = () => O(!1);
      return window.addEventListener("blur", M), window.addEventListener("resize", M), () => {
        window.removeEventListener("blur", M), window.removeEventListener("resize", M);
      };
    }, [O]);
    const [k, ie] = Rc((M) => {
      const Q = V().filter((Z) => !Z.disabled), j = Q.find((Z) => Z.ref.current === document.activeElement), J = Pc(Q, M, j);
      J && setTimeout(() => J.ref.current.focus());
    }), pe = l.useCallback(
      (M, Q, j) => {
        const J = !K.current && !j;
        (x.value !== void 0 && x.value === Q || J) && (N(M), J && (K.current = !0));
      },
      [x.value]
    ), he = l.useCallback(() => y?.focus(), [y]), ce = l.useCallback(
      (M, Q, j) => {
        const J = !K.current && !j;
        (x.value !== void 0 && x.value === Q || J) && F(M);
      },
      [x.value]
    ), ee = n === "popper" ? Rn : lc, q = ee === Rn ? {
      side: s,
      sideOffset: d,
      align: u,
      alignOffset: f,
      arrowPadding: p,
      collisionBoundary: m,
      collisionPadding: h,
      sticky: b,
      hideWhenDetached: g,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ c(
      ic,
      {
        scope: o,
        content: y,
        viewport: R,
        onViewportChange: A,
        itemRefCallback: pe,
        selectedItem: S,
        onItemLeave: he,
        itemTextRefCallback: ce,
        focusSelectedItem: G,
        selectedItemText: $,
        position: n,
        isPositioned: H,
        searchRef: k,
        children: /* @__PURE__ */ c(Ot, { as: wv, allowPinchZoom: !0, children: /* @__PURE__ */ c(
          Dt,
          {
            asChild: !0,
            trapped: x.open,
            onMountAutoFocus: (M) => {
              M.preventDefault();
            },
            onUnmountAutoFocus: _(r, (M) => {
              x.trigger?.focus({ preventScroll: !0 }), M.preventDefault();
            }),
            children: /* @__PURE__ */ c(
              wt,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: i,
                onFocusOutside: (M) => M.preventDefault(),
                onDismiss: () => x.onOpenChange(!1),
                children: /* @__PURE__ */ c(
                  ee,
                  {
                    role: "listbox",
                    id: x.contentId,
                    "data-state": x.open ? "open" : "closed",
                    dir: x.dir,
                    onContextMenu: (M) => M.preventDefault(),
                    ...w,
                    ...q,
                    onPlaced: () => W(!0),
                    ref: P,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: _(w.onKeyDown, (M) => {
                      const Q = M.ctrlKey || M.altKey || M.metaKey;
                      if (M.key === "Tab" && M.preventDefault(), !Q && M.key.length === 1 && ie(M.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(M.key)) {
                        let J = V().filter((Z) => !Z.disabled).map((Z) => Z.ref.current);
                        if (["ArrowUp", "End"].includes(M.key) && (J = J.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(M.key)) {
                          const Z = M.target, te = J.indexOf(Z);
                          J = J.slice(te + 1);
                        }
                        setTimeout(() => z(J)), M.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
sc.displayName = bv;
var xv = "SelectItemAlignedPosition", lc = l.forwardRef((e, t) => {
  const { __scopeSelect: o, onPlaced: n, ...r } = e, a = je(tt, o), i = Ye(tt, o), [s, d] = l.useState(null), [u, f] = l.useState(null), p = B(t, (P) => f(P)), m = Wo(o), h = l.useRef(!1), b = l.useRef(!0), { viewport: g, selectedItem: v, selectedItemText: w, focusSelectedItem: x } = i, y = l.useCallback(() => {
    if (a.trigger && a.valueNode && s && u && g && v && w) {
      const P = a.trigger.getBoundingClientRect(), S = u.getBoundingClientRect(), N = a.valueNode.getBoundingClientRect(), $ = w.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const Z = $.left - S.left, te = N.left - Z, de = P.left - te, ve = P.width + de, qo = Math.max(ve, S.width), Zo = window.innerWidth - xe, Qo = kt(te, [
          xe,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(xe, Zo - qo)
        ]);
        s.style.minWidth = ve + "px", s.style.left = Qo + "px";
      } else {
        const Z = S.right - $.right, te = window.innerWidth - N.right - Z, de = window.innerWidth - P.right - te, ve = P.width + de, qo = Math.max(ve, S.width), Zo = window.innerWidth - xe, Qo = kt(te, [
          xe,
          Math.max(xe, Zo - qo)
        ]);
        s.style.minWidth = ve + "px", s.style.right = Qo + "px";
      }
      const F = m(), V = window.innerHeight - xe * 2, H = g.scrollHeight, W = window.getComputedStyle(u), K = parseInt(W.borderTopWidth, 10), z = parseInt(W.paddingTop, 10), G = parseInt(W.borderBottomWidth, 10), O = parseInt(W.paddingBottom, 10), T = K + z + H + O + G, k = Math.min(v.offsetHeight * 5, T), ie = window.getComputedStyle(g), pe = parseInt(ie.paddingTop, 10), he = parseInt(ie.paddingBottom, 10), ce = P.top + P.height / 2 - xe, ee = V - ce, q = v.offsetHeight / 2, M = v.offsetTop + q, Q = K + z + M, j = T - Q;
      if (Q <= ce) {
        const Z = F.length > 0 && v === F[F.length - 1].ref.current;
        s.style.bottom = "0px";
        const te = u.clientHeight - g.offsetTop - g.offsetHeight, de = Math.max(
          ee,
          q + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (Z ? he : 0) + te + G
        ), ve = Q + de;
        s.style.height = ve + "px";
      } else {
        const Z = F.length > 0 && v === F[0].ref.current;
        s.style.top = "0px";
        const de = Math.max(
          ce,
          K + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (Z ? pe : 0) + q
        ) + j;
        s.style.height = de + "px", g.scrollTop = Q - ce + g.offsetTop;
      }
      s.style.margin = `${xe}px 0`, s.style.minHeight = k + "px", s.style.maxHeight = V + "px", n?.(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    m,
    a.trigger,
    a.valueNode,
    s,
    u,
    g,
    v,
    w,
    a.dir,
    n
  ]);
  oe(() => y(), [y]);
  const [C, R] = l.useState();
  oe(() => {
    u && R(window.getComputedStyle(u).zIndex);
  }, [u]);
  const A = l.useCallback(
    (P) => {
      P && b.current === !0 && (y(), x?.(), b.current = !1);
    },
    [y, x]
  );
  return /* @__PURE__ */ c(
    Cv,
    {
      scope: o,
      contentWrapper: s,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: A,
      children: /* @__PURE__ */ c(
        "div",
        {
          ref: d,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: C
          },
          children: /* @__PURE__ */ c(
            I.div,
            {
              ...r,
              ref: p,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...r.style
              }
            }
          )
        }
      )
    }
  );
});
lc.displayName = xv;
var yv = "SelectPopperPosition", Rn = l.forwardRef((e, t) => {
  const {
    __scopeSelect: o,
    align: n = "start",
    collisionPadding: r = xe,
    ...a
  } = e, i = Ho(o);
  return /* @__PURE__ */ c(
    Do,
    {
      ...i,
      ...a,
      ref: t,
      align: n,
      collisionPadding: r,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Rn.displayName = yv;
var [Cv, Rr] = St(tt, {}), Pn = "SelectViewport", cc = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, nonce: n, ...r } = e, a = Ye(Pn, o), i = Rr(Pn, o), s = B(t, a.onViewportChange), d = l.useRef(0);
    return /* @__PURE__ */ Y(Fe, { children: [
      /* @__PURE__ */ c(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ c(Go.Slot, { scope: o, children: /* @__PURE__ */ c(
        I.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...r,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...r.style
          },
          onScroll: _(r.onScroll, (u) => {
            const f = u.currentTarget, { contentWrapper: p, shouldExpandOnScrollRef: m } = i;
            if (m?.current && p) {
              const h = Math.abs(d.current - f.scrollTop);
              if (h > 0) {
                const b = window.innerHeight - xe * 2, g = parseFloat(p.style.minHeight), v = parseFloat(p.style.height), w = Math.max(g, v);
                if (w < b) {
                  const x = w + h, y = Math.min(b, x), C = x - y;
                  p.style.height = y + "px", p.style.bottom === "0px" && (f.scrollTop = C > 0 ? C : 0, p.style.justifyContent = "flex-end");
                }
              }
            }
            d.current = f.scrollTop;
          })
        }
      ) })
    ] });
  }
);
cc.displayName = Pn;
var dc = "SelectGroup", [Sv, Ev] = St(dc), uc = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, ...n } = e, r = fe();
    return /* @__PURE__ */ c(Sv, { scope: o, id: r, children: /* @__PURE__ */ c(I.div, { role: "group", "aria-labelledby": r, ...n, ref: t }) });
  }
);
uc.displayName = dc;
var fc = "SelectLabel", pc = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, ...n } = e, r = Ev(fc, o);
    return /* @__PURE__ */ c(I.div, { id: r.id, ...n, ref: t });
  }
);
pc.displayName = fc;
var ho = "SelectItem", [Rv, mc] = St(ho), gc = l.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: o,
      value: n,
      disabled: r = !1,
      textValue: a,
      ...i
    } = e, s = je(ho, o), d = Ye(ho, o), u = s.value === n, [f, p] = l.useState(a ?? ""), [m, h] = l.useState(!1), b = B(
      t,
      (x) => d.itemRefCallback?.(x, n, r)
    ), g = fe(), v = l.useRef("touch"), w = () => {
      r || (s.onValueChange(n), s.onOpenChange(!1));
    };
    if (n === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ c(
      Rv,
      {
        scope: o,
        value: n,
        disabled: r,
        textId: g,
        isSelected: u,
        onItemTextChange: l.useCallback((x) => {
          p((y) => y || (x?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ c(
          Go.ItemSlot,
          {
            scope: o,
            value: n,
            disabled: r,
            textValue: f,
            children: /* @__PURE__ */ c(
              I.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": u && m,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": r || void 0,
                "data-disabled": r ? "" : void 0,
                tabIndex: r ? void 0 : -1,
                ...i,
                ref: b,
                onFocus: _(i.onFocus, () => h(!0)),
                onBlur: _(i.onBlur, () => h(!1)),
                onClick: _(i.onClick, () => {
                  v.current !== "mouse" && w();
                }),
                onPointerUp: _(i.onPointerUp, () => {
                  v.current === "mouse" && w();
                }),
                onPointerDown: _(i.onPointerDown, (x) => {
                  v.current = x.pointerType;
                }),
                onPointerMove: _(i.onPointerMove, (x) => {
                  v.current = x.pointerType, r ? d.onItemLeave?.() : v.current === "mouse" && x.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: _(i.onPointerLeave, (x) => {
                  x.currentTarget === document.activeElement && d.onItemLeave?.();
                }),
                onKeyDown: _(i.onKeyDown, (x) => {
                  d.searchRef?.current !== "" && x.key === " " || (uv.includes(x.key) && w(), x.key === " " && x.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
gc.displayName = ho;
var At = "SelectItemText", hc = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, className: n, style: r, ...a } = e, i = je(At, o), s = Ye(At, o), d = mc(At, o), u = gv(At, o), [f, p] = l.useState(null), m = B(
      t,
      (w) => p(w),
      d.onItemTextChange,
      (w) => s.itemTextRefCallback?.(w, d.value, d.disabled)
    ), h = f?.textContent, b = l.useMemo(
      () => /* @__PURE__ */ c("option", { value: d.value, disabled: d.disabled, children: h }, d.value),
      [d.disabled, d.value, h]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: v } = u;
    return oe(() => (g(b), () => v(b)), [g, v, b]), /* @__PURE__ */ Y(Fe, { children: [
      /* @__PURE__ */ c(I.span, { id: d.textId, ...a, ref: m }),
      d.isSelected && i.valueNode && !i.valueNodeHasChildren ? bo.createPortal(a.children, i.valueNode) : null
    ] });
  }
);
hc.displayName = At;
var vc = "SelectItemIndicator", bc = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, ...n } = e;
    return mc(vc, o).isSelected ? /* @__PURE__ */ c(I.span, { "aria-hidden": !0, ...n, ref: t }) : null;
  }
);
bc.displayName = vc;
var An = "SelectScrollUpButton", wc = l.forwardRef((e, t) => {
  const o = Ye(An, e.__scopeSelect), n = Rr(An, e.__scopeSelect), [r, a] = l.useState(!1), i = B(t, n.onScrollButtonChange);
  return oe(() => {
    if (o.viewport && o.isPositioned) {
      let s = function() {
        const u = d.scrollTop > 0;
        a(u);
      };
      const d = o.viewport;
      return s(), d.addEventListener("scroll", s), () => d.removeEventListener("scroll", s);
    }
  }, [o.viewport, o.isPositioned]), r ? /* @__PURE__ */ c(
    yc,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: d } = o;
        s && d && (s.scrollTop = s.scrollTop - d.offsetHeight);
      }
    }
  ) : null;
});
wc.displayName = An;
var _n = "SelectScrollDownButton", xc = l.forwardRef((e, t) => {
  const o = Ye(_n, e.__scopeSelect), n = Rr(_n, e.__scopeSelect), [r, a] = l.useState(!1), i = B(t, n.onScrollButtonChange);
  return oe(() => {
    if (o.viewport && o.isPositioned) {
      let s = function() {
        const u = d.scrollHeight - d.clientHeight, f = Math.ceil(d.scrollTop) < u;
        a(f);
      };
      const d = o.viewport;
      return s(), d.addEventListener("scroll", s), () => d.removeEventListener("scroll", s);
    }
  }, [o.viewport, o.isPositioned]), r ? /* @__PURE__ */ c(
    yc,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: d } = o;
        s && d && (s.scrollTop = s.scrollTop + d.offsetHeight);
      }
    }
  ) : null;
});
xc.displayName = _n;
var yc = l.forwardRef((e, t) => {
  const { __scopeSelect: o, onAutoScroll: n, ...r } = e, a = Ye("SelectScrollButton", o), i = l.useRef(null), s = Wo(o), d = l.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return l.useEffect(() => () => d(), [d]), oe(() => {
    s().find((f) => f.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ c(
    I.div,
    {
      "aria-hidden": !0,
      ...r,
      ref: t,
      style: { flexShrink: 0, ...r.style },
      onPointerDown: _(r.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(n, 50));
      }),
      onPointerMove: _(r.onPointerMove, () => {
        a.onItemLeave?.(), i.current === null && (i.current = window.setInterval(n, 50));
      }),
      onPointerLeave: _(r.onPointerLeave, () => {
        d();
      })
    }
  );
}), Pv = "SelectSeparator", Cc = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, ...n } = e;
    return /* @__PURE__ */ c(I.div, { "aria-hidden": !0, ...n, ref: t });
  }
);
Cc.displayName = Pv;
var Tn = "SelectArrow", Av = l.forwardRef(
  (e, t) => {
    const { __scopeSelect: o, ...n } = e, r = Ho(o), a = je(Tn, o), i = Ye(Tn, o);
    return a.open && i.position === "popper" ? /* @__PURE__ */ c(Oo, { ...r, ...n, ref: t }) : null;
  }
);
Av.displayName = Tn;
var _v = "SelectBubbleInput", Sc = l.forwardRef(
  ({ __scopeSelect: e, value: t, ...o }, n) => {
    const r = l.useRef(null), a = B(n, r), i = Ao(t);
    return l.useEffect(() => {
      const s = r.current;
      if (!s) return;
      const d = window.HTMLSelectElement.prototype, f = Object.getOwnPropertyDescriptor(
        d,
        "value"
      ).set;
      if (i !== t && f) {
        const p = new Event("change", { bubbles: !0 });
        f.call(s, t), s.dispatchEvent(p);
      }
    }, [i, t]), /* @__PURE__ */ c(
      I.select,
      {
        ...o,
        style: { ...Ga, ...o.style },
        ref: a,
        defaultValue: t
      }
    );
  }
);
Sc.displayName = _v;
function Ec(e) {
  return e === "" || e === void 0;
}
function Rc(e) {
  const t = re(e), o = l.useRef(""), n = l.useRef(0), r = l.useCallback(
    (i) => {
      const s = o.current + i;
      t(s), (function d(u) {
        o.current = u, window.clearTimeout(n.current), u !== "" && (n.current = window.setTimeout(() => d(""), 1e3));
      })(s);
    },
    [t]
  ), a = l.useCallback(() => {
    o.current = "", window.clearTimeout(n.current);
  }, []);
  return l.useEffect(() => () => window.clearTimeout(n.current), []), [o, r, a];
}
function Pc(e, t, o) {
  const r = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, a = o ? e.indexOf(o) : -1;
  let i = Tv(e, Math.max(a, 0));
  r.length === 1 && (i = i.filter((u) => u !== o));
  const d = i.find(
    (u) => u.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return d !== o ? d : void 0;
}
function Tv(e, t) {
  return e.map((o, n) => e[(t + n) % e.length]);
}
var Nv = Ql, kv = ec, Iv = oc, Mv = nc, Dv = rc, Ov = ac, Lv = cc, zv = uc, $v = pc, Fv = gc, Bv = hc, Vv = bc, Gv = wc, Wv = xc, Hv = Cc, Uv = "Separator", ba = "horizontal", Kv = ["horizontal", "vertical"], Ac = l.forwardRef((e, t) => {
  const { decorative: o, orientation: n = ba, ...r } = e, a = jv(n) ? n : ba, s = o ? { role: "none" } : { "aria-orientation": a === "vertical" ? a : void 0, role: "separator" };
  return /* @__PURE__ */ c(
    I.div,
    {
      "data-orientation": a,
      ...s,
      ...r,
      ref: t
    }
  );
});
Ac.displayName = Uv;
function jv(e) {
  return Kv.includes(e);
}
var Yv = Ac, _c = ["PageUp", "PageDown"], Tc = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Nc = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, Et = "Slider", [Nn, Xv, qv] = Mt(Et), [kc] = ae(Et, [
  qv
]), [Zv, Uo] = kc(Et), Ic = l.forwardRef(
  (e, t) => {
    const {
      name: o,
      min: n = 0,
      max: r = 100,
      step: a = 1,
      orientation: i = "horizontal",
      disabled: s = !1,
      minStepsBetweenThumbs: d = 0,
      defaultValue: u = [n],
      value: f,
      onValueChange: p = () => {
      },
      onValueCommit: m = () => {
      },
      inverted: h = !1,
      form: b,
      ...g
    } = e, v = l.useRef(/* @__PURE__ */ new Set()), w = l.useRef(0), y = i === "horizontal" ? Qv : Jv, [C = [], R] = le({
      prop: f,
      defaultProp: u,
      onChange: (F) => {
        [...v.current][w.current]?.focus(), p(F);
      }
    }), A = l.useRef(C);
    function P(F) {
      const V = rb(C, F);
      $(F, V);
    }
    function S(F) {
      $(F, w.current);
    }
    function N() {
      const F = A.current[w.current];
      C[w.current] !== F && m(C);
    }
    function $(F, V, { commit: H } = { commit: !1 }) {
      const W = lb(a), K = cb(Math.round((F - n) / a) * a + n, W), z = kt(K, [n, r]);
      R((G = []) => {
        const O = ob(G, z, V);
        if (sb(O, d * a)) {
          w.current = O.indexOf(z);
          const T = String(O) !== String(G);
          return T && H && m(O), T ? O : G;
        } else
          return G;
      });
    }
    return /* @__PURE__ */ c(
      Zv,
      {
        scope: e.__scopeSlider,
        name: o,
        disabled: s,
        min: n,
        max: r,
        valueIndexToChangeRef: w,
        thumbs: v.current,
        values: C,
        orientation: i,
        form: b,
        children: /* @__PURE__ */ c(Nn.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ c(Nn.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ c(
          y,
          {
            "aria-disabled": s,
            "data-disabled": s ? "" : void 0,
            ...g,
            ref: t,
            onPointerDown: _(g.onPointerDown, () => {
              s || (A.current = C);
            }),
            min: n,
            max: r,
            inverted: h,
            onSlideStart: s ? void 0 : P,
            onSlideMove: s ? void 0 : S,
            onSlideEnd: s ? void 0 : N,
            onHomeKeyDown: () => !s && $(n, 0, { commit: !0 }),
            onEndKeyDown: () => !s && $(r, C.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: F, direction: V }) => {
              if (!s) {
                const K = _c.includes(F.key) || F.shiftKey && Tc.includes(F.key) ? 10 : 1, z = w.current, G = C[z], O = a * K * V;
                $(G + O, z, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
Ic.displayName = Et;
var [Mc, Dc] = kc(Et, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), Qv = l.forwardRef(
  (e, t) => {
    const {
      min: o,
      max: n,
      dir: r,
      inverted: a,
      onSlideStart: i,
      onSlideMove: s,
      onSlideEnd: d,
      onStepKeyDown: u,
      ...f
    } = e, [p, m] = l.useState(null), h = B(t, (y) => m(y)), b = l.useRef(void 0), g = nt(r), v = g === "ltr", w = v && !a || !v && a;
    function x(y) {
      const C = b.current || p.getBoundingClientRect(), R = [0, C.width], P = Pr(R, w ? [o, n] : [n, o]);
      return b.current = C, P(y - C.left);
    }
    return /* @__PURE__ */ c(
      Mc,
      {
        scope: e.__scopeSlider,
        startEdge: w ? "left" : "right",
        endEdge: w ? "right" : "left",
        direction: w ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ c(
          Oc,
          {
            dir: g,
            "data-orientation": "horizontal",
            ...f,
            ref: h,
            style: {
              ...f.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (y) => {
              const C = x(y.clientX);
              i?.(C);
            },
            onSlideMove: (y) => {
              const C = x(y.clientX);
              s?.(C);
            },
            onSlideEnd: () => {
              b.current = void 0, d?.();
            },
            onStepKeyDown: (y) => {
              const R = Nc[w ? "from-left" : "from-right"].includes(y.key);
              u?.({ event: y, direction: R ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Jv = l.forwardRef(
  (e, t) => {
    const {
      min: o,
      max: n,
      inverted: r,
      onSlideStart: a,
      onSlideMove: i,
      onSlideEnd: s,
      onStepKeyDown: d,
      ...u
    } = e, f = l.useRef(null), p = B(t, f), m = l.useRef(void 0), h = !r;
    function b(g) {
      const v = m.current || f.current.getBoundingClientRect(), w = [0, v.height], y = Pr(w, h ? [n, o] : [o, n]);
      return m.current = v, y(g - v.top);
    }
    return /* @__PURE__ */ c(
      Mc,
      {
        scope: e.__scopeSlider,
        startEdge: h ? "bottom" : "top",
        endEdge: h ? "top" : "bottom",
        size: "height",
        direction: h ? 1 : -1,
        children: /* @__PURE__ */ c(
          Oc,
          {
            "data-orientation": "vertical",
            ...u,
            ref: p,
            style: {
              ...u.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (g) => {
              const v = b(g.clientY);
              a?.(v);
            },
            onSlideMove: (g) => {
              const v = b(g.clientY);
              i?.(v);
            },
            onSlideEnd: () => {
              m.current = void 0, s?.();
            },
            onStepKeyDown: (g) => {
              const w = Nc[h ? "from-bottom" : "from-top"].includes(g.key);
              d?.({ event: g, direction: w ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Oc = l.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: o,
      onSlideStart: n,
      onSlideMove: r,
      onSlideEnd: a,
      onHomeKeyDown: i,
      onEndKeyDown: s,
      onStepKeyDown: d,
      ...u
    } = e, f = Uo(Et, o);
    return /* @__PURE__ */ c(
      I.span,
      {
        ...u,
        ref: t,
        onKeyDown: _(e.onKeyDown, (p) => {
          p.key === "Home" ? (i(p), p.preventDefault()) : p.key === "End" ? (s(p), p.preventDefault()) : _c.concat(Tc).includes(p.key) && (d(p), p.preventDefault());
        }),
        onPointerDown: _(e.onPointerDown, (p) => {
          const m = p.target;
          m.setPointerCapture(p.pointerId), p.preventDefault(), f.thumbs.has(m) ? m.focus() : n(p);
        }),
        onPointerMove: _(e.onPointerMove, (p) => {
          p.target.hasPointerCapture(p.pointerId) && r(p);
        }),
        onPointerUp: _(e.onPointerUp, (p) => {
          const m = p.target;
          m.hasPointerCapture(p.pointerId) && (m.releasePointerCapture(p.pointerId), a(p));
        })
      }
    );
  }
), Lc = "SliderTrack", zc = l.forwardRef(
  (e, t) => {
    const { __scopeSlider: o, ...n } = e, r = Uo(Lc, o);
    return /* @__PURE__ */ c(
      I.span,
      {
        "data-disabled": r.disabled ? "" : void 0,
        "data-orientation": r.orientation,
        ...n,
        ref: t
      }
    );
  }
);
zc.displayName = Lc;
var kn = "SliderRange", $c = l.forwardRef(
  (e, t) => {
    const { __scopeSlider: o, ...n } = e, r = Uo(kn, o), a = Dc(kn, o), i = l.useRef(null), s = B(t, i), d = r.values.length, u = r.values.map(
      (m) => Vc(m, r.min, r.max)
    ), f = d > 1 ? Math.min(...u) : 0, p = 100 - Math.max(...u);
    return /* @__PURE__ */ c(
      I.span,
      {
        "data-orientation": r.orientation,
        "data-disabled": r.disabled ? "" : void 0,
        ...n,
        ref: s,
        style: {
          ...e.style,
          [a.startEdge]: f + "%",
          [a.endEdge]: p + "%"
        }
      }
    );
  }
);
$c.displayName = kn;
var In = "SliderThumb", Fc = l.forwardRef(
  (e, t) => {
    const o = Xv(e.__scopeSlider), [n, r] = l.useState(null), a = B(t, (s) => r(s)), i = l.useMemo(
      () => n ? o().findIndex((s) => s.ref.current === n) : -1,
      [o, n]
    );
    return /* @__PURE__ */ c(eb, { ...e, ref: a, index: i });
  }
), eb = l.forwardRef(
  (e, t) => {
    const { __scopeSlider: o, index: n, name: r, ...a } = e, i = Uo(In, o), s = Dc(In, o), [d, u] = l.useState(null), f = B(t, (x) => u(x)), p = d ? i.form || !!d.closest("form") : !0, m = _o(d), h = i.values[n], b = h === void 0 ? 0 : Vc(h, i.min, i.max), g = nb(n, i.values.length), v = m?.[s.size], w = v ? ab(v, b, s.direction) : 0;
    return l.useEffect(() => {
      if (d)
        return i.thumbs.add(d), () => {
          i.thumbs.delete(d);
        };
    }, [d, i.thumbs]), /* @__PURE__ */ Y(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [s.startEdge]: `calc(${b}% + ${w}px)`
        },
        children: [
          /* @__PURE__ */ c(Nn.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ c(
            I.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || g,
              "aria-valuemin": i.min,
              "aria-valuenow": h,
              "aria-valuemax": i.max,
              "aria-orientation": i.orientation,
              "data-orientation": i.orientation,
              "data-disabled": i.disabled ? "" : void 0,
              tabIndex: i.disabled ? void 0 : 0,
              ...a,
              ref: f,
              style: h === void 0 ? { display: "none" } : e.style,
              onFocus: _(e.onFocus, () => {
                i.valueIndexToChangeRef.current = n;
              })
            }
          ) }),
          p && /* @__PURE__ */ c(
            Bc,
            {
              name: r ?? (i.name ? i.name + (i.values.length > 1 ? "[]" : "") : void 0),
              form: i.form,
              value: h
            },
            n
          )
        ]
      }
    );
  }
);
Fc.displayName = In;
var tb = "RadioBubbleInput", Bc = l.forwardRef(
  ({ __scopeSlider: e, value: t, ...o }, n) => {
    const r = l.useRef(null), a = B(r, n), i = Ao(t);
    return l.useEffect(() => {
      const s = r.current;
      if (!s) return;
      const d = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(d, "value").set;
      if (i !== t && f) {
        const p = new Event("input", { bubbles: !0 });
        f.call(s, t), s.dispatchEvent(p);
      }
    }, [i, t]), /* @__PURE__ */ c(
      I.input,
      {
        style: { display: "none" },
        ...o,
        ref: a,
        defaultValue: t
      }
    );
  }
);
Bc.displayName = tb;
function ob(e = [], t, o) {
  const n = [...e];
  return n[o] = t, n.sort((r, a) => r - a);
}
function Vc(e, t, o) {
  const a = 100 / (o - t) * (e - t);
  return kt(a, [0, 100]);
}
function nb(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function rb(e, t) {
  if (e.length === 1) return 0;
  const o = e.map((r) => Math.abs(r - t)), n = Math.min(...o);
  return o.indexOf(n);
}
function ab(e, t, o) {
  const n = e / 2, a = Pr([0, 50], [0, n]);
  return (n - a(t) * o) * o;
}
function ib(e) {
  return e.slice(0, -1).map((t, o) => e[o + 1] - t);
}
function sb(e, t) {
  if (t > 0) {
    const o = ib(e);
    return Math.min(...o) >= t;
  }
  return !0;
}
function Pr(e, t) {
  return (o) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (o - e[0]);
  };
}
function lb(e) {
  return (String(e).split(".")[1] || "").length;
}
function cb(e, t) {
  const o = Math.pow(10, t);
  return Math.round(e * o) / o;
}
var db = Ic, ub = zc, fb = $c, pb = Fc, Ko = "Switch", [mb] = ae(Ko), [gb, hb] = mb(Ko), Gc = l.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: o,
      name: n,
      checked: r,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: d = "on",
      onCheckedChange: u,
      form: f,
      ...p
    } = e, [m, h] = l.useState(null), b = B(t, (y) => h(y)), g = l.useRef(!1), v = m ? f || !!m.closest("form") : !0, [w, x] = le({
      prop: r,
      defaultProp: a ?? !1,
      onChange: u,
      caller: Ko
    });
    return /* @__PURE__ */ Y(gb, { scope: o, checked: w, disabled: s, children: [
      /* @__PURE__ */ c(
        I.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": w,
          "aria-required": i,
          "data-state": Kc(w),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: d,
          ...p,
          ref: b,
          onClick: _(e.onClick, (y) => {
            x((C) => !C), v && (g.current = y.isPropagationStopped(), g.current || y.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ c(
        Uc,
        {
          control: m,
          bubbles: !g.current,
          name: n,
          value: d,
          checked: w,
          required: i,
          disabled: s,
          form: f,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Gc.displayName = Ko;
var Wc = "SwitchThumb", Hc = l.forwardRef(
  (e, t) => {
    const { __scopeSwitch: o, ...n } = e, r = hb(Wc, o);
    return /* @__PURE__ */ c(
      I.span,
      {
        "data-state": Kc(r.checked),
        "data-disabled": r.disabled ? "" : void 0,
        ...n,
        ref: t
      }
    );
  }
);
Hc.displayName = Wc;
var vb = "SwitchBubbleInput", Uc = l.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: o,
    bubbles: n = !0,
    ...r
  }, a) => {
    const i = l.useRef(null), s = B(i, a), d = Ao(o), u = _o(t);
    return l.useEffect(() => {
      const f = i.current;
      if (!f) return;
      const p = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        p,
        "checked"
      ).set;
      if (d !== o && h) {
        const b = new Event("click", { bubbles: n });
        h.call(f, o), f.dispatchEvent(b);
      }
    }, [d, o, n]), /* @__PURE__ */ c(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: o,
        ...r,
        tabIndex: -1,
        ref: s,
        style: {
          ...r.style,
          ...u,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Uc.displayName = vb;
function Kc(e) {
  return e ? "checked" : "unchecked";
}
var bb = Gc, wb = Hc, jc = "Toggle", Ar = l.forwardRef((e, t) => {
  const { pressed: o, defaultPressed: n, onPressedChange: r, ...a } = e, [i, s] = le({
    prop: o,
    onChange: r,
    defaultProp: n ?? !1,
    caller: jc
  });
  return /* @__PURE__ */ c(
    I.button,
    {
      type: "button",
      "aria-pressed": i,
      "data-state": i ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...a,
      ref: t,
      onClick: _(e.onClick, () => {
        e.disabled || s(!i);
      })
    }
  );
});
Ar.displayName = jc;
var xb = Ar, Xe = "ToggleGroup", [Yc] = ae(Xe, [
  Lo
]), Xc = Lo(), _r = X.forwardRef((e, t) => {
  const { type: o, ...n } = e;
  if (o === "single")
    return /* @__PURE__ */ c(yb, { ...n, ref: t });
  if (o === "multiple")
    return /* @__PURE__ */ c(Cb, { ...n, ref: t });
  throw new Error(`Missing prop \`type\` expected on \`${Xe}\``);
});
_r.displayName = Xe;
var [qc, Zc] = Yc(Xe), yb = X.forwardRef((e, t) => {
  const {
    value: o,
    defaultValue: n,
    onValueChange: r = () => {
    },
    ...a
  } = e, [i, s] = le({
    prop: o,
    defaultProp: n ?? "",
    onChange: r,
    caller: Xe
  });
  return /* @__PURE__ */ c(
    qc,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: X.useMemo(() => i ? [i] : [], [i]),
      onItemActivate: s,
      onItemDeactivate: X.useCallback(() => s(""), [s]),
      children: /* @__PURE__ */ c(Qc, { ...a, ref: t })
    }
  );
}), Cb = X.forwardRef((e, t) => {
  const {
    value: o,
    defaultValue: n,
    onValueChange: r = () => {
    },
    ...a
  } = e, [i, s] = le({
    prop: o,
    defaultProp: n ?? [],
    onChange: r,
    caller: Xe
  }), d = X.useCallback(
    (f) => s((p = []) => [...p, f]),
    [s]
  ), u = X.useCallback(
    (f) => s((p = []) => p.filter((m) => m !== f)),
    [s]
  );
  return /* @__PURE__ */ c(
    qc,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: i,
      onItemActivate: d,
      onItemDeactivate: u,
      children: /* @__PURE__ */ c(Qc, { ...a, ref: t })
    }
  );
});
_r.displayName = Xe;
var [Sb, Eb] = Yc(Xe), Qc = X.forwardRef(
  (e, t) => {
    const {
      __scopeToggleGroup: o,
      disabled: n = !1,
      rovingFocus: r = !0,
      orientation: a,
      dir: i,
      loop: s = !0,
      ...d
    } = e, u = Xc(o), f = nt(i), p = { role: "group", dir: f, ...d };
    return /* @__PURE__ */ c(Sb, { scope: o, rovingFocus: r, disabled: n, children: r ? /* @__PURE__ */ c(
      Is,
      {
        asChild: !0,
        ...u,
        orientation: a,
        dir: f,
        loop: s,
        children: /* @__PURE__ */ c(I.div, { ...p, ref: t })
      }
    ) : /* @__PURE__ */ c(I.div, { ...p, ref: t }) });
  }
), vo = "ToggleGroupItem", Jc = X.forwardRef(
  (e, t) => {
    const o = Zc(vo, e.__scopeToggleGroup), n = Eb(vo, e.__scopeToggleGroup), r = Xc(e.__scopeToggleGroup), a = o.value.includes(e.value), i = n.disabled || e.disabled, s = { ...e, pressed: a, disabled: i }, d = X.useRef(null);
    return n.rovingFocus ? /* @__PURE__ */ c(
      Ms,
      {
        asChild: !0,
        ...r,
        focusable: !i,
        active: a,
        ref: d,
        children: /* @__PURE__ */ c(wa, { ...s, ref: t })
      }
    ) : /* @__PURE__ */ c(wa, { ...s, ref: t });
  }
);
Jc.displayName = vo;
var wa = X.forwardRef(
  (e, t) => {
    const { __scopeToggleGroup: o, value: n, ...r } = e, a = Zc(vo, o), i = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, s = a.type === "single" ? i : void 0;
    return /* @__PURE__ */ c(
      Ar,
      {
        ...s,
        ...r,
        ref: t,
        onPressedChange: (d) => {
          d ? a.onItemActivate(n) : a.onItemDeactivate(n);
        }
      }
    );
  }
), Rb = _r, Pb = Jc, [jo] = ae("Tooltip", [
  He
]), Yo = He(), ed = "TooltipProvider", Ab = 700, Mn = "tooltip.open", [_b, Tr] = jo(ed), td = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: o = Ab,
    skipDelayDuration: n = 300,
    disableHoverableContent: r = !1,
    children: a
  } = e, i = l.useRef(!0), s = l.useRef(!1), d = l.useRef(0);
  return l.useEffect(() => {
    const u = d.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ c(
    _b,
    {
      scope: t,
      isOpenDelayedRef: i,
      delayDuration: o,
      onOpen: l.useCallback(() => {
        window.clearTimeout(d.current), i.current = !1;
      }, []),
      onClose: l.useCallback(() => {
        window.clearTimeout(d.current), d.current = window.setTimeout(
          () => i.current = !0,
          n
        );
      }, [n]),
      isPointerInTransitRef: s,
      onPointerInTransitChange: l.useCallback((u) => {
        s.current = u;
      }, []),
      disableHoverableContent: r,
      children: a
    }
  );
};
td.displayName = ed;
var It = "Tooltip", [Tb, Ht] = jo(It), od = (e) => {
  const {
    __scopeTooltip: t,
    children: o,
    open: n,
    defaultOpen: r,
    onOpenChange: a,
    disableHoverableContent: i,
    delayDuration: s
  } = e, d = Tr(It, e.__scopeTooltip), u = Yo(t), [f, p] = l.useState(null), m = fe(), h = l.useRef(0), b = i ?? d.disableHoverableContent, g = s ?? d.delayDuration, v = l.useRef(!1), [w, x] = le({
    prop: n,
    defaultProp: r ?? !1,
    onChange: (P) => {
      P ? (d.onOpen(), document.dispatchEvent(new CustomEvent(Mn))) : d.onClose(), a?.(P);
    },
    caller: It
  }), y = l.useMemo(() => w ? v.current ? "delayed-open" : "instant-open" : "closed", [w]), C = l.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, v.current = !1, x(!0);
  }, [x]), R = l.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, x(!1);
  }, [x]), A = l.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      v.current = !0, x(!0), h.current = 0;
    }, g);
  }, [g, x]);
  return l.useEffect(() => () => {
    h.current && (window.clearTimeout(h.current), h.current = 0);
  }, []), /* @__PURE__ */ c(zt, { ...u, children: /* @__PURE__ */ c(
    Tb,
    {
      scope: t,
      contentId: m,
      open: w,
      stateAttribute: y,
      trigger: f,
      onTriggerChange: p,
      onTriggerEnter: l.useCallback(() => {
        d.isOpenDelayedRef.current ? A() : C();
      }, [d.isOpenDelayedRef, A, C]),
      onTriggerLeave: l.useCallback(() => {
        b ? R() : (window.clearTimeout(h.current), h.current = 0);
      }, [R, b]),
      onOpen: C,
      onClose: R,
      disableHoverableContent: b,
      children: o
    }
  ) });
};
od.displayName = It;
var Dn = "TooltipTrigger", nd = l.forwardRef(
  (e, t) => {
    const { __scopeTooltip: o, ...n } = e, r = Ht(Dn, o), a = Tr(Dn, o), i = Yo(o), s = l.useRef(null), d = B(t, s, r.onTriggerChange), u = l.useRef(!1), f = l.useRef(!1), p = l.useCallback(() => u.current = !1, []);
    return l.useEffect(() => () => document.removeEventListener("pointerup", p), [p]), /* @__PURE__ */ c($t, { asChild: !0, ...i, children: /* @__PURE__ */ c(
      I.button,
      {
        "aria-describedby": r.open ? r.contentId : void 0,
        "data-state": r.stateAttribute,
        ...n,
        ref: d,
        onPointerMove: _(e.onPointerMove, (m) => {
          m.pointerType !== "touch" && !f.current && !a.isPointerInTransitRef.current && (r.onTriggerEnter(), f.current = !0);
        }),
        onPointerLeave: _(e.onPointerLeave, () => {
          r.onTriggerLeave(), f.current = !1;
        }),
        onPointerDown: _(e.onPointerDown, () => {
          r.open && r.onClose(), u.current = !0, document.addEventListener("pointerup", p, { once: !0 });
        }),
        onFocus: _(e.onFocus, () => {
          u.current || r.onOpen();
        }),
        onBlur: _(e.onBlur, r.onClose),
        onClick: _(e.onClick, r.onClose)
      }
    ) });
  }
);
nd.displayName = Dn;
var Nr = "TooltipPortal", [Nb, kb] = jo(Nr, {
  forceMount: void 0
}), rd = (e) => {
  const { __scopeTooltip: t, forceMount: o, children: n, container: r } = e, a = Ht(Nr, t);
  return /* @__PURE__ */ c(Nb, { scope: t, forceMount: o, children: /* @__PURE__ */ c(se, { present: o || a.open, children: /* @__PURE__ */ c(xt, { asChild: !0, container: r, children: n }) }) });
};
rd.displayName = Nr;
var vt = "TooltipContent", ad = l.forwardRef(
  (e, t) => {
    const o = kb(vt, e.__scopeTooltip), { forceMount: n = o.forceMount, side: r = "top", ...a } = e, i = Ht(vt, e.__scopeTooltip);
    return /* @__PURE__ */ c(se, { present: n || i.open, children: i.disableHoverableContent ? /* @__PURE__ */ c(id, { side: r, ...a, ref: t }) : /* @__PURE__ */ c(Ib, { side: r, ...a, ref: t }) });
  }
), Ib = l.forwardRef((e, t) => {
  const o = Ht(vt, e.__scopeTooltip), n = Tr(vt, e.__scopeTooltip), r = l.useRef(null), a = B(t, r), [i, s] = l.useState(null), { trigger: d, onClose: u } = o, f = r.current, { onPointerInTransitChange: p } = n, m = l.useCallback(() => {
    s(null), p(!1);
  }, [p]), h = l.useCallback(
    (b, g) => {
      const v = b.currentTarget, w = { x: b.clientX, y: b.clientY }, x = Lb(w, v.getBoundingClientRect()), y = zb(w, x), C = $b(g.getBoundingClientRect()), R = Bb([...y, ...C]);
      s(R), p(!0);
    },
    [p]
  );
  return l.useEffect(() => () => m(), [m]), l.useEffect(() => {
    if (d && f) {
      const b = (v) => h(v, f), g = (v) => h(v, d);
      return d.addEventListener("pointerleave", b), f.addEventListener("pointerleave", g), () => {
        d.removeEventListener("pointerleave", b), f.removeEventListener("pointerleave", g);
      };
    }
  }, [d, f, h, m]), l.useEffect(() => {
    if (i) {
      const b = (g) => {
        const v = g.target, w = { x: g.clientX, y: g.clientY }, x = d?.contains(v) || f?.contains(v), y = !Fb(w, i);
        x ? m() : y && (m(), u());
      };
      return document.addEventListener("pointermove", b), () => document.removeEventListener("pointermove", b);
    }
  }, [d, f, i, u, m]), /* @__PURE__ */ c(id, { ...e, ref: a });
}), [Mb, Db] = jo(It, { isInside: !1 }), Ob = /* @__PURE__ */ Ba("TooltipContent"), id = l.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: o,
      children: n,
      "aria-label": r,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      ...s
    } = e, d = Ht(vt, o), u = Yo(o), { onClose: f } = d;
    return l.useEffect(() => (document.addEventListener(Mn, f), () => document.removeEventListener(Mn, f)), [f]), l.useEffect(() => {
      if (d.trigger) {
        const p = (m) => {
          m.target?.contains(d.trigger) && f();
        };
        return window.addEventListener("scroll", p, { capture: !0 }), () => window.removeEventListener("scroll", p, { capture: !0 });
      }
    }, [d.trigger, f]), /* @__PURE__ */ c(
      wt,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: i,
        onFocusOutside: (p) => p.preventDefault(),
        onDismiss: f,
        children: /* @__PURE__ */ Y(
          Do,
          {
            "data-state": d.stateAttribute,
            ...u,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ c(Ob, { children: n }),
              /* @__PURE__ */ c(Mb, { scope: o, isInside: !0, children: /* @__PURE__ */ c(vu, { id: d.contentId, role: "tooltip", children: r || n }) })
            ]
          }
        )
      }
    );
  }
);
ad.displayName = vt;
var sd = "TooltipArrow", ld = l.forwardRef(
  (e, t) => {
    const { __scopeTooltip: o, ...n } = e, r = Yo(o);
    return Db(
      sd,
      o
    ).isInside ? null : /* @__PURE__ */ c(Oo, { ...r, ...n, ref: t });
  }
);
ld.displayName = sd;
function Lb(e, t) {
  const o = Math.abs(t.top - e.y), n = Math.abs(t.bottom - e.y), r = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(o, n, r, a)) {
    case a:
      return "left";
    case r:
      return "right";
    case o:
      return "top";
    case n:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function zb(e, t, o = 5) {
  const n = [];
  switch (t) {
    case "top":
      n.push(
        { x: e.x - o, y: e.y + o },
        { x: e.x + o, y: e.y + o }
      );
      break;
    case "bottom":
      n.push(
        { x: e.x - o, y: e.y - o },
        { x: e.x + o, y: e.y - o }
      );
      break;
    case "left":
      n.push(
        { x: e.x + o, y: e.y - o },
        { x: e.x + o, y: e.y + o }
      );
      break;
    case "right":
      n.push(
        { x: e.x - o, y: e.y - o },
        { x: e.x - o, y: e.y + o }
      );
      break;
  }
  return n;
}
function $b(e) {
  const { top: t, right: o, bottom: n, left: r } = e;
  return [
    { x: r, y: t },
    { x: o, y: t },
    { x: o, y: n },
    { x: r, y: n }
  ];
}
function Fb(e, t) {
  const { x: o, y: n } = e;
  let r = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a], d = t[i], u = s.x, f = s.y, p = d.x, m = d.y;
    f > n != m > n && o < (p - u) * (n - f) / (m - f) + u && (r = !r);
  }
  return r;
}
function Bb(e) {
  const t = e.slice();
  return t.sort((o, n) => o.x < n.x ? -1 : o.x > n.x ? 1 : o.y < n.y ? -1 : o.y > n.y ? 1 : 0), Vb(t);
}
function Vb(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], i = t[t.length - 2];
      if ((a.x - i.x) * (r.y - i.y) >= (a.y - i.y) * (r.x - i.x)) t.pop();
      else break;
    }
    t.push(r);
  }
  t.pop();
  const o = [];
  for (let n = e.length - 1; n >= 0; n--) {
    const r = e[n];
    for (; o.length >= 2; ) {
      const a = o[o.length - 1], i = o[o.length - 2];
      if ((a.x - i.x) * (r.y - i.y) >= (a.y - i.y) * (r.x - i.x)) o.pop();
      else break;
    }
    o.push(r);
  }
  return o.pop(), t.length === 1 && o.length === 1 && t[0].x === o[0].x && t[0].y === o[0].y ? t : t.concat(o);
}
var Gb = td, Wb = od, Hb = nd, Ub = rd, Kb = ad, jb = ld;
function Yb({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Ah,
    {
      "data-slot": "label",
      className: E(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        e
      ),
      ...t
    }
  );
}
function Xb({
  className: e,
  orientation: t = "horizontal",
  decorative: o = !0,
  ...n
}) {
  return /* @__PURE__ */ c(
    Yv,
    {
      "data-slot": "separator",
      decorative: o,
      orientation: t,
      className: E(
        "shrink-0 bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch",
        e
      ),
      ...n
    }
  );
}
function Nw({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "fieldset",
    {
      "data-slot": "field-set",
      className: E(
        "flex flex-col gap-4 has-[>[data-slot=checkbox-group]]:gap-3 has-[>[data-slot=radio-group]]:gap-3",
        e
      ),
      ...t
    }
  );
}
function kw({
  className: e,
  variant: t = "legend",
  ...o
}) {
  return /* @__PURE__ */ c(
    "legend",
    {
      "data-slot": "field-legend",
      "data-variant": t,
      className: E(
        "mb-1.5 font-medium data-[variant=label]:text-sm data-[variant=legend]:text-base",
        e
      ),
      ...o
    }
  );
}
function Iw({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "field-group",
      className: E(
        "group/field-group @container/field-group flex w-full flex-col gap-5 data-[slot=checkbox-group]:gap-3 *:data-[slot=field-group]:gap-4",
        e
      ),
      ...t
    }
  );
}
const qb = bt(
  "group/field flex w-full gap-2 data-[invalid=true]:text-destructive",
  {
    variants: {
      orientation: {
        vertical: "flex-col *:w-full [&>.sr-only]:w-auto",
        horizontal: "flex-row items-center has-[>[data-slot=field-content]]:items-start *:data-[slot=field-label]:flex-auto has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px",
        responsive: "flex-col *:w-full @md/field-group:flex-row @md/field-group:items-center @md/field-group:*:w-auto @md/field-group:has-[>[data-slot=field-content]]:items-start @md/field-group:*:data-[slot=field-label]:flex-auto [&>.sr-only]:w-auto @md/field-group:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px"
      }
    },
    defaultVariants: {
      orientation: "vertical"
    }
  }
);
function Mw({
  className: e,
  orientation: t = "vertical",
  ...o
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      role: "group",
      "data-slot": "field",
      "data-orientation": t,
      className: E(qb({ orientation: t }), e),
      ...o
    }
  );
}
function Dw({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "field-content",
      className: E(
        "group/field-content flex flex-1 flex-col gap-0.5 leading-snug",
        e
      ),
      ...t
    }
  );
}
function Ow({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Yb,
    {
      "data-slot": "field-label",
      className: E(
        "group/field-label peer/field-label flex w-fit gap-2 leading-snug group-data-[disabled=true]/field:opacity-50 has-data-checked:border-primary/30 has-data-checked:bg-primary/5 has-[>[data-slot=field]]:rounded-lg has-[>[data-slot=field]]:border *:data-[slot=field]:p-2.5 dark:has-data-checked:border-primary/20 dark:has-data-checked:bg-primary/10",
        "has-[>[data-slot=field]]:w-full has-[>[data-slot=field]]:flex-col",
        e
      ),
      ...t
    }
  );
}
function Lw({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "field-label",
      className: E(
        "flex w-fit items-center gap-2 text-sm leading-snug font-medium group-data-[disabled=true]/field:opacity-50",
        e
      ),
      ...t
    }
  );
}
function zw({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "p",
    {
      "data-slot": "field-description",
      className: E(
        "text-left text-sm leading-normal font-normal text-muted-foreground group-has-data-horizontal/field:text-balance [[data-variant=legend]+&]:-mt-1.5",
        "last:mt-0 nth-last-2:-mt-1",
        "[&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:text-primary",
        e
      ),
      ...t
    }
  );
}
function $w({
  children: e,
  className: t,
  ...o
}) {
  return /* @__PURE__ */ Y(
    "div",
    {
      "data-slot": "field-separator",
      "data-content": !!e,
      className: E(
        "relative -my-2 h-5 text-sm group-data-[variant=outline]/field-group:-mb-2",
        t
      ),
      ...o,
      children: [
        /* @__PURE__ */ c(Xb, { className: "absolute inset-0 top-1/2" }),
        e && /* @__PURE__ */ c(
          "span",
          {
            className: "relative mx-auto block w-fit bg-background px-2 text-muted-foreground",
            "data-slot": "field-separator-content",
            children: e
          }
        )
      ]
    }
  );
}
function Fw({
  className: e,
  children: t,
  errors: o,
  ...n
}) {
  const r = bd(() => {
    if (t)
      return t;
    if (!o?.length)
      return null;
    const a = [
      ...new Map(o.map((i) => [i?.message, i])).values()
    ];
    return a?.length === 1 ? a[0]?.message : /* @__PURE__ */ c("ul", { className: "ml-4 flex list-disc flex-col gap-1", children: a.map(
      (i, s) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: no stable key available for error list
        i?.message && /* @__PURE__ */ c("li", { children: i.message }, s)
      )
    ) });
  }, [t, o]);
  return r ? /* @__PURE__ */ c(
    "div",
    {
      role: "alert",
      "data-slot": "field-error",
      className: E("text-sm font-normal text-destructive", e),
      ...n,
      children: r
    }
  ) : null;
}
const Zb = bt(
  "group/button inline-flex shrink-0 cursor-pointer items-center justify-center rounded-lg border border-transparent bg-clip-padding text-sm font-medium whitespace-nowrap transition-all outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 active:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  // override: added cursor-pointer so buttons always show a pointer cursor
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground [a]:hover:bg-primary/80",
        outline: "border-border bg-background hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80 aria-expanded:bg-secondary aria-expanded:text-secondary-foreground",
        ghost: "hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:hover:bg-muted/50",
        destructive: "bg-destructive/10 text-destructive hover:bg-destructive/20 focus-visible:border-destructive/40 focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:hover:bg-destructive/30 dark:focus-visible:ring-destructive/40",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-8 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2",
        xs: "h-6 gap-1 rounded-[min(var(--radius-md),10px)] px-2 text-xs in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3",
        sm: "h-7 gap-1 rounded-[min(var(--radius-md),12px)] px-2.5 text-[0.8rem] in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3.5",
        lg: "h-9 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-3 has-data-[icon=inline-start]:pl-3",
        icon: "size-8",
        "icon-xs": "size-6 rounded-[min(var(--radius-md),10px)] in-data-[slot=button-group]:rounded-lg [&_svg:not([class*='size-'])]:size-3",
        "icon-sm": "size-7 rounded-[min(var(--radius-md),12px)] in-data-[slot=button-group]:rounded-lg",
        "icon-lg": "size-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function it({
  className: e,
  variant: t = "default",
  size: o = "default",
  asChild: n = !1,
  ...r
}) {
  return /* @__PURE__ */ c(
    n ? $a : "button",
    {
      "data-slot": "button",
      "data-variant": t,
      "data-size": o,
      className: E(Zb({ variant: t, size: o, className: e })),
      ...r
    }
  );
}
function Bw({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "button-group",
      role: "group",
      className: E(
        "flex h-7 items-center -space-x-px [&>*:first-child]:rounded-l-md [&>*:first-child]:rounded-r-none [&>*:last-child]:rounded-l-none [&>*:last-child]:rounded-r-md [&>*:not(:first-child):not(:last-child)]:rounded-none",
        e
      ),
      ...t
    }
  );
}
const cd = (...e) => e.filter((t, o, n) => !!t && t.trim() !== "" && n.indexOf(t) === o).join(" ").trim();
const Qb = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const Jb = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, o, n) => n ? n.toUpperCase() : o.toLowerCase()
);
const xa = (e) => {
  const t = Jb(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
};
var mn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const ew = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
  return !1;
}, tw = xd({}), ow = () => wd(tw), nw = ya(
  ({ color: e, size: t, strokeWidth: o, absoluteStrokeWidth: n, className: r = "", children: a, iconNode: i, ...s }, d) => {
    const {
      size: u = 24,
      strokeWidth: f = 2,
      absoluteStrokeWidth: p = !1,
      color: m = "currentColor",
      className: h = ""
    } = ow() ?? {}, b = n ?? p ? Number(o ?? f) * 24 / Number(t ?? u) : o ?? f;
    return gn(
      "svg",
      {
        ref: d,
        ...mn,
        width: t ?? u ?? mn.width,
        height: t ?? u ?? mn.height,
        stroke: e ?? m,
        strokeWidth: b,
        className: cd("lucide", h, r),
        ...!a && !ew(s) && { "aria-hidden": "true" },
        ...s
      },
      [
        ...i.map(([g, v]) => gn(g, v)),
        ...Array.isArray(a) ? a : [a]
      ]
    );
  }
);
const st = (e, t) => {
  const o = ya(
    ({ className: n, ...r }, a) => gn(nw, {
      ref: a,
      iconNode: t,
      className: cd(
        `lucide-${Qb(xa(e))}`,
        `lucide-${e}`,
        n
      ),
      ...r
    })
  );
  return o.displayName = xa(e), o;
};
const rw = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Xo = st("check", rw);
const aw = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], kr = st("chevron-down", aw);
const iw = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], sw = st("chevron-left", iw);
const lw = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], dd = st("chevron-right", lw);
const cw = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], ud = st("chevron-up", cw);
const dw = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
], uw = st("ellipsis", dw);
const fw = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], fd = st("x", fw);
function Vw({
  ...e
}) {
  return /* @__PURE__ */ c(Nv, { "data-slot": "select", ...e });
}
function Gw({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    zv,
    {
      "data-slot": "select-group",
      className: E("scroll-my-1 p-1", e),
      ...t
    }
  );
}
function Ww({
  ...e
}) {
  return /* @__PURE__ */ c(Iv, { "data-slot": "select-value", ...e });
}
function Hw({
  className: e,
  size: t = "default",
  children: o,
  ...n
}) {
  return /* @__PURE__ */ Y(
    kv,
    {
      "data-slot": "select-trigger",
      "data-size": t,
      className: E(
        "flex w-fit items-center justify-between gap-1.5 rounded-lg border border-input bg-transparent py-2 pr-2 pl-2.5 text-sm whitespace-nowrap transition-colors outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-placeholder:text-muted-foreground data-[size=default]:h-8 data-[size=sm]:h-7 data-[size=sm]:rounded-[min(var(--radius-md),10px)] *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-1.5 dark:bg-input/30 dark:hover:bg-input/50 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...n,
      children: [
        o,
        /* @__PURE__ */ c(Mv, { asChild: !0, children: /* @__PURE__ */ c(kr, { className: "pointer-events-none size-4 text-muted-foreground" }) })
      ]
    }
  );
}
function Uw({
  className: e,
  children: t,
  position: o = "item-aligned",
  align: n = "center",
  ...r
}) {
  return /* @__PURE__ */ c(Dv, { children: /* @__PURE__ */ Y(
    Ov,
    {
      "data-slot": "select-content",
      "data-align-trigger": o === "item-aligned",
      className: E(
        "relative z-50 max-h-(--radix-select-content-available-height) min-w-36 origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-lg bg-popover text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[align-trigger=true]:animate-none data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        o === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: o,
      align: n,
      ...r,
      children: [
        /* @__PURE__ */ c(pw, {}),
        /* @__PURE__ */ c(
          Lv,
          {
            "data-position": o,
            className: E(
              "data-[position=popper]:h-(--radix-select-trigger-height) data-[position=popper]:w-full data-[position=popper]:min-w-(--radix-select-trigger-width)",
              o === "popper" && ""
            ),
            children: t
          }
        ),
        /* @__PURE__ */ c(mw, {})
      ]
    }
  ) });
}
function Kw({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    $v,
    {
      "data-slot": "select-label",
      className: E("px-1.5 py-1 text-xs text-muted-foreground", e),
      ...t
    }
  );
}
function jw({
  className: e,
  children: t,
  ...o
}) {
  return /* @__PURE__ */ Y(
    Fv,
    {
      "data-slot": "select-item",
      className: E(
        "relative flex w-full cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2",
        e
      ),
      ...o,
      children: [
        /* @__PURE__ */ c("span", { className: "pointer-events-none absolute right-2 flex size-4 items-center justify-center", children: /* @__PURE__ */ c(Vv, { children: /* @__PURE__ */ c(Xo, { className: "pointer-events-none" }) }) }),
        /* @__PURE__ */ c(Bv, { children: t })
      ]
    }
  );
}
function Yw({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Hv,
    {
      "data-slot": "select-separator",
      className: E("pointer-events-none -mx-1 my-1 h-px bg-border", e),
      ...t
    }
  );
}
function pw({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Gv,
    {
      "data-slot": "select-scroll-up-button",
      className: E(
        "z-10 flex cursor-default items-center justify-center bg-popover py-1 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t,
      children: /* @__PURE__ */ c(ud, {})
    }
  );
}
function mw({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Wv,
    {
      "data-slot": "select-scroll-down-button",
      className: E(
        "z-10 flex cursor-default items-center justify-center bg-popover py-1 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t,
      children: /* @__PURE__ */ c(kr, {})
    }
  );
}
function Xw({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    es,
    {
      "data-slot": "checkbox",
      className: E(
        "peer relative flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-input transition-colors outline-none group-has-disabled/field:opacity-50 after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary",
        e
      ),
      ...t,
      children: /* @__PURE__ */ c(
        os,
        {
          "data-slot": "checkbox-indicator",
          className: "grid place-content-center text-current transition-none [&>svg]:size-3.5",
          children: /* @__PURE__ */ c(Xo, {})
        }
      )
    }
  );
}
function qw({
  className: e,
  size: t = "default",
  ...o
}) {
  return /* @__PURE__ */ c(
    bb,
    {
      "data-slot": "switch",
      "data-size": t,
      className: E(
        "peer group/switch relative inline-flex shrink-0 items-center rounded-full border border-transparent transition-all outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-[size=default]:h-[18.4px] data-[size=default]:w-[32px] data-[size=sm]:h-[14px] data-[size=sm]:w-[24px] dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:bg-primary data-unchecked:bg-input dark:data-unchecked:bg-input/80 data-disabled:cursor-not-allowed data-disabled:opacity-50",
        e
      ),
      ...o,
      children: /* @__PURE__ */ c(
        wb,
        {
          "data-slot": "switch-thumb",
          className: "pointer-events-none block rounded-full bg-background ring-0 transition-transform group-data-[size=default]/switch:size-4 group-data-[size=sm]/switch:size-3 group-data-[size=default]/switch:data-checked:translate-x-[calc(100%-2px)] group-data-[size=sm]/switch:data-checked:translate-x-[calc(100%-2px)] dark:data-checked:bg-primary-foreground group-data-[size=default]/switch:data-unchecked:translate-x-0 group-data-[size=sm]/switch:data-unchecked:translate-x-0 dark:data-unchecked:bg-foreground"
        }
      )
    }
  );
}
function Zw({
  className: e,
  defaultValue: t,
  value: o,
  min: n = 0,
  max: r = 100,
  ...a
}) {
  const i = l.useMemo(
    () => Array.isArray(o) ? o : Array.isArray(t) ? t : [n, r],
    [o, t, n, r]
  );
  return /* @__PURE__ */ Y(
    db,
    {
      "data-slot": "slider",
      defaultValue: t,
      value: o,
      min: n,
      max: r,
      className: E(
        "relative flex w-full touch-none items-center select-none data-disabled:opacity-50 data-vertical:h-full data-vertical:min-h-40 data-vertical:w-auto data-vertical:flex-col",
        e
      ),
      ...a,
      children: [
        /* @__PURE__ */ c(
          ub,
          {
            "data-slot": "slider-track",
            className: "relative grow overflow-hidden rounded-full bg-muted data-horizontal:h-1 data-horizontal:w-full data-vertical:h-full data-vertical:w-1",
            children: /* @__PURE__ */ c(
              fb,
              {
                "data-slot": "slider-range",
                className: "absolute bg-primary select-none data-horizontal:h-full data-vertical:w-full"
              }
            )
          }
        ),
        Array.from({ length: i.length }, (s, d) => /* @__PURE__ */ c(
          pb,
          {
            "data-slot": "slider-thumb",
            className: "relative block size-3 shrink-0 rounded-full border border-ring bg-white ring-ring/50 transition-[color,box-shadow] select-none after:absolute after:-inset-2 hover:ring-3 focus-visible:ring-3 focus-visible:outline-hidden active:ring-3 disabled:pointer-events-none disabled:opacity-50"
          },
          d
        ))
      ]
    }
  );
}
function gw({ className: e, type: t, ...o }) {
  return /* @__PURE__ */ c(
    "input",
    {
      type: t,
      "data-slot": "input",
      className: E(
        "h-8 w-full min-w-0 rounded-lg border border-input bg-transparent px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        e
      ),
      ...o
    }
  );
}
function hw({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "textarea",
    {
      "data-slot": "textarea",
      className: E(
        "flex field-sizing-content min-h-16 w-full rounded-lg border border-input bg-transparent px-2.5 py-2 text-base transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        e
      ),
      ...t
    }
  );
}
function Qw({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "input-group",
      role: "group",
      className: E(
        "group/input-group relative flex h-7 w-full min-w-0 items-center rounded-md border border-input transition-colors outline-none in-data-[slot=combobox-content]:focus-within:border-inherit in-data-[slot=combobox-content]:focus-within:ring-0 has-disabled:bg-input/50 has-disabled:opacity-50 has-[[data-slot=input-group-control]:focus-visible]:border-ring has-[[data-slot=input-group-control]:focus-visible]:ring-3 has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50 has-[[data-slot][aria-invalid=true]]:border-destructive has-[[data-slot][aria-invalid=true]]:ring-3 has-[[data-slot][aria-invalid=true]]:ring-destructive/20 has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>textarea]:h-auto dark:bg-input/30 dark:has-disabled:bg-input/80 dark:has-[[data-slot][aria-invalid=true]]:ring-destructive/40 has-[>[data-align=block-end]]:[&>input]:pt-3 has-[>[data-align=block-start]]:[&>input]:pb-3 has-[>[data-align=inline-end]]:[&>input]:pr-1.5 has-[>[data-align=inline-start]]:[&>input]:pl-1.5",
        e
      ),
      ...t
    }
  );
}
const vw = bt(
  "flex h-auto cursor-text items-center justify-center gap-2 py-1.5 text-sm font-medium text-muted-foreground select-none group-data-[disabled=true]/input-group:opacity-50 [&>kbd]:rounded-[calc(var(--radius)-5px)] [&>svg:not([class*='size-'])]:size-4",
  {
    variants: {
      align: {
        "inline-start": "order-first pl-2 has-[>button]:ml-[-0.3rem] has-[>kbd]:ml-[-0.15rem]",
        "inline-end": "order-last pr-2 has-[>button]:mr-[-0.3rem] has-[>kbd]:mr-[-0.15rem]",
        "block-start": "order-first w-full justify-start px-2.5 pt-2 group-has-[>input]/input-group:pt-2 [.border-b]:pb-2",
        "block-end": "order-last w-full justify-start px-2.5 pb-2 group-has-[>input]/input-group:pb-2 [.border-t]:pt-2"
      }
    },
    defaultVariants: {
      align: "inline-start"
    }
  }
);
function Jw({
  className: e,
  align: t = "inline-start",
  ...o
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      role: "group",
      "data-slot": "input-group-addon",
      "data-align": t,
      className: E(vw({ align: t }), e),
      onClick: (n) => {
        n.target.closest("button") || n.currentTarget.parentElement?.querySelector("input")?.focus();
      },
      ...o
    }
  );
}
const bw = bt(
  "flex items-center gap-2 text-sm shadow-none",
  {
    variants: {
      size: {
        xs: "h-6 gap-1 rounded-[calc(var(--radius)-3px)] px-1.5 [&>svg:not([class*='size-'])]:size-3.5",
        sm: "",
        "icon-xs": "size-6 rounded-[calc(var(--radius)-3px)] p-0 has-[>svg]:p-0",
        "icon-sm": "size-8 p-0 has-[>svg]:p-0"
      }
    },
    defaultVariants: {
      size: "xs"
    }
  }
);
function ex({
  className: e,
  type: t = "button",
  variant: o = "ghost",
  size: n = "xs",
  ...r
}) {
  return /* @__PURE__ */ c(
    it,
    {
      type: t,
      "data-size": n,
      variant: o,
      className: E(bw({ size: n }), e),
      ...r
    }
  );
}
function tx({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "span",
    {
      className: E(
        "flex items-center gap-2 text-sm text-muted-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t
    }
  );
}
function ox({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    gw,
    {
      "data-slot": "input-group-control",
      className: E(
        "flex-1 rounded-none border-0 bg-transparent shadow-none ring-0 focus-visible:ring-0 disabled:bg-transparent aria-invalid:ring-0 dark:bg-transparent dark:disabled:bg-transparent",
        e
      ),
      ...t
    }
  );
}
function nx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    hw,
    {
      "data-slot": "input-group-control",
      className: E(
        "flex-1 resize-none rounded-none border-0 bg-transparent py-2 shadow-none ring-0 focus-visible:ring-0 disabled:bg-transparent aria-invalid:ring-0 dark:bg-transparent dark:disabled:bg-transparent",
        e
      ),
      ...t
    }
  );
}
function rx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Wu,
    {
      "data-slot": "accordion",
      className: E("flex w-full flex-col", e),
      ...t
    }
  );
}
function ax({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Hu,
    {
      "data-slot": "accordion-item",
      className: E("not-last:border-b", e),
      ...t
    }
  );
}
function ix({
  className: e,
  children: t,
  ...o
}) {
  return /* @__PURE__ */ c(Uu, { className: "flex", children: /* @__PURE__ */ Y(
    Ku,
    {
      "data-slot": "accordion-trigger",
      className: E(
        "group/accordion-trigger relative flex flex-1 items-start justify-between rounded-lg border border-transparent py-2.5 text-left text-sm font-medium transition-all outline-none hover:underline focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:after:border-ring disabled:pointer-events-none disabled:opacity-50 **:data-[slot=accordion-trigger-icon]:ml-auto **:data-[slot=accordion-trigger-icon]:size-4 **:data-[slot=accordion-trigger-icon]:text-muted-foreground",
        e
      ),
      ...o,
      children: [
        t,
        /* @__PURE__ */ c(
          kr,
          {
            "data-slot": "accordion-trigger-icon",
            className: "pointer-events-none shrink-0 group-aria-expanded/accordion-trigger:hidden"
          }
        ),
        /* @__PURE__ */ c(
          ud,
          {
            "data-slot": "accordion-trigger-icon",
            className: "pointer-events-none hidden shrink-0 group-aria-expanded/accordion-trigger:inline"
          }
        )
      ]
    }
  ) });
}
function sx({
  className: e,
  children: t,
  ...o
}) {
  return /* @__PURE__ */ c(
    ju,
    {
      "data-slot": "accordion-content",
      className: "overflow-hidden text-sm data-open:animate-accordion-down data-closed:animate-accordion-up",
      ...o,
      children: /* @__PURE__ */ c(
        "div",
        {
          className: E(
            "h-(--radix-accordion-content-height) pt-0 pb-2.5 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4",
            e
          ),
          children: t
        }
      )
    }
  );
}
function lx({
  className: e,
  size: t = "default",
  ...o
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "card",
      "data-size": t,
      className: E(
        "group/card flex flex-col gap-4 overflow-hidden rounded-xl bg-card py-4 text-sm text-card-foreground ring-1 ring-foreground/10 has-data-[slot=card-footer]:pb-0 has-[>img:first-child]:pt-0 data-[size=sm]:gap-3 data-[size=sm]:py-3 data-[size=sm]:has-data-[slot=card-footer]:pb-0 *:[img:first-child]:rounded-t-xl *:[img:last-child]:rounded-b-xl",
        e
      ),
      ...o
    }
  );
}
function cx({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "card-header",
      className: E(
        "group/card-header @container/card-header grid auto-rows-min items-start gap-1 rounded-t-xl px-4 group-data-[size=sm]/card:px-3 has-data-[slot=card-action]:grid-cols-[1fr_auto] has-data-[slot=card-description]:grid-rows-[auto_auto] [.border-b]:pb-4 group-data-[size=sm]/card:[.border-b]:pb-3",
        e
      ),
      ...t
    }
  );
}
function dx({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "card-title",
      className: E(
        "text-base leading-snug font-medium group-data-[size=sm]/card:text-sm",
        e
      ),
      ...t
    }
  );
}
function ux({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "card-description",
      className: E("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function fx({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "card-action",
      className: E(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        e
      ),
      ...t
    }
  );
}
function px({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "card-content",
      className: E("px-4 group-data-[size=sm]/card:px-3", e),
      ...t
    }
  );
}
function mx({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "card-footer",
      className: E(
        "flex items-center rounded-b-xl border-t bg-muted/50 p-4 group-data-[size=sm]/card:p-3",
        e
      ),
      ...t
    }
  );
}
function gx({
  className: e,
  children: t,
  ...o
}) {
  return /* @__PURE__ */ Y(
    sv,
    {
      "data-slot": "scroll-area",
      type: "always",
      className: E("relative flex flex-col overflow-hidden", e),
      ...o,
      children: [
        /* @__PURE__ */ c(
          lv,
          {
            "data-slot": "scroll-area-viewport",
            className: "w-full grow rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1",
            children: t
          }
        ),
        /* @__PURE__ */ c(ww, {}),
        /* @__PURE__ */ c(cv, {})
      ]
    }
  );
}
function ww({
  className: e,
  orientation: t = "vertical",
  ...o
}) {
  return /* @__PURE__ */ c(
    Wl,
    {
      "data-slot": "scroll-area-scrollbar",
      "data-orientation": t,
      orientation: t,
      className: E(
        "flex touch-none p-px transition-colors select-none data-horizontal:h-2.5 data-horizontal:flex-col data-horizontal:border-t data-horizontal:border-t-transparent data-vertical:h-full data-vertical:w-2.5 data-vertical:border-l data-vertical:border-l-transparent",
        e
      ),
      ...o,
      children: /* @__PURE__ */ c(
        jl,
        {
          "data-slot": "scroll-area-thumb",
          className: "relative flex-1 rounded-full bg-border"
        }
      )
    }
  );
}
function hx({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "skeleton",
      className: E("animate-pulse rounded-md bg-muted", e),
      ...t
    }
  );
}
function vx({
  className: e,
  size: t = "default",
  ...o
}) {
  return /* @__PURE__ */ c(
    Mp,
    {
      "data-slot": "avatar",
      "data-size": t,
      className: E(
        "group/avatar relative flex size-8 shrink-0 rounded-full select-none after:absolute after:inset-0 after:rounded-full after:border after:border-border after:mix-blend-darken data-[size=lg]:size-10 data-[size=sm]:size-6 dark:after:mix-blend-lighten",
        e
      ),
      ...o
    }
  );
}
function bx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Dp,
    {
      "data-slot": "avatar-image",
      className: E(
        "aspect-square size-full rounded-full object-cover",
        e
      ),
      ...t
    }
  );
}
function wx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Op,
    {
      "data-slot": "avatar-fallback",
      className: E(
        "flex size-full items-center justify-center rounded-full bg-muted text-sm text-muted-foreground group-data-[size=sm]/avatar:text-xs",
        e
      ),
      ...t
    }
  );
}
function xx({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "span",
    {
      "data-slot": "avatar-badge",
      className: E(
        "absolute right-0 bottom-0 z-10 inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground bg-blend-color ring-2 ring-background select-none",
        "group-data-[size=sm]/avatar:size-2 group-data-[size=sm]/avatar:[&>svg]:hidden",
        "group-data-[size=default]/avatar:size-2.5 group-data-[size=default]/avatar:[&>svg]:size-2",
        "group-data-[size=lg]/avatar:size-3 group-data-[size=lg]/avatar:[&>svg]:size-2",
        e
      ),
      ...t
    }
  );
}
function yx({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "avatar-group",
      className: E(
        "group/avatar-group flex -space-x-2 *:data-[slot=avatar]:ring-2 *:data-[slot=avatar]:ring-background",
        e
      ),
      ...t
    }
  );
}
function Cx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "avatar-group-count",
      className: E(
        "relative flex size-8 shrink-0 items-center justify-center rounded-full bg-muted text-sm text-muted-foreground ring-2 ring-background group-has-data-[size=lg]/avatar-group:size-10 group-has-data-[size=sm]/avatar-group:size-6 [&>svg]:size-4 group-has-data-[size=lg]/avatar-group:[&>svg]:size-5 group-has-data-[size=sm]/avatar-group:[&>svg]:size-3",
        e
      ),
      ...t
    }
  );
}
function Sx({
  className: e,
  value: t,
  ...o
}) {
  const [n, r] = l.useState(0);
  return l.useEffect(() => {
    const a = requestAnimationFrame(() => r(t || 0));
    return () => cancelAnimationFrame(a);
  }, [t]), /* @__PURE__ */ c(
    Yh,
    {
      "data-slot": "progress",
      value: t,
      className: E(
        "relative flex h-1 w-full items-center overflow-x-hidden rounded-full bg-muted",
        e
      ),
      ...o,
      children: /* @__PURE__ */ c(
        Xh,
        {
          "data-slot": "progress-indicator",
          className: "size-full flex-1 bg-primary transition-all",
          style: { transform: `translateX(-${100 - n}%)` }
        }
      )
    }
  );
}
const xw = bt(
  "group/badge inline-flex h-5 w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-4xl border border-transparent px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-all focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&>svg]:pointer-events-none [&>svg]:size-3!",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground [a]:hover:bg-primary/80",
        secondary: "bg-secondary text-secondary-foreground [a]:hover:bg-secondary/80",
        destructive: "bg-destructive/10 text-destructive focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:focus-visible:ring-destructive/40 [a]:hover:bg-destructive/20",
        outline: "border-border text-foreground [a]:hover:bg-muted [a]:hover:text-muted-foreground",
        ghost: "hover:bg-muted hover:text-muted-foreground dark:hover:bg-muted/50",
        link: "text-primary underline-offset-4 hover:underline"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Ex({
  className: e,
  variant: t = "default",
  asChild: o = !1,
  ...n
}) {
  return /* @__PURE__ */ c(
    o ? $a : "span",
    {
      "data-slot": "badge",
      "data-variant": t,
      className: E(xw({ variant: t }), e),
      ...n
    }
  );
}
const pd = bt(
  "group/toggle inline-flex items-center justify-center gap-1 rounded-lg text-sm font-medium whitespace-nowrap transition-all outline-none hover:bg-muted hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 aria-pressed:bg-muted data-[state=on]:bg-muted dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent hover:bg-muted"
      },
      size: {
        default: "h-8 min-w-8 px-2",
        sm: "h-7 min-w-7 rounded-[min(var(--radius-md),12px)] px-1.5 text-[0.8rem]",
        lg: "h-9 min-w-9 px-2.5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function Rx({
  className: e,
  variant: t = "default",
  size: o = "default",
  ...n
}) {
  return /* @__PURE__ */ c(
    xb,
    {
      "data-slot": "toggle",
      className: E(pd({ variant: t, size: o, className: e })),
      ...n
    }
  );
}
const md = l.createContext({
  size: "default",
  variant: "default",
  spacing: 0,
  orientation: "horizontal"
});
function Px({
  className: e,
  variant: t,
  size: o,
  spacing: n = 0,
  orientation: r = "horizontal",
  children: a,
  ...i
}) {
  return /* @__PURE__ */ c(
    Rb,
    {
      "data-slot": "toggle-group",
      "data-variant": t,
      "data-size": o,
      "data-spacing": n,
      "data-orientation": r,
      style: { "--gap": n },
      className: E(
        "group/toggle-group flex w-fit flex-row items-center gap-[--spacing(var(--gap))] rounded-lg data-[size=sm]:rounded-[min(var(--radius-md),10px)] data-vertical:flex-col data-vertical:items-stretch",
        e
      ),
      ...i,
      children: /* @__PURE__ */ c(
        md.Provider,
        {
          value: { variant: t, size: o, spacing: n, orientation: r },
          children: a
        }
      )
    }
  );
}
function Ax({
  className: e,
  children: t,
  variant: o = "default",
  size: n = "default",
  ...r
}) {
  const a = l.useContext(md);
  return /* @__PURE__ */ c(
    Pb,
    {
      "data-slot": "toggle-group-item",
      "data-variant": a.variant || o,
      "data-size": a.size || n,
      "data-spacing": a.spacing,
      className: E(
        "shrink-0 group-data-[spacing=0]/toggle-group:rounded-none group-data-[spacing=0]/toggle-group:px-2 focus:z-10 focus-visible:z-10 group-data-horizontal/toggle-group:data-[spacing=0]:first:rounded-l-lg group-data-vertical/toggle-group:data-[spacing=0]:first:rounded-t-lg group-data-horizontal/toggle-group:data-[spacing=0]:last:rounded-r-lg group-data-vertical/toggle-group:data-[spacing=0]:last:rounded-b-lg group-data-horizontal/toggle-group:data-[spacing=0]:data-[variant=outline]:border-l-0 group-data-vertical/toggle-group:data-[spacing=0]:data-[variant=outline]:border-t-0 group-data-horizontal/toggle-group:data-[spacing=0]:data-[variant=outline]:first:border-l group-data-vertical/toggle-group:data-[spacing=0]:data-[variant=outline]:first:border-t",
        pd({
          variant: a.variant || o,
          size: a.size || n
        }),
        e
      ),
      ...r,
      children: t
    }
  );
}
function _x({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "table-container",
      className: "relative w-full overflow-x-auto",
      children: /* @__PURE__ */ c(
        "table",
        {
          "data-slot": "table",
          className: E("w-full caption-bottom text-sm", e),
          ...t
        }
      )
    }
  );
}
function Tx({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "thead",
    {
      "data-slot": "table-header",
      className: E("[&_tr]:border-b", e),
      ...t
    }
  );
}
function Nx({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "tbody",
    {
      "data-slot": "table-body",
      className: E("[&_tr:last-child]:border-0", e),
      ...t
    }
  );
}
function kx({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "tfoot",
    {
      "data-slot": "table-footer",
      className: E(
        "border-t bg-muted/50 font-medium [&>tr]:last:border-b-0",
        e
      ),
      ...t
    }
  );
}
function Ix({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "tr",
    {
      "data-slot": "table-row",
      className: E(
        "border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted",
        e
      ),
      ...t
    }
  );
}
function Mx({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "th",
    {
      "data-slot": "table-head",
      className: E(
        "h-10 px-2 text-left align-middle font-medium whitespace-nowrap text-foreground [&:has([role=checkbox])]:pr-0",
        e
      ),
      ...t
    }
  );
}
function Dx({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "td",
    {
      "data-slot": "table-cell",
      className: E(
        "p-2 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0",
        e
      ),
      ...t
    }
  );
}
function Ox({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "caption",
    {
      "data-slot": "table-caption",
      className: E("mt-4 text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function Lx({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "nav",
    {
      "aria-label": "pagination",
      "data-slot": "pagination",
      className: E("mx-auto flex w-full justify-center", e),
      ...t
    }
  );
}
function zx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "ul",
    {
      "data-slot": "pagination-content",
      className: E("flex items-center gap-0.5", e),
      ...t
    }
  );
}
function $x({ ...e }) {
  return /* @__PURE__ */ c("li", { "data-slot": "pagination-item", ...e });
}
function gd({
  className: e,
  isActive: t,
  size: o = "icon",
  ...n
}) {
  return /* @__PURE__ */ c(
    it,
    {
      asChild: !0,
      variant: t ? "outline" : "ghost",
      size: o,
      className: E(e),
      children: /* @__PURE__ */ c(
        "a",
        {
          "aria-current": t ? "page" : void 0,
          "data-slot": "pagination-link",
          "data-active": t,
          ...n
        }
      )
    }
  );
}
function Fx({
  className: e,
  text: t = "Previous",
  ...o
}) {
  return /* @__PURE__ */ Y(
    gd,
    {
      "aria-label": "Go to previous page",
      size: "default",
      className: E("pl-1.5!", e),
      ...o,
      children: [
        /* @__PURE__ */ c(sw, { "data-icon": "inline-start" }),
        /* @__PURE__ */ c("span", { className: "hidden sm:block", children: t })
      ]
    }
  );
}
function Bx({
  className: e,
  text: t = "Next",
  ...o
}) {
  return /* @__PURE__ */ Y(
    gd,
    {
      "aria-label": "Go to next page",
      size: "default",
      className: E("pr-1.5!", e),
      ...o,
      children: [
        /* @__PURE__ */ c("span", { className: "hidden sm:block", children: t }),
        /* @__PURE__ */ c(dd, { "data-icon": "inline-end" })
      ]
    }
  );
}
function Vx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ Y(
    "span",
    {
      "aria-hidden": !0,
      "data-slot": "pagination-ellipsis",
      className: E(
        "flex size-8 items-center justify-center [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t,
      children: [
        /* @__PURE__ */ c(uw, {}),
        /* @__PURE__ */ c("span", { className: "sr-only", children: "More pages" })
      ]
    }
  );
}
function Gx({
  ...e
}) {
  return /* @__PURE__ */ c(gp, { "data-slot": "alert-dialog", ...e });
}
function Wx({
  ...e
}) {
  return /* @__PURE__ */ c(hp, { "data-slot": "alert-dialog-trigger", ...e });
}
function yw({
  ...e
}) {
  return /* @__PURE__ */ c(vp, { "data-slot": "alert-dialog-portal", ...e });
}
function Cw({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    bp,
    {
      "data-slot": "alert-dialog-overlay",
      className: E(
        "fixed inset-0 z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0",
        e
      ),
      ...t
    }
  );
}
function Hx({
  className: e,
  size: t = "default",
  ...o
}) {
  return /* @__PURE__ */ Y(yw, { children: [
    /* @__PURE__ */ c(Cw, {}),
    /* @__PURE__ */ c(
      wp,
      {
        "data-slot": "alert-dialog-content",
        "data-size": t,
        className: E(
          "group/alert-dialog-content fixed top-1/2 left-1/2 z-50 grid w-full -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl bg-popover p-4 text-popover-foreground ring-1 ring-foreground/10 duration-100 outline-none data-[size=default]:max-w-xs data-[size=sm]:max-w-xs data-[size=default]:sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
          e
        ),
        ...o
      }
    )
  ] });
}
function Ux({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "alert-dialog-header",
      className: E(
        "grid grid-rows-[auto_1fr] place-items-center gap-1.5 text-center has-data-[slot=alert-dialog-media]:grid-rows-[auto_auto_1fr] has-data-[slot=alert-dialog-media]:gap-x-4 sm:group-data-[size=default]/alert-dialog-content:place-items-start sm:group-data-[size=default]/alert-dialog-content:text-left sm:group-data-[size=default]/alert-dialog-content:has-data-[slot=alert-dialog-media]:grid-rows-[auto_1fr]",
        e
      ),
      ...t
    }
  );
}
function Kx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "alert-dialog-footer",
      className: E(
        "-mx-4 -mb-4 flex flex-col-reverse gap-2 rounded-b-xl border-t bg-muted/50 p-4 group-data-[size=sm]/alert-dialog-content:grid group-data-[size=sm]/alert-dialog-content:grid-cols-2 sm:flex-row sm:justify-end",
        e
      ),
      ...t
    }
  );
}
function jx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "alert-dialog-media",
      className: E(
        "mb-2 inline-flex size-10 items-center justify-center rounded-md bg-muted sm:group-data-[size=default]/alert-dialog-content:row-span-2 *:[svg:not([class*='size-'])]:size-6",
        e
      ),
      ...t
    }
  );
}
function Yx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Cp,
    {
      "data-slot": "alert-dialog-title",
      className: E(
        "text-base font-medium sm:group-data-[size=default]/alert-dialog-content:group-has-data-[slot=alert-dialog-media]/alert-dialog-content:col-start-2",
        e
      ),
      ...t
    }
  );
}
function Xx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Sp,
    {
      "data-slot": "alert-dialog-description",
      className: E(
        "text-sm text-balance text-muted-foreground md:text-pretty *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground",
        e
      ),
      ...t
    }
  );
}
function qx({
  className: e,
  variant: t = "default",
  size: o = "default",
  ...n
}) {
  return /* @__PURE__ */ c(it, { variant: t, size: o, asChild: !0, children: /* @__PURE__ */ c(
    xp,
    {
      "data-slot": "alert-dialog-action",
      className: E(e),
      ...n
    }
  ) });
}
function Zx({
  className: e,
  variant: t = "outline",
  size: o = "default",
  ...n
}) {
  return /* @__PURE__ */ c(it, { variant: t, size: o, asChild: !0, children: /* @__PURE__ */ c(
    yp,
    {
      "data-slot": "alert-dialog-cancel",
      className: E(e),
      ...n
    }
  ) });
}
function Qx({
  ...e
}) {
  return /* @__PURE__ */ c($h, { "data-slot": "popover", ...e });
}
function Jx({
  ...e
}) {
  return /* @__PURE__ */ c(Fh, { "data-slot": "popover-trigger", ...e });
}
function ey({
  className: e,
  align: t = "center",
  sideOffset: o = 4,
  ...n
}) {
  return /* @__PURE__ */ c(Bh, { children: /* @__PURE__ */ c(
    Vh,
    {
      "data-slot": "popover-content",
      align: t,
      sideOffset: o,
      className: E(
        "z-50 flex w-72 origin-(--radix-popover-content-transform-origin) flex-col gap-2.5 rounded-lg bg-popover p-2.5 text-sm text-popover-foreground shadow-md ring-1 ring-foreground/10 outline-hidden duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        e
      ),
      ...n
    }
  ) });
}
function ty({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "popover-header",
      className: E("flex flex-col gap-0.5 text-sm", e),
      ...t
    }
  );
}
function oy({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "popover-title",
      className: E("font-medium", e),
      ...t
    }
  );
}
function ny({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "p",
    {
      "data-slot": "popover-description",
      className: E("text-muted-foreground", e),
      ...t
    }
  );
}
function ry({ ...e }) {
  return /* @__PURE__ */ c(Yn, { "data-slot": "sheet", ...e });
}
function ay({
  ...e
}) {
  return /* @__PURE__ */ c(Xn, { "data-slot": "sheet-trigger", ...e });
}
function iy({
  ...e
}) {
  return /* @__PURE__ */ c(rt, { "data-slot": "sheet-close", ...e });
}
function Sw({
  ...e
}) {
  return /* @__PURE__ */ c(qn, { "data-slot": "sheet-portal", ...e });
}
function Ew({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Zn,
    {
      "data-slot": "sheet-overlay",
      className: E(
        "fixed inset-0 z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0",
        e
      ),
      ...t
    }
  );
}
function sy({
  className: e,
  children: t,
  side: o = "right",
  showCloseButton: n = !0,
  ...r
}) {
  return /* @__PURE__ */ Y(Sw, { children: [
    /* @__PURE__ */ c(Ew, {}),
    /* @__PURE__ */ Y(
      Qn,
      {
        "data-slot": "sheet-content",
        "data-side": o,
        className: E(
          "fixed z-50 flex flex-col gap-4 bg-popover bg-clip-padding text-sm text-popover-foreground shadow-lg transition duration-200 ease-in-out data-[side=bottom]:inset-x-0 data-[side=bottom]:bottom-0 data-[side=bottom]:h-auto data-[side=bottom]:border-t data-[side=left]:inset-y-0 data-[side=left]:left-0 data-[side=left]:h-full data-[side=left]:w-3/4 data-[side=left]:border-r data-[side=right]:inset-y-0 data-[side=right]:right-0 data-[side=right]:h-full data-[side=right]:w-3/4 data-[side=right]:border-l data-[side=top]:inset-x-0 data-[side=top]:top-0 data-[side=top]:h-auto data-[side=top]:border-b data-[side=left]:sm:max-w-sm data-[side=right]:sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-[side=bottom]:data-open:slide-in-from-bottom-10 data-[side=left]:data-open:slide-in-from-left-10 data-[side=right]:data-open:slide-in-from-right-10 data-[side=top]:data-open:slide-in-from-top-10 data-closed:animate-out data-closed:fade-out-0 data-[side=bottom]:data-closed:slide-out-to-bottom-10 data-[side=left]:data-closed:slide-out-to-left-10 data-[side=right]:data-closed:slide-out-to-right-10 data-[side=top]:data-closed:slide-out-to-top-10",
          e
        ),
        ...r,
        children: [
          t,
          n && /* @__PURE__ */ c(rt, { "data-slot": "sheet-close", asChild: !0, children: /* @__PURE__ */ Y(
            it,
            {
              variant: "ghost",
              className: "absolute top-3 right-3",
              size: "icon-sm",
              children: [
                /* @__PURE__ */ c(fd, {}),
                /* @__PURE__ */ c("span", { className: "sr-only", children: "Close" })
              ]
            }
          ) })
        ]
      }
    )
  ] });
}
function ly({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "sheet-header",
      className: E("flex flex-col gap-0.5 p-4", e),
      ...t
    }
  );
}
function cy({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "sheet-footer",
      className: E("mt-auto flex flex-col gap-2 p-4", e),
      ...t
    }
  );
}
function dy({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Jn,
    {
      "data-slot": "sheet-title",
      className: E("text-base font-medium text-foreground", e),
      ...t
    }
  );
}
function uy({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    er,
    {
      "data-slot": "sheet-description",
      className: E("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function fy({
  ...e
}) {
  return /* @__PURE__ */ c(ja, { "data-slot": "collapsible", ...e });
}
function py({
  ...e
}) {
  return /* @__PURE__ */ c(
    $n,
    {
      "data-slot": "collapsible-trigger",
      ...e
    }
  );
}
function my({
  ...e
}) {
  return /* @__PURE__ */ c(
    Bn,
    {
      "data-slot": "collapsible-content",
      ...e
    }
  );
}
function gy({
  // Override: default delay is 700ms; 0 gives instant tooltips app-wide
  delayDuration: e = 0,
  ...t
}) {
  return /* @__PURE__ */ c(
    Gb,
    {
      "data-slot": "tooltip-provider",
      delayDuration: e,
      ...t
    }
  );
}
function hy({
  ...e
}) {
  return /* @__PURE__ */ c(Wb, { "data-slot": "tooltip", ...e });
}
function vy({
  ...e
}) {
  return /* @__PURE__ */ c(Hb, { "data-slot": "tooltip-trigger", ...e });
}
function by({
  className: e,
  sideOffset: t = 0,
  children: o,
  ...n
}) {
  return /* @__PURE__ */ c(Ub, { children: /* @__PURE__ */ Y(
    Kb,
    {
      "data-slot": "tooltip-content",
      sideOffset: t,
      className: E(
        "z-50 inline-flex w-fit max-w-xs origin-(--radix-tooltip-content-transform-origin) items-center gap-1.5 rounded-md bg-foreground px-3 py-1.5 text-xs text-background has-data-[slot=kbd]:pr-1.5 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 **:data-[slot=kbd]:relative **:data-[slot=kbd]:isolate **:data-[slot=kbd]:z-50 **:data-[slot=kbd]:rounded-sm data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        e
      ),
      ...n,
      children: [
        o,
        /* @__PURE__ */ c(jb, { className: "z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px] bg-foreground fill-foreground" })
      ]
    }
  ) });
}
function wy({
  ...e
}) {
  return /* @__PURE__ */ c(Yn, { "data-slot": "dialog", ...e });
}
function xy({
  ...e
}) {
  return /* @__PURE__ */ c(Xn, { "data-slot": "dialog-trigger", ...e });
}
function Rw({
  ...e
}) {
  return /* @__PURE__ */ c(qn, { "data-slot": "dialog-portal", ...e });
}
function yy({
  ...e
}) {
  return /* @__PURE__ */ c(rt, { "data-slot": "dialog-close", ...e });
}
function Pw({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Zn,
    {
      "data-slot": "dialog-overlay",
      className: E(
        "fixed inset-0 isolate z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0",
        e
      ),
      ...t
    }
  );
}
function Cy({
  className: e,
  children: t,
  showCloseButton: o = !0,
  ...n
}) {
  return /* @__PURE__ */ Y(Rw, { children: [
    /* @__PURE__ */ c(Pw, {}),
    /* @__PURE__ */ Y(
      Qn,
      {
        "data-slot": "dialog-content",
        className: E(
          "fixed top-1/2 left-1/2 z-50 grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl bg-popover p-4 text-sm text-popover-foreground ring-1 ring-foreground/10 duration-100 outline-none sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
          e
        ),
        ...n,
        children: [
          t,
          o && /* @__PURE__ */ c(rt, { "data-slot": "dialog-close", asChild: !0, children: /* @__PURE__ */ Y(
            it,
            {
              variant: "ghost",
              className: "absolute top-2 right-2",
              size: "icon-sm",
              children: [
                /* @__PURE__ */ c(fd, {}),
                /* @__PURE__ */ c("span", { className: "sr-only", children: "Close" })
              ]
            }
          ) })
        ]
      }
    )
  ] });
}
function Sy({ className: e, ...t }) {
  return /* @__PURE__ */ c(
    "div",
    {
      "data-slot": "dialog-header",
      className: E("flex flex-col gap-2", e),
      ...t
    }
  );
}
function Ey({
  className: e,
  showCloseButton: t = !1,
  children: o,
  ...n
}) {
  return /* @__PURE__ */ Y(
    "div",
    {
      "data-slot": "dialog-footer",
      className: E(
        "-mx-4 -mb-4 flex flex-col-reverse gap-2 rounded-b-xl border-t bg-muted/50 p-4 sm:flex-row sm:justify-end",
        e
      ),
      ...n,
      children: [
        o,
        t && /* @__PURE__ */ c(rt, { asChild: !0, children: /* @__PURE__ */ c(it, { variant: "outline", children: "Close" }) })
      ]
    }
  );
}
function Ry({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Jn,
    {
      "data-slot": "dialog-title",
      className: E(
        "cn-font-heading text-base leading-none font-medium",
        e
      ),
      ...t
    }
  );
}
function Py({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    er,
    {
      "data-slot": "dialog-description",
      className: E(
        "text-sm text-muted-foreground *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground",
        e
      ),
      ...t
    }
  );
}
function Ay({
  ...e
}) {
  return /* @__PURE__ */ c(ph, { "data-slot": "dropdown-menu", ...e });
}
function _y({
  ...e
}) {
  return /* @__PURE__ */ c(Cl, { "data-slot": "dropdown-menu-portal", ...e });
}
function Ty({
  ...e
}) {
  return /* @__PURE__ */ c(
    mh,
    {
      "data-slot": "dropdown-menu-trigger",
      ...e
    }
  );
}
function Ny({
  className: e,
  align: t = "start",
  sideOffset: o = 4,
  ...n
}) {
  return /* @__PURE__ */ c(Cl, { children: /* @__PURE__ */ c(
    gh,
    {
      "data-slot": "dropdown-menu-content",
      sideOffset: o,
      align: t,
      className: E(
        "z-50 max-h-(--radix-dropdown-menu-content-available-height) w-(--radix-dropdown-menu-trigger-width) min-w-32 origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-lg bg-popover p-1 text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:overflow-hidden data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        e
      ),
      ...n
    }
  ) });
}
function ky({
  ...e
}) {
  return /* @__PURE__ */ c(hh, { "data-slot": "dropdown-menu-group", ...e });
}
function Iy({
  className: e,
  inset: t,
  variant: o = "default",
  ...n
}) {
  return /* @__PURE__ */ c(
    bh,
    {
      "data-slot": "dropdown-menu-item",
      "data-inset": t,
      "data-variant": o,
      className: E(
        "group/dropdown-menu-item relative flex cursor-default items-center gap-1.5 rounded-md px-1.5 py-1 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-inset:pl-7 data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 data-[variant=destructive]:*:[svg]:text-destructive",
        e
      ),
      ...n
    }
  );
}
function My({
  className: e,
  children: t,
  checked: o,
  inset: n,
  ...r
}) {
  return /* @__PURE__ */ Y(
    wh,
    {
      "data-slot": "dropdown-menu-checkbox-item",
      "data-inset": n,
      className: E(
        "relative flex cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground data-inset:pl-7 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      checked: o,
      ...r,
      children: [
        /* @__PURE__ */ c(
          "span",
          {
            className: "pointer-events-none absolute right-2 flex items-center justify-center",
            "data-slot": "dropdown-menu-checkbox-item-indicator",
            children: /* @__PURE__ */ c(Sl, { children: /* @__PURE__ */ c(Xo, {}) })
          }
        ),
        t
      ]
    }
  );
}
function Dy({
  ...e
}) {
  return /* @__PURE__ */ c(
    xh,
    {
      "data-slot": "dropdown-menu-radio-group",
      ...e
    }
  );
}
function Oy({
  className: e,
  children: t,
  inset: o,
  ...n
}) {
  return /* @__PURE__ */ Y(
    yh,
    {
      "data-slot": "dropdown-menu-radio-item",
      "data-inset": o,
      className: E(
        "relative flex cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground data-inset:pl-7 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ c(
          "span",
          {
            className: "pointer-events-none absolute right-2 flex items-center justify-center",
            "data-slot": "dropdown-menu-radio-item-indicator",
            children: /* @__PURE__ */ c(Sl, { children: /* @__PURE__ */ c(Xo, {}) })
          }
        ),
        t
      ]
    }
  );
}
function Ly({
  className: e,
  inset: t,
  ...o
}) {
  return /* @__PURE__ */ c(
    vh,
    {
      "data-slot": "dropdown-menu-label",
      "data-inset": t,
      className: E(
        "px-1.5 py-1 text-xs font-medium text-muted-foreground data-inset:pl-7",
        e
      ),
      ...o
    }
  );
}
function zy({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Ch,
    {
      "data-slot": "dropdown-menu-separator",
      className: E("-mx-1 my-1 h-px bg-border", e),
      ...t
    }
  );
}
function $y({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    "span",
    {
      "data-slot": "dropdown-menu-shortcut",
      className: E(
        "ml-auto text-xs tracking-widest text-muted-foreground group-focus/dropdown-menu-item:text-accent-foreground",
        e
      ),
      ...t
    }
  );
}
function Fy({
  ...e
}) {
  return /* @__PURE__ */ c(Sh, { "data-slot": "dropdown-menu-sub", ...e });
}
function By({
  className: e,
  inset: t,
  children: o,
  ...n
}) {
  return /* @__PURE__ */ Y(
    Eh,
    {
      "data-slot": "dropdown-menu-sub-trigger",
      "data-inset": t,
      className: E(
        "flex cursor-default items-center gap-1.5 rounded-md px-1.5 py-1 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-inset:pl-7 data-open:bg-accent data-open:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...n,
      children: [
        o,
        /* @__PURE__ */ c(dd, { className: "cn-rtl-flip ml-auto" })
      ]
    }
  );
}
function Vy({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ c(
    Rh,
    {
      "data-slot": "dropdown-menu-sub-content",
      className: E(
        "z-50 min-w-[96px] origin-(--radix-dropdown-menu-content-transform-origin) overflow-hidden rounded-lg bg-popover p-1 text-popover-foreground shadow-lg ring-1 ring-foreground/10 duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        e
      ),
      ...t
    }
  );
}
export {
  rx as Accordion,
  sx as AccordionContent,
  ax as AccordionItem,
  ix as AccordionTrigger,
  Gx as AlertDialog,
  qx as AlertDialogAction,
  Zx as AlertDialogCancel,
  Hx as AlertDialogContent,
  Xx as AlertDialogDescription,
  Kx as AlertDialogFooter,
  Ux as AlertDialogHeader,
  jx as AlertDialogMedia,
  Yx as AlertDialogTitle,
  Wx as AlertDialogTrigger,
  vx as Avatar,
  xx as AvatarBadge,
  wx as AvatarFallback,
  yx as AvatarGroup,
  Cx as AvatarGroupCount,
  bx as AvatarImage,
  Ex as Badge,
  it as Button,
  Bw as ButtonGroup,
  lx as Card,
  fx as CardAction,
  px as CardContent,
  ux as CardDescription,
  mx as CardFooter,
  cx as CardHeader,
  dx as CardTitle,
  Xw as Checkbox,
  fy as Collapsible,
  my as CollapsibleContent,
  py as CollapsibleTrigger,
  wy as Dialog,
  yy as DialogClose,
  Cy as DialogContent,
  Py as DialogDescription,
  Ey as DialogFooter,
  Sy as DialogHeader,
  Pw as DialogOverlay,
  Rw as DialogPortal,
  Ry as DialogTitle,
  xy as DialogTrigger,
  Ay as DropdownMenu,
  My as DropdownMenuCheckboxItem,
  Ny as DropdownMenuContent,
  ky as DropdownMenuGroup,
  Iy as DropdownMenuItem,
  Ly as DropdownMenuLabel,
  _y as DropdownMenuPortal,
  Dy as DropdownMenuRadioGroup,
  Oy as DropdownMenuRadioItem,
  zy as DropdownMenuSeparator,
  $y as DropdownMenuShortcut,
  Fy as DropdownMenuSub,
  Vy as DropdownMenuSubContent,
  By as DropdownMenuSubTrigger,
  Ty as DropdownMenuTrigger,
  Mw as Field,
  Dw as FieldContent,
  zw as FieldDescription,
  Fw as FieldError,
  Iw as FieldGroup,
  Ow as FieldLabel,
  kw as FieldLegend,
  $w as FieldSeparator,
  Nw as FieldSet,
  Lw as FieldTitle,
  gw as Input,
  Qw as InputGroup,
  Jw as InputGroupAddon,
  ex as InputGroupButton,
  ox as InputGroupInput,
  tx as InputGroupText,
  nx as InputGroupTextarea,
  Yb as Label,
  Lx as Pagination,
  zx as PaginationContent,
  Vx as PaginationEllipsis,
  $x as PaginationItem,
  gd as PaginationLink,
  Bx as PaginationNext,
  Fx as PaginationPrevious,
  Qx as Popover,
  ey as PopoverContent,
  ny as PopoverDescription,
  ty as PopoverHeader,
  oy as PopoverTitle,
  Jx as PopoverTrigger,
  Sx as Progress,
  gx as ScrollArea,
  ww as ScrollBar,
  Vw as Select,
  Uw as SelectContent,
  Gw as SelectGroup,
  jw as SelectItem,
  Kw as SelectLabel,
  mw as SelectScrollDownButton,
  pw as SelectScrollUpButton,
  Yw as SelectSeparator,
  Hw as SelectTrigger,
  Ww as SelectValue,
  Xb as Separator,
  ry as Sheet,
  iy as SheetClose,
  sy as SheetContent,
  uy as SheetDescription,
  cy as SheetFooter,
  ly as SheetHeader,
  dy as SheetTitle,
  ay as SheetTrigger,
  hx as Skeleton,
  Zw as Slider,
  qw as Switch,
  _x as Table,
  Nx as TableBody,
  Ox as TableCaption,
  Dx as TableCell,
  kx as TableFooter,
  Mx as TableHead,
  Tx as TableHeader,
  Ix as TableRow,
  hw as Textarea,
  Rx as Toggle,
  Px as ToggleGroup,
  Ax as ToggleGroupItem,
  hy as Tooltip,
  by as TooltipContent,
  gy as TooltipProvider,
  vy as TooltipTrigger,
  xw as badgeVariants,
  Zb as buttonVariants,
  E as cn,
  pd as toggleVariants
};
